import { Subject, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { trigger, state, style, animate, transition } from '@angular/animations';
import * as moment_ from 'moment';
import { MyDatePickerModule } from 'mydatepicker';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { __spread, __extends, __awaiter, __generator, __values, __assign } from 'tslib';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef, Injectable, NgZone, ViewChild, ViewContainerRef, ComponentFactoryResolver, Inject, Injector, NgModule, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AddressSuggestion = /** @class */ (function () {
    function AddressSuggestion(eRef, changeDetector) {
        this.eRef = eRef;
        this.changeDetector = changeDetector;
        this.suggestions = [];
        this.property = {};
        this.onUpdateAddress = new EventEmitter();
        this.showSuggestions = false;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    AddressSuggestion.prototype.toggleSuggestions = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        this.showSuggestions = !this.showSuggestions;
        if (!(/** @type {?} */ (this.changeDetector)).destroyed) {
            this.changeDetector.detectChanges();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddressSuggestion.prototype.onOutsideClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showSuggestions = false;
        }
    };
    /**
     * @param {?} e
     * @param {?} suggestion
     * @return {?}
     */
    AddressSuggestion.prototype.setLatLng = /**
     * @param {?} e
     * @param {?} suggestion
     * @return {?}
     */
    function (e, suggestion) {
        this.showSuggestions = false;
        if (!(/** @type {?} */ (this.changeDetector)).destroyed) {
            this.changeDetector.detectChanges();
        }
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        suggestion.propertyId = this.property._id;
        suggestion.property = this.property;
        if (!suggestion.addressComponents) {
            suggestion.addressComponents = {
                streetName: suggestion.formattedAddress
            };
        }
        if (suggestion.latitude &&
            suggestion.latitude !== 0 &&
            suggestion.longitude &&
            suggestion.longitude !== 0) {
            this.onUpdateAddress.emit(suggestion);
        }
    };
    AddressSuggestion.decorators = [
        { type: Component, args: [{
                    selector: 'am-address-suggestion',
                    template: "<div *ngIf=\"suggestions && suggestions.length\" class=\"apto-map--address-suggestion\">\n    <span class=\"apto-map--address-suggestion--title\">\n        <button\n            (click)=\"toggleSuggestions($event)\"\n            class=\"apto-map--btn apto-map--btn-link-dropdown apto-map--chevron--down\">\n            <i class=\"apto-map--icon-warning\"></i> &nbsp;&nbsp; REVIEW SUGGESTION</button>\n    </span>\n    <ul\n        *ngIf=\"showSuggestions\"\n        class=\"apto-map--dropdown apto-map--dropdown--borders apto-map--dropdown--hover\">\n        <li\n            *ngFor=\"let suggestion of suggestions\"\n            (click)=\"setLatLng($event, suggestion)\"\n            title=\"{{ suggestion.formattedAddress }}\">\n            {{ suggestion.formattedAddress }}\n        </li>\n    </ul>\n</div>",
                    host: {
                        '(document:click)': 'onOutsideClick($event)'
                    }
                }] }
    ];
    /** @nocollapse */
    AddressSuggestion.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    AddressSuggestion.propDecorators = {
        suggestions: [{ type: Input }],
        property: [{ type: Input }],
        onUpdateAddress: [{ type: Output }]
    };
    return AddressSuggestion;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment = moment_;
var QueryHistory = /** @class */ (function () {
    function QueryHistory() {
        this.onChange = new Subject();
        this.onSelectHistory = new Subject();
        this.storage = localStorage;
        this.maxItems = 500;
        this.uniqueKey = '';
        this.currentHistory = [];
    }
    /**
     * @param {?} key
     * @return {?}
     */
    QueryHistory.prototype.setUniqueKey = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.uniqueKey = "apto-mapping-" + key;
        this.currentHistory = JSON.parse(this.storage.getItem(this.uniqueKey) || '[]');
        this.currentHistory.map(function (history) {
            history.date = moment(history.date);
            return history;
        });
    };
    /**
     * @param {?} query
     * @return {?}
     */
    QueryHistory.prototype.create = /**
     * @param {?} query
     * @return {?}
     */
    function (query) {
        if (Object.keys(query).length) {
            /** @type {?} */
            var item = {
                date: moment(),
                query: query
            };
            this.currentHistory.unshift(item);
            if (this.currentHistory.length > this.maxItems) {
                this.currentHistory = this.currentHistory.slice(0, this.maxItems);
            }
            this.storage.setItem(this.uniqueKey, JSON.stringify(this.currentHistory));
            this.onChange.next(item);
        }
    };
    /**
     * @return {?}
     */
    QueryHistory.prototype.getHistory = /**
     * @return {?}
     */
    function () {
        return this.currentHistory;
    };
    QueryHistory.decorators = [
        { type: Injectable }
    ];
    return QueryHistory;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var BaseFilter = /** @class */ (function () {
    function BaseFilter() {
        this.onQueryChange = new EventEmitter();
    }
    BaseFilter.propDecorators = {
        label: [{ type: Input }],
        name: [{ type: Input }],
        onQueryChange: [{ type: Output }]
    };
    return BaseFilter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Logger = /** @class */ (function () {
    function Logger() {
        this.logger = console;
    }
    /**
     * @param {?} message
     * @return {?}
     */
    Logger.prototype.info = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.logger.info(message);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Logger.prototype.debug = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.logger.debug(message);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Logger.prototype.error = /**
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.logger.error(message);
    };
    /**
     * @param {?} message
     * @param {?} context
     * @return {?}
     */
    Logger.prototype.exception = /**
     * @param {?} message
     * @param {?} context
     * @return {?}
     */
    function (message, context) {
        if (typeof this.logger.exception === 'function') {
            this.logger.exception(message, context);
        }
        else {
            this.error(message);
        }
    };
    /**
     * @param {?} logger
     * @return {?}
     */
    Logger.prototype.setHandler = /**
     * @param {?} logger
     * @return {?}
     */
    function (logger) {
        this.logger = logger;
    };
    Logger.decorators = [
        { type: Injectable }
    ];
    return Logger;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$1 = moment_;
var DateRangeFilter = /** @class */ (function (_super) {
    __extends(DateRangeFilter, _super);
    function DateRangeFilter(formBuilder, elRef, logger) {
        var _this = _super.call(this) || this;
        _this.formBuilder = formBuilder;
        _this.elRef = elRef;
        _this.logger = logger;
        _this.startDatePlaceholder = '';
        _this.stopDatePlaceholder = '';
        _this.onClearCalendar = new EventEmitter();
        _this.onSelectStartDate = new EventEmitter();
        _this.onSelectStopDate = new EventEmitter();
        _this.startDateOptions = {};
        _this.stopDateOptions = { alignSelectorRight: true };
        _this.subscriptions = [];
        _this.form = _this.formBuilder.group({
            startDate: new FormControl(),
            stopDate: new FormControl()
        });
        return _this;
    }
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.form
            .get('startDate')
            .valueChanges.pipe(debounceTime(700))
            .subscribe(function (value) {
            _this.onQueryChange.emit();
        }, this.logger.error), this.form
            .get('stopDate')
            .valueChanges.pipe(debounceTime(700))
            .subscribe(function (value) {
            _this.onQueryChange.emit();
        }, this.logger.error));
    };
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        /** @type {?} */
        var isValid = this.validate();
        if (isValid && !this.isEmpty()) {
            query[this.name] = {};
            if (this.form.controls["startDate"].value) {
                query[this.name].startDate = {
                    value: this.form.controls["startDate"].value.date.format('MM/DD/YYYY'),
                    label: this.label + ":Start Date"
                };
            }
            if (this.form.controls["stopDate"].value) {
                query[this.name].stopDate = {
                    value: this.form.controls["stopDate"].value.date.format('MM/DD/YYYY'),
                    label: this.label + ":Stop Date"
                };
            }
        }
        return query;
    };
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        if (this.form.controls["startDate"].value &&
            this.form.controls["stopDate"].value &&
            this.form.controls["startDate"].value > this.form.controls["stopDate"].value) {
            return false;
        }
        return !this.form.controls["startDate"].errors && !this.form.controls["stopDate"].errors;
    };
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.onClearCalendar.emit(true);
    };
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return !this.form.controls["stopDate"].value && !this.form.controls["startDate"].value;
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    DateRangeFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        if (initialQuery && initialQuery[this.name]) {
            if (initialQuery[this.name].startDate) {
                this.form.patchValue({
                    startDate: {
                        date: moment$1(initialQuery[this.name].startDate.value, 'MM/DD/YYYY')
                    }
                }, { emitEvent: false });
                this.onSelectStartDate.emit(moment$1(initialQuery[this.name].startDate.value, 'MM/DD/YYYY').toDate());
            }
            if (initialQuery[this.name].stopDate) {
                this.form.patchValue({
                    stopDate: {
                        date: moment$1(initialQuery[this.name].stopDate.value, 'MM/DD/YYYY'),
                        emitEvent: false
                    }
                }, { emitEvent: false });
                this.onSelectStopDate.emit(moment$1(initialQuery[this.name].stopDate.value, 'MM/DD/YYYY').toDate());
            }
        }
    };
    /**
     * @return {?}
     */
    DateRangeFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.elRef;
    };
    DateRangeFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-date-range-filter',
                    template: "<div class=\"apto-map--filter apto-map--date-range-filter apto-map--date-range-filter--{{name}}\">\n    <label class=\"apto-map--form-label\">\n        {{ label }}\n    </label>\n\n    <div class=\"apto-map--date-range-filter--wrapper\">\n        <am-date-field class=\"apto-map--date-range-filter--field\"\n                    [form]=\"form\"\n                    field=\"startDate\"\n                    placeholder=\"Start\"\n                    [onClearCalendar]=\"onClearCalendar\"\n                    [options]=\"startDateOptions\"\n                    [onSelectDate]=\"onSelectStartDate\"></am-date-field>\n        <span>to</span>\n        <am-date-field class=\"apto-map--date-range-filter--field\"\n                    [form]=\"form\"\n                    field=\"stopDate\"\n                    placeholder=\"End\"\n                    [onClearCalendar]=\"onClearCalendar\"\n                    [options]=\"stopDateOptions\"\n                    [onSelectDate]=\"onSelectStopDate\"></am-date-field>\n    </div>\n\n    <div class=\"error\" *ngIf=\"form?.get('startDate').errors\">Start date must be in MM/DD/YYYY format.</div>\n    <div class=\"error\" *ngIf=\"form?.get('stopDate').errors\">End date must be in MM/DD/YYYY format.</div>\n    <div class=\"error\" *ngIf=\"form?.get('startDate').value && form?.get('stopDate').value && form?.get('startDate').value > form?.get('stopDate').value\">Start date must be before End date.</div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    DateRangeFilter.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: ElementRef },
        { type: Logger }
    ]; };
    DateRangeFilter.propDecorators = {
        startDatePlaceholder: [{ type: Input }],
        stopDatePlaceholder: [{ type: Input }]
    };
    return DateRangeFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SelectItem = /** @class */ (function () {
    function SelectItem() {
    }
    return SelectItem;
}());
var SelectFilter = /** @class */ (function (_super) {
    __extends(SelectFilter, _super);
    function SelectFilter(eRef, changeDetector) {
        var _this = _super.call(this) || this;
        _this.eRef = eRef;
        _this.changeDetector = changeDetector;
        _this.selectedOption = null;
        _this.showOptions = false;
        return _this;
    }
    /**
     * @return {?}
     */
    SelectFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.validate() && !this.isEmpty()) {
            query[this.name] = { label: this.label, value: this.selectedOption.value };
        }
        return query;
    };
    /**
     * @return {?}
     */
    SelectFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        return true;
    };
    /**
     * @return {?}
     */
    SelectFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.selectedOption = null;
    };
    /**
     * @return {?}
     */
    SelectFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return !this.selectedOption;
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    SelectFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        var _this = this;
        if (initialQuery && initialQuery[this.name]) {
            this.selectedOption = this.items.find(function (i) { return i.value === initialQuery[_this.name].value; });
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    SelectFilter.prototype.isSelected = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return item === this.selectedOption;
    };
    /**
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    SelectFilter.prototype.updateSelected = /**
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    function (item, event) {
        this.selectedOption = item;
        this.showOptions = false;
        this.onQueryChange.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectFilter.prototype.onOutsideClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showOptions = false;
            if (!(/** @type {?} */ (this.changeDetector)).destroyed) {
                this.changeDetector.detectChanges();
            }
        }
    };
    /**
     * @return {?}
     */
    SelectFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.eRef;
    };
    SelectFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-select-filter',
                    template: "<div class=\"apto-map--filter apto-map--select-filter apto-map--select-filter--{{name}}\">\n    <label class=\"apto-map--form-label\">{{ label }}</label>\n    <div class=\"apto-map--select-filter--wrapper\">\n        <div (click)=\"showOptions = !showOptions\"\n             class=\"apto-map--form-control apto-map--select-filter--show-options\">\n            <span\n                class=\"apto-map--placeholder\"\n                [ngClass]=\"{'apto-map--value': (selectedOption && selectedOption.label)}\">\n                {{ (selectedOption && selectedOption.label) || placeholder }}\n            </span>\n            <button type=\"button\"\n                    class=\"apto-map--btn apto-map--chevron--down\"\n                    title=\"open options\"></button>\n        </div>\n        <ul *ngIf=\"showOptions\"\n            class=\"apto-map--dropdown apto-map--dropdown--borders apto-map--dropdown--hover apto-map--select-filter--items\">\n            <li *ngFor=\"let item of items\"\n                class=\"apto-map--select-filter--item\">\n                <label class=\"apto-map--form-control--checkbox\">\n                    {{ item.label }}\n                    <input type=\"radio\"\n                           value=\"{{ item.value }}\"\n                           [checked]=\"isSelected(item)\"\n                           (change)=\"updateSelected(item, $event)\">\n                    <span class=\"apto-map--form-control--checkbox--check\"></span>\n                </label>\n            </li>\n        </ul>\n    </div>\n</div>",
                    host: {
                        '(document:click)': 'onOutsideClick($event)'
                    }
                }] }
    ];
    /** @nocollapse */
    SelectFilter.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    SelectFilter.propDecorators = {
        items: [{ type: Input }],
        placeholder: [{ type: Input }]
    };
    return SelectFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SearchFilter = /** @class */ (function (_super) {
    __extends(SearchFilter, _super);
    function SearchFilter(elRef, logger) {
        var _this = _super.call(this) || this;
        _this.elRef = elRef;
        _this.logger = logger;
        _this.showLoader = false;
        _this.showSearch = false;
        _this.split = null;
        _this.debounceTime = 500;
        _this.subscriptions = [];
        return _this;
    }
    /**
     * @return {?}
     */
    SearchFilter.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    SearchFilter.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.searchControl = new FormControl();
        this.subscriptions.push(this.searchControl.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe(function (search) {
            _this.onQueryChange.emit();
        }, this.logger.error));
    };
    /**
     * @return {?}
     */
    SearchFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.validate()) {
            /** @type {?} */
            var value = void 0;
            if (this.split !== null) {
                /** @type {?} */
                var values = this.searchControl.value.split(this.split);
                value = values.map(function (v) { return v.trim(); });
            }
            else {
                value = this.searchControl.value;
            }
            query[this.name] = { value: value, label: this.label };
        }
        return query;
    };
    /**
     * @return {?}
     */
    SearchFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        return this.searchControl.value;
    };
    /**
     * @return {?}
     */
    SearchFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.searchControl.setValue('', { emitEvent: true });
    };
    /**
     * @return {?}
     */
    SearchFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return !this.searchControl.value;
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    SearchFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        if (initialQuery && initialQuery[this.name]) {
            /** @type {?} */
            var value = initialQuery[this.name].value;
            if (this.split !== null && Array.isArray(value)) {
                this.searchControl.setValue(value.join(this.split), {
                    emitEvent: false
                });
            }
            else {
                this.searchControl.setValue(value, { emitEvent: false });
            }
        }
    };
    /**
     * @return {?}
     */
    SearchFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.elRef;
    };
    SearchFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-search-filter',
                    template: "<div class=\"apto-map--filter apto-map--search-filter apto-map--search-filter--{{name}}\">\n    <label class=\"apto-map--form-label\">{{ label }}</label>\n    <div class=\"apto-map--search-filter--wrapper\">\n        <button\n            *ngIf=\"!showLoader && showSearch\"\n            type=\"button\"\n            (click)=\"searchFilterInput.focus()\"\n            class=\"apto-map--btn apto-map--icon-search\"\n            data-automation=\"search-filter-search\"></button>\n        <am-spinner\n            *ngIf=\"showLoader\"\n            class=\"apto-map--spinner\"\n            data-automation=\"search-filter-spinner\"></am-spinner>\n        <input\n            class=\"apto-map--form-control\"\n            #searchFilterInput\n            type=\"text\"\n            [formControl]=\"searchControl\"\n            [placeholder]=\"placeholder\"\n            [ngClass]=\"{'apto-map--search-filter--no-padding' : showSearch === false}\">\n        <button\n            type=\"button\"\n            class=\"apto-map--btn apto-map--btn-close\"\n            *ngIf=\"searchControl.value\"\n            (click)=\"reset()\"\n            data-automation=\"search-filter-remove\"\n            title=\"clear\"></button>\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SearchFilter.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Logger }
    ]; };
    SearchFilter.propDecorators = {
        placeholder: [{ type: Input }],
        label: [{ type: Input }],
        showLoader: [{ type: Input }],
        showSearch: [{ type: Input }],
        split: [{ type: Input }]
    };
    return SearchFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var MapAPILoader = /** @class */ (function () {
    function MapAPILoader() {
    }
    MapAPILoader.decorators = [
        { type: Injectable }
    ];
    return MapAPILoader;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GoogleMapsAPIService = /** @class */ (function () {
    function GoogleMapsAPIService(loader, zone) {
        this.loader = loader;
        this.zone = zone;
        this.onMapLoad = new Subject();
    }
    /**
     * @param {?} el
     * @param {?} mapOptions
     * @return {?}
     */
    GoogleMapsAPIService.prototype.createMap = /**
     * @param {?} el
     * @param {?} mapOptions
     * @return {?}
     */
    function (el, mapOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loader.load()];
                    case 1:
                        _a.sent();
                        this.map = new google.maps.Map(el, mapOptions);
                        this.onMapLoad.next(this.map);
                        return [2 /*return*/, this.map];
                }
            });
        });
    };
    /**
     * @param {?} options
     * @return {?}
     */
    GoogleMapsAPIService.prototype.setMapOptions = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        this.map.setOptions(options);
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getMap = /**
     * @return {?}
     */
    function () {
        return this.map;
    };
    /**
     * @param {?=} options
     * @return {?}
     */
    GoogleMapsAPIService.prototype.createInfoWindow = /**
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        if (options === void 0) { options = /** @type {?} */ ({}); }
        return new google.maps.InfoWindow(options);
    };
    /**
     * @param {?=} options
     * @param {?=} addToMap
     * @return {?}
     */
    GoogleMapsAPIService.prototype.createMarker = /**
     * @param {?=} options
     * @param {?=} addToMap
     * @return {?}
     */
    function (options, addToMap) {
        if (options === void 0) { options = /** @type {?} */ ({}); }
        if (addToMap === void 0) { addToMap = true; }
        if (addToMap) {
            options.map = this.map;
        }
        return new google.maps.Marker(options);
    };
    /**
     * @param {?} eventName
     * @return {?}
     */
    GoogleMapsAPIService.prototype.triggerMapEvent = /**
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) {
        google.maps.event.trigger(this.map, eventName);
    };
    /**
     * @param {?} element
     * @param {?} eventName
     * @return {?}
     */
    GoogleMapsAPIService.prototype.triggerEvent = /**
     * @param {?} element
     * @param {?} eventName
     * @return {?}
     */
    function (element, eventName) {
        google.maps.event.trigger(element, eventName);
    };
    /**
     * @template E
     * @param {?} eventName
     * @return {?}
     */
    GoogleMapsAPIService.prototype.subscribeToMapEvent = /**
     * @template E
     * @param {?} eventName
     * @return {?}
     */
    function (eventName) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.map.addListener(eventName, function (arg) { _this.zone.run(function () { return observer.next(arg); }); });
        });
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getCenter = /**
     * @return {?}
     */
    function () {
        return this.map.getCenter();
    };
    /**
     * @param {?} latLng
     * @return {?}
     */
    GoogleMapsAPIService.prototype.setCenter = /**
     * @param {?} latLng
     * @return {?}
     */
    function (latLng) {
        this.map.setCenter(latLng);
    };
    /**
     * @param {?} latLng
     * @return {?}
     */
    GoogleMapsAPIService.prototype.panTo = /**
     * @param {?} latLng
     * @return {?}
     */
    function (latLng) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            google.maps.event.addListenerOnce(_this.map, 'idle', function () {
                resolve(latLng);
            });
            _this.map.panTo(latLng);
        });
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getZoom = /**
     * @return {?}
     */
    function () {
        return this.map.getZoom();
    };
    /**
     * @param {?} zoom
     * @return {?}
     */
    GoogleMapsAPIService.prototype.setZoom = /**
     * @param {?} zoom
     * @return {?}
     */
    function (zoom) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            google.maps.event.addListenerOnce(_this.map, 'idle', function () {
                resolve(zoom);
            });
            _this.map.setZoom(zoom);
        });
    };
    /**
     * @param {?} zoom
     * @param {?} latLng
     * @return {?}
     */
    GoogleMapsAPIService.prototype.zoomAndPan = /**
     * @param {?} zoom
     * @param {?} latLng
     * @return {?}
     */
    function (zoom, latLng) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setZoom(zoom)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.panTo(latLng)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getMapType = /**
     * @return {?}
     */
    function () {
        return this.map.getMapTypeId().toString();
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getHeading = /**
     * @return {?}
     */
    function () {
        return this.map.getHeading();
    };
    /**
     * @param {?} deg
     * @return {?}
     */
    GoogleMapsAPIService.prototype.setHeading = /**
     * @param {?} deg
     * @return {?}
     */
    function (deg) {
        return this.map.setHeading(deg);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    GoogleMapsAPIService.prototype.setMapType = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        this.map.setMapTypeId(this.getMapTypeIdFromString(type));
    };
    /**
     * @param {?} type
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getMapTypeIdFromString = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        switch (type) {
            case 'satellite':
                return google.maps.MapTypeId.SATELLITE;
            case 'hybrid':
                return google.maps.MapTypeId.HYBRID;
            case 'terrain':
                return google.maps.MapTypeId.TERRAIN;
            case 'roadmap':
            default:
                return google.maps.MapTypeId.ROADMAP;
        }
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getBounds = /**
     * @return {?}
     */
    function () {
        return this.map.getBounds();
    };
    /**
     * @param {?} angle
     * @return {?}
     */
    GoogleMapsAPIService.prototype.setTilt = /**
     * @param {?} angle
     * @return {?}
     */
    function (angle) {
        this.map.setTilt(angle);
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getTilt = /**
     * @return {?}
     */
    function () {
        return this.map.getTilt();
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.getBoundsAsWKT = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var bounds = this.getBounds();
        /** @type {?} */
        var ne = bounds.getNorthEast();
        /** @type {?} */
        var sw = bounds.getSouthWest();
        /** @type {?} */
        var precision = 100000;
        /** @type {?} */
        var pointsNe = {
            lat: Math.round(ne.lat() * precision) / precision,
            lng: Math.round(ne.lng() * precision) / precision
        };
        /** @type {?} */
        var pointsSe = {
            lat: Math.round(sw.lat() * precision) / precision,
            lng: Math.round(ne.lng() * precision) / precision
        };
        /** @type {?} */
        var pointsSw = {
            lat: Math.round(sw.lat() * precision) / precision,
            lng: Math.round(sw.lng() * precision) / precision
        };
        /** @type {?} */
        var pointsNw = {
            lat: Math.round(ne.lat() * precision) / precision,
            lng: Math.round(sw.lng() * precision) / precision
        };
        return "POLYGON(("
            + (pointsNw.lng + " " + pointsNw.lat + ",")
            + (pointsNe.lng + " " + pointsNe.lat + ",")
            + (pointsSe.lng + " " + pointsSe.lat + ",")
            + (pointsSw.lng + " " + pointsSw.lat + ",")
            + (pointsNw.lng + " " + pointsNw.lat)
            + "))";
    };
    /**
     * @param {?} latLng
     * @return {?}
     */
    GoogleMapsAPIService.prototype.fitBounds = /**
     * @param {?} latLng
     * @return {?}
     */
    function (latLng) {
        this.map.fitBounds(latLng);
    };
    /**
     * @return {?}
     */
    GoogleMapsAPIService.prototype.tilesLoaded = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return new Promise(function (resolve) {
            google.maps.event.addListenerOnce(_this.map, 'tilesloaded', function () {
                resolve(true);
            });
        });
    };
    GoogleMapsAPIService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    GoogleMapsAPIService.ctorParameters = function () { return [
        { type: MapAPILoader },
        { type: NgZone }
    ]; };
    return GoogleMapsAPIService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var markerId = 0;
/** @type {?} */
var HOVER_INTERVAL = 200;
var MarkerType = /** @class */ (function () {
    function MarkerType() {
    }
    MarkerType.PROPERTY = 'property';
    MarkerType.PLACE = 'place';
    MarkerType.GENERIC = 'generic';
    MarkerType.NEWS = 'news';
    return MarkerType;
}());
var MarkerClassName = /** @class */ (function () {
    function MarkerClassName() {
    }
    MarkerClassName.GENERIC = 'apto-map--marker';
    MarkerClassName.PLACE = 'apto-map--marker--place';
    MarkerClassName.ON_MARKET = 'apto-map--marker--on-market';
    MarkerClassName.ON_MARKET_INTERNAL = 'apto-map--marker--on-market-internal';
    MarkerClassName.OFF_MARKET = 'apto-map--marker--off-market';
    MarkerClassName.OFF_MARKET_INTERNAL = 'apto-map--marker--off-market-internal';
    MarkerClassName.NEWS = 'apto-map--marker--news';
    MarkerClassName.LEASE_DANGER = 'apto-map--marker--lease-danger';
    MarkerClassName.LEASE_WARNING = 'apto-map--marker--lease-warning';
    return MarkerClassName;
}());
var Marker = /** @class */ (function () {
    function Marker(type, latitude, longitude, id, iconClass) {
        this.type = MarkerType.GENERIC;
        this.visible = true;
        this.opacity = 1;
        this.hoverable = true;
        this.clickable = true;
        this.onClick = new EventEmitter();
        this.onHover = new EventEmitter();
        this.onMouseOut = new EventEmitter();
        this.addedToMap = false;
        this.nativeEventListeners = [];
        this.type = type;
        if (this.addedToMap) {
            return;
        }
        if (latitude) {
            this.latitude = Number(latitude);
        }
        if (longitude) {
            this.longitude = Number(longitude);
        }
        if (iconClass) {
            this.iconClass = iconClass;
        }
        this.id = id ? (type + id.toString()) : (type + (markerId++).toString());
    }
    /**
     * @param {?} m
     * @return {?}
     */
    Marker.prototype.setMapMarker = /**
     * @param {?} m
     * @return {?}
     */
    function (m) {
        var _this = this;
        if (!this.addedToMap) {
            this.addedToMap = true;
            this.nativeMarker = m;
            this.removeNativeEvents();
            if (this.clickable) {
                this.nativeEventListeners.push(this.nativeMarker.addListener('click', function () {
                    _this.onClick.emit(_this);
                }));
            }
            if (this.hoverable) {
                /** @type {?} */
                var timeoutId_1 = null;
                this.nativeEventListeners.push(this.nativeMarker.addListener('mouseover', function () {
                    if (timeoutId_1) {
                        clearTimeout(timeoutId_1);
                    }
                    timeoutId_1 = setTimeout(function () {
                        _this.onHover.emit(_this);
                    }, HOVER_INTERVAL);
                }));
                this.nativeEventListeners.push(this.nativeMarker.addListener('mouseout', function () {
                    if (timeoutId_1) {
                        clearTimeout(timeoutId_1);
                    }
                    _this.onMouseOut.emit(_this);
                }));
            }
        }
    };
    /**
     * @return {?}
     */
    Marker.prototype.hoverOn = /**
     * @return {?}
     */
    function () {
        this.nativeMarker.addMouseOverClass();
    };
    /**
     * @return {?}
     */
    Marker.prototype.hoverOff = /**
     * @return {?}
     */
    function () {
        this.nativeMarker.removeMouseOverClass();
    };
    /**
     * @return {?}
     */
    Marker.prototype.getId = /**
     * @return {?}
     */
    function () {
        return this.id.toString();
    };
    /**
     * @param {?} id
     * @return {?}
     */
    Marker.prototype.setId = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        this.id = id;
    };
    /**
     * @return {?}
     */
    Marker.prototype.getNativeMarker = /**
     * @return {?}
     */
    function () {
        return this.nativeMarker;
    };
    /**
     * @return {?}
     */
    Marker.prototype.removeNativeEvents = /**
     * @return {?}
     */
    function () {
        this.nativeEventListeners.forEach(function (e) {
            e.remove();
        });
        this.nativeEventListeners = [];
    };
    /**
     * @return {?}
     */
    Marker.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.removeNativeEvents();
        this.nativeMarker.setMap(null);
    };
    return Marker;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var MARKER_POSITION = {
    TOP_LEFT: 1,
    TOP: 2,
    TOP_RIGHT: 3,
    LEFT: 4,
    MIDDLE: 5,
    RIGHT: 6,
    BOTTOM_LEFT: 7,
    BOTTOM: 8,
    BOTTOM_RIGHT: 9
};
/** @type {?} */
var createCustomMarker = function (options) {
    if (options === void 0) { options = {}; }
    /** @type {?} */
    var customMarker = /** @class */ (function (_super) {
        __extends(CustomMarker, _super);
        function CustomMarker(opts) {
            if (opts === void 0) { opts = {}; }
            var _this = _super.call(this) || this;
            _this.ready = false;
            if (opts.visible === undefined) {
                opts.visible = true;
            }
            if (opts.anchor === undefined) {
                opts.anchor = MARKER_POSITION.MIDDLE;
            }
            _this.setValues(opts);
            return _this;
        }
        /**
         * @return {?}
         */
        CustomMarker.prototype.getVisible = /**
         * @return {?}
         */
        function () {
            return this.get('visible');
        };
        /**
         * @param {?} visible
         * @return {?}
         */
        CustomMarker.prototype.setVisible = /**
         * @param {?} visible
         * @return {?}
         */
        function (visible) {
            this.set('visible', visible);
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.visible_changed = /**
         * @return {?}
         */
        function () {
            if (this.marker) {
                this.marker.style.display = this.getVisible() ? 'block' : 'none';
            }
            this.draw();
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getWidth = /**
         * @return {?}
         */
        function () {
            return this.get('width');
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getHeight = /**
         * @return {?}
         */
        function () {
            return this.get('height');
        };
        /**
         * @param {?} index
         * @return {?}
         */
        CustomMarker.prototype.setZIndex = /**
         * @param {?} index
         * @return {?}
         */
        function (index) {
            this.set('zIndex', index);
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getZIndex = /**
         * @return {?}
         */
        function () {
            return this.get('zIndex');
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.zIndex_changed = /**
         * @return {?}
         */
        function () {
            if (this.getZIndex() && this.ready) {
                this.marker.style.zIndex = this.getZIndex();
            }
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getPosition = /**
         * @return {?}
         */
        function () {
            return this.get('position');
        };
        /**
         * @param {?} position
         * @return {?}
         */
        CustomMarker.prototype.setPosition = /**
         * @param {?} position
         * @return {?}
         */
        function (position) {
            this.set('position', position);
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.position_changed = /**
         * @return {?}
         */
        function () {
            this.draw();
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getAnchor = /**
         * @return {?}
         */
        function () {
            return this.get('anchor');
        };
        /**
         * @param {?} anchor
         * @return {?}
         */
        CustomMarker.prototype.setAnchor = /**
         * @param {?} anchor
         * @return {?}
         */
        function (anchor) {
            this.set('anchor', anchor);
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.anchor_changed = /**
         * @return {?}
         */
        function () {
            this.draw();
        };
        /**
         * @param {?} content
         * @return {?}
         */
        CustomMarker.prototype.setContent = /**
         * @param {?} content
         * @return {?}
         */
        function (content) {
            this.set('content', content);
        };
        /**
         * @param {?} icon
         * @return {?}
         */
        CustomMarker.prototype.setIcon = /**
         * @param {?} icon
         * @return {?}
         */
        function (icon) {
            if (this.marker) {
                this.marker.className = "apto-map--marker " + (icon || '');
            }
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getContent = /**
         * @return {?}
         */
        function () {
            return this.get('content');
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.isHovered = /**
         * @return {?}
         */
        function () {
            if (this.marker) {
                return this.marker.classList.contains('apto-map--marker-hover');
            }
            return false;
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.addMouseOverClass = /**
         * @return {?}
         */
        function () {
            if (this.marker && !this.isHovered()) {
                this.marker.classList.add('apto-map--marker-hover');
            }
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.removeMouseOverClass = /**
         * @return {?}
         */
        function () {
            if (this.marker && this.isHovered()) {
                this.marker.classList.remove('apto-map--marker-hover');
            }
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.content_changed = /**
         * @return {?}
         */
        function () {
            if (!this.marker) {
                return;
            }
            if (this.marker.firstChild) {
                this.marker.removeChild(this.marker.firstChild);
            }
            /** @type {?} */
            var content = this.getContent();
            if (content) {
                /** @type {?} */
                var d = document.createElement('div');
                d.className = 'apto-map--marker-content';
                d.innerHTML = content;
                this.marker.appendChild(d);
            }
            google.maps.event.trigger(this, 'domready');
            this.draw();
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.onAdd = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this.marker) {
                this.marker = document.createElement('div');
                this.setIcon(this.get('iconClass') || '');
                this.marker.style.position = 'absolute';
                this.marker.style.display = this.getVisible() ? 'block' : 'none';
                google.maps.event.addDomListener(this.marker, 'click', function (e) {
                    e.stopPropagation();
                    google.maps.event.trigger(_this, 'click');
                });
                google.maps.event.addDomListener(this.marker, 'mouseover', function (e) {
                    e.stopPropagation();
                    google.maps.event.trigger(_this, 'mouseover');
                });
                google.maps.event.addDomListener(this.marker, 'mouseout', function (e) {
                    e.stopPropagation();
                    google.maps.event.trigger(_this, 'mouseout');
                });
            }
            if (this.getZIndex()) {
                this.marker.style.zIndex = this.getZIndex();
            }
            this.ready = true;
            this.content_changed();
            /** @type {?} */
            var panes = this.getPanes();
            if (panes) {
                panes.overlayMouseTarget.appendChild(this.marker);
            }
            google.maps.event.trigger(this, 'ready');
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.draw = /**
         * @return {?}
         */
        function () {
            if (!this.ready) {
                return;
            }
            /** @type {?} */
            var projection = this.getProjection();
            if (!projection) {
                return;
            }
            /** @type {?} */
            var latLng = this.get('position');
            /** @type {?} */
            var pos = projection.fromLatLngToDivPixel(latLng);
            /** @type {?} */
            var offset = this.getOffset();
            this.marker.style.top = (pos.y + offset.height) + 'px';
            this.marker.style.left = (pos.x + offset.width) + 'px';
            /** @type {?} */
            var height = this.marker.offsetHeight;
            /** @type {?} */
            var width = this.marker.offsetWidth;
            if (width !== this.get('width')) {
                this.set('width', width);
            }
            if (height !== this.get('height')) {
                this.set('height', height);
            }
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.onRemove = /**
         * @return {?}
         */
        function () {
            if (this.marker && this.marker.parentNode) {
                this.marker.parentNode.removeChild(this.marker);
            }
        };
        /**
         * @return {?}
         */
        CustomMarker.prototype.getOffset = /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var anchor = this.getAnchor();
            if (typeof anchor === 'object') {
                return anchor;
            }
            /** @type {?} */
            var offset = new google.maps.Size(0, 0);
            if (!this.marker) {
                return offset;
            }
            /** @type {?} */
            var width = this.marker.offsetWidth;
            /** @type {?} */
            var height = this.marker.offsetHeight;
            switch (anchor) {
                case MARKER_POSITION.TOP_LEFT:
                    break;
                case MARKER_POSITION.TOP:
                    offset.width = -width / 2;
                    break;
                case MARKER_POSITION.TOP_RIGHT:
                    offset.width = -width;
                    break;
                case MARKER_POSITION.LEFT:
                    offset.height = -height / 2;
                    break;
                case MARKER_POSITION.MIDDLE:
                    offset.width = -width / 2;
                    offset.height = -height / 2;
                    break;
                case MARKER_POSITION.RIGHT:
                    offset.width = -width;
                    offset.height = -height / 2;
                    break;
                case MARKER_POSITION.BOTTOM_LEFT:
                    offset.height = -height;
                    break;
                case MARKER_POSITION.BOTTOM:
                    offset.width = -width / 2;
                    offset.height = -height;
                    break;
                case MARKER_POSITION.BOTTOM_RIGHT:
                    offset.width = -width;
                    offset.height = -height;
                    break;
            }
            return offset;
        };
        return CustomMarker;
    }(google.maps.OverlayView));
    return new customMarker(options);
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var EXCLUDE_TYPES_FROM_CLUSTERER = [
    MarkerType.PLACE,
    MarkerType.GENERIC,
    MarkerType.NEWS
];
var MarkerManager = /** @class */ (function () {
    function MarkerManager(mapsService, logger) {
        this.mapsService = mapsService;
        this.logger = logger;
        this.onMarkerClick = new EventEmitter();
        this.onMarkerHover = new EventEmitter();
        this.onMarkerMouseOut = new EventEmitter();
        this.markers = new Map();
    }
    /**
     * @param {?=} opts
     * @return {?}
     */
    MarkerManager.prototype.initClusterer = /**
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        if (typeof MarkerClusterer === 'function') {
            this.markerClusterer = new MarkerClusterer(this.mapsService.getMap(), [], opts);
        }
    };
    /**
     * @return {?}
     */
    MarkerManager.prototype.hideMarkers = /**
     * @return {?}
     */
    function () {
        this.getNativeMarkersForClusterer().forEach(function (m) {
            m.setVisible(false);
        });
        this.clearClusters();
    };
    /**
     * @return {?}
     */
    MarkerManager.prototype.showMarkers = /**
     * @return {?}
     */
    function () {
        this.getNativeMarkersForClusterer().forEach(function (m) {
            m.setVisible(true);
        });
        this.setClusters();
    };
    /**
     * @param {?} type
     * @return {?}
     */
    MarkerManager.prototype.deleteMarkersByType = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        /** @type {?} */
        var markersToDelete = [];
        this.markers.forEach(function (m) {
            if (m.type === type) {
                markersToDelete.push(m);
            }
        });
        this.deleteMarkers(markersToDelete);
    };
    /**
     * @param {?} markers
     * @return {?}
     */
    MarkerManager.prototype.deleteMarkers = /**
     * @param {?} markers
     * @return {?}
     */
    function (markers) {
        var _this = this;
        /** @type {?} */
        var native = [];
        markers.forEach(function (m) {
            /** @type {?} */
            var nativeMarker = m.getNativeMarker();
            if (nativeMarker) {
                native.push(m.getNativeMarker());
            }
            m.onClick.unsubscribe();
            m.onHover.unsubscribe();
            m.onMouseOut.unsubscribe();
            m.destroy();
            /** @type {?} */
            var markerId = m.getId();
            if (_this.markers.has(markerId)) {
                _this.markers.delete(markerId);
            }
        });
        // remove markers from clusterer
        if (native.length) {
            this.clearClusters();
        }
    };
    /**
     * @return {?}
     */
    MarkerManager.prototype.deleteAllMarkers = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var markers = [];
        this.markers.forEach(function (m) {
            markers.push(m);
        });
        this.deleteMarkers(markers);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    MarkerManager.prototype.hoverMarkerById = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var marker = this.markers.get(id);
        if (marker) {
            marker.hoverOn();
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    MarkerManager.prototype.removeHoverMarkerById = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var marker = this.markers.get(id);
        if (marker) {
            marker.hoverOff();
        }
    };
    /**
     * @param {?} markers
     * @return {?}
     */
    MarkerManager.prototype.addMarkers = /**
     * @param {?} markers
     * @return {?}
     */
    function (markers) {
        var _this = this;
        markers.forEach(function (m) {
            _this.addMarker(m, false);
        });
        // add markers to clusterer
        this.setClusters();
    };
    /**
     * @param {?} marker
     * @return {?}
     */
    MarkerManager.prototype.resolveClusteringLatLng = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        var e_1, _a, e_2, _b;
        if (!marker) {
            return null;
        }
        /** @type {?} */
        var markerId = marker.getId();
        /** @type {?} */
        var point = null;
        if (this.markerClusterer && this.markerClusterer.clusters_ && this.markerClusterer.clusters_.length) {
            try {
                for (var _c = __values(this.markerClusterer.clusters_), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var cluster = _d.value;
                    if (cluster.markers_ && cluster.markers_.length) {
                        try {
                            for (var _e = __values(cluster.markers_), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var m = _f.value;
                                if (m.markerId && m.markerId === markerId) {
                                    point = cluster.center_;
                                    break;
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    if (point) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return point;
    };
    /**
     * @param {?} marker
     * @param {?=} forceAddToClusterer
     * @return {?}
     */
    MarkerManager.prototype.addMarker = /**
     * @param {?} marker
     * @param {?=} forceAddToClusterer
     * @return {?}
     */
    function (marker, forceAddToClusterer) {
        var _this = this;
        if (forceAddToClusterer === void 0) { forceAddToClusterer = false; }
        /** @type {?} */
        var markerId = marker.getId();
        /** @type {?} */
        var existingMarker = this.markers.get(markerId);
        if (!existingMarker) {
            /** @type {?} */
            var mapMarker = createCustomMarker({
                map: this.mapsService.getMap(),
                position: new google.maps.LatLng(Number(marker.latitude), Number(marker.longitude)),
                visible: marker.visible,
                markerId: markerId,
                iconClass: marker.iconClass || null
            });
            marker.setMapMarker(mapMarker);
            if (marker.clickable) {
                marker.onClick.subscribe(function (m) {
                    _this.onMarkerClick.emit(m);
                }, this.logger.error);
            }
            if (marker.hoverable) {
                marker.onHover.subscribe(function (m) {
                    _this.onMarkerHover.emit(m);
                }, this.logger.error);
                marker.onMouseOut.subscribe(function (m) {
                    _this.onMarkerMouseOut.emit(m);
                }, this.logger.error);
            }
            this.markers.set(markerId, marker);
        }
        else if (existingMarker) {
            if (marker.data !== existingMarker.data) {
                existingMarker.data = marker.data;
            }
            if (marker.iconClass !== existingMarker.iconClass) {
                existingMarker.iconClass = marker.iconClass;
                existingMarker.getNativeMarker().setIcon(existingMarker.iconClass);
            }
        }
        marker = this.markers.get(markerId);
        // if force add to cluster
        if (forceAddToClusterer && this.markerClusterer && marker && !EXCLUDE_TYPES_FROM_CLUSTERER.includes(marker.type)) {
            this.markerClusterer.addMarker(marker.getNativeMarker());
        }
        return marker;
    };
    /**
     * @return {?}
     */
    MarkerManager.prototype.getNativeMarkersForClusterer = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var nativeMarkers = [];
        this.markers.forEach(function (m) {
            if (!EXCLUDE_TYPES_FROM_CLUSTERER.includes(m.type)) {
                nativeMarkers.push(m.getNativeMarker());
            }
        });
        return nativeMarkers;
    };
    /**
     * @return {?}
     */
    MarkerManager.prototype.clearClusters = /**
     * @return {?}
     */
    function () {
        if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
        }
    };
    /**
     * @return {?}
     */
    MarkerManager.prototype.setClusters = /**
     * @return {?}
     */
    function () {
        if (this.markerClusterer) {
            this.markerClusterer.addMarkers(this.getNativeMarkersForClusterer());
        }
    };
    MarkerManager.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MarkerManager.ctorParameters = function () { return [
        { type: GoogleMapsAPIService },
        { type: Logger }
    ]; };
    MarkerManager.propDecorators = {
        onMarkerClick: [{ type: Output }],
        onMarkerHover: [{ type: Output }],
        onMarkerMouseOut: [{ type: Output }]
    };
    return MarkerManager;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InfoWindow = /** @class */ (function () {
    function InfoWindow(resolver) {
        this.resolver = resolver;
        this.onBeforeOpen = new EventEmitter();
        this.onAfterOpen = new EventEmitter();
        this.onClose = new EventEmitter();
    }
    /**
     * @param {?} eventName
     * @param {?} success
     * @param {?} failure
     * @return {?}
     */
    InfoWindow.prototype.subscribe = /**
     * @param {?} eventName
     * @param {?} success
     * @param {?} failure
     * @return {?}
     */
    function (eventName, success, failure) {
        return this.content.instance[eventName].subscribe(function (e) {
            // stop event so it doesn't carry into the map dom
            try {
                e.stopPropagation();
            }
            catch (e) {
            }
            success(e);
        }, failure);
    };
    /**
     * @param {?} contentClass
     * @param {?} marker
     * @param {?=} alternateLatLng
     * @param {?=} offset
     * @return {?}
     */
    InfoWindow.prototype.show = /**
     * @param {?} contentClass
     * @param {?} marker
     * @param {?=} alternateLatLng
     * @param {?=} offset
     * @return {?}
     */
    function (contentClass, marker, alternateLatLng, offset) {
        var _this = this;
        if (alternateLatLng === void 0) { alternateLatLng = null; }
        if (offset === void 0) { offset = null; }
        if (!this.customInfoWindow) {
            return;
        }
        if (this.content && this.currentContentClass !== contentClass) {
            this.destroyContent();
        }
        this.currentContentClass = contentClass;
        // remove old content component
        if (!this.content) {
            /** @type {?} */
            var factory = this.resolver.resolveComponentFactory(contentClass);
            this.content = this.infoWindowContent.createComponent(factory);
        }
        // close to prevent weird rendering change
        if (this.content.instance.marker &&
            marker &&
            marker.getId() !== this.content.instance.marker.getId()) {
            this.customInfoWindow.close();
        }
        // update component data
        this.content.instance.init(marker);
        // manually detect change
        if (!(/** @type {?} */ (this.content.changeDetectorRef)).destroyed) {
            this.content.changeDetectorRef.detectChanges();
        }
        // before open emit event
        this.onBeforeOpen.emit();
        this.customInfoWindow.setEdgeOffset(offset);
        this.customInfoWindow.open(marker.getNativeMarker(), alternateLatLng || null);
        // after opened emit event
        // allows time for map to recenter if infowindow was not fully visible
        setTimeout(function () {
            _this.onAfterOpen.emit();
        }, 700);
    };
    /**
     * @return {?}
     */
    InfoWindow.prototype.close = /**
     * @return {?}
     */
    function () {
        if (this.customInfoWindow) {
            this.onClose.emit();
            this.customInfoWindow.close();
        }
    };
    /**
     * @return {?}
     */
    InfoWindow.prototype.destroyContent = /**
     * @return {?}
     */
    function () {
        if (this.content) {
            this.content.destroy();
            this.content = null;
        }
    };
    /**
     * @return {?}
     */
    InfoWindow.prototype.getContentInstance = /**
     * @return {?}
     */
    function () {
        return this.content ? this.content.instance : null;
    };
    /**
     * @return {?}
     */
    InfoWindow.prototype.destroy = /**
     * @return {?}
     */
    function () {
        // remove child component
        this.destroyContent();
        // remove custom window
        if (this.customInfoWindow) {
            this.customInfoWindow.destroy();
        }
    };
    /**
     * @return {?}
     */
    InfoWindow.prototype.detectContentChanges = /**
     * @return {?}
     */
    function () {
        if (this.content) {
            if (!(/** @type {?} */ (this.content.changeDetectorRef)).destroyed) {
                this.content.changeDetectorRef.detectChanges();
            }
        }
    };
    /**
     * @param {?} iw
     * @return {?}
     */
    InfoWindow.prototype.initialize = /**
     * @param {?} iw
     * @return {?}
     */
    function (iw) {
        this.customInfoWindow = iw;
    };
    /**
     * @return {?}
     */
    InfoWindow.prototype.getCurrentContentName = /**
     * @return {?}
     */
    function () {
        return this.currentContentClass && this.currentContentClass.name;
    };
    InfoWindow.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--info-window apto-map--info-window-arrow\" #infoWindowComponent>\n    <div class=\"apto-map--info-window-content\">\n        <div>\n            <ng-template #infoWindowContent></ng-template>\n        </div>\n    </div>\n</div>",
                    selector: 'am-info-window'
                }] }
    ];
    /** @nocollapse */
    InfoWindow.ctorParameters = function () { return [
        { type: ComponentFactoryResolver }
    ]; };
    InfoWindow.propDecorators = {
        infoWindowComponent: [{ type: ViewChild, args: ['infoWindowComponent',] }],
        infoWindowContent: [{ type: ViewChild, args: ['infoWindowContent', { read: ViewContainerRef },] }],
        onBeforeOpen: [{ type: Output }],
        onAfterOpen: [{ type: Output }],
        onClose: [{ type: Output }]
    };
    return InfoWindow;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InfoWindowPosition = /** @class */ (function () {
    function InfoWindowPosition() {
    }
    InfoWindowPosition.LEFT = 'left';
    InfoWindowPosition.RIGHT = 'right';
    return InfoWindowPosition;
}());
/** @type {?} */
var createCustomInfoWindow = function (mapEl, options) {
    if (options === void 0) { options = {}; }
    /** @type {?} */
    var edgeOffset = {
        x: 32,
        y: 0
    };
    /** @type {?} */
    var location = InfoWindowPosition.RIGHT;
    /** @type {?} */
    var defaultOptions = {
        closeOnMapClick: true,
        // clicking map closes info window
        panOnOpen: true,
        location: location,
        edgeOffset: edgeOffset // allows for adjusting the info window offset relative to marker
    };
    /** @type {?} */
    var customInfoWindow = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(map, opts) {
            if (opts === void 0) { opts = {}; }
            var _this = _super.call(this) || this;
            _this.container = null;
            _this.listeners = [];
            _this.isOpen = false;
            _this.opts = {};
            _this.addedToMap = false;
            _this.opts = __assign({}, defaultOptions, opts);
            _this.defaultOffset = _this.opts.edgeOffset;
            _this.container = document.createElement('div');
            _this.container.className = 'apto-map--info-window-map-container';
            _this.container.style.position = 'absolute';
            _this.container.style.visibility = 'hidden';
            _this.map = map;
            _this.setMap(_this.map);
            return _this;
        }
        /**
         * @param {?} offset
         * @return {?}
         */
        class_1.prototype.setEdgeOffset = /**
         * @param {?} offset
         * @return {?}
         */
        function (offset) {
            if (offset) {
                this.opts.edgeOffset = offset;
            }
            else {
                this.opts.edgeOffset = this.defaultOffset;
            }
        };
        /**
         * @param {?} latLng
         * @return {?}
         */
        class_1.prototype.setPosition = /**
         * @param {?} latLng
         * @return {?}
         */
        function (latLng) {
            this.position = latLng;
            this.draw();
            this.reposition();
        };
        /**
         * @param {?} marker
         * @param {?=} customPostion
         * @return {?}
         */
        class_1.prototype.open = /**
         * @param {?} marker
         * @param {?=} customPostion
         * @return {?}
         */
        function (marker, customPostion) {
            var _this = this;
            if (customPostion === void 0) { customPostion = null; }
            this.position = customPostion || marker.getPosition();
            this.clearListeners();
            if (this.getMap() && this.opts.closeOnMapClick) {
                this.trackListener(google.maps.event.addListener(this.getMap(), 'click', function () {
                    _this.close();
                }), false);
            }
            this.isOpen = true;
            this.draw();
            this.reposition();
        };
        /**
         * @return {?}
         */
        class_1.prototype.close = /**
         * @return {?}
         */
        function () {
            this.clearListeners();
            this.isOpen = false;
            this.setVisibility(this.isOpen);
        };
        /**
         * @return {?}
         */
        class_1.prototype.draw = /**
         * @return {?}
         */
        function () {
            if (!this.addedToMap || !this.getMap() || !this.position) {
                return;
            }
            /** @type {?} */
            var divPixel = this.getProjection().fromLatLngToDivPixel(this.position);
            /** @type {?} */
            var width = this.container.offsetWidth;
            /** @type {?} */
            var height = this.container.offsetHeight;
            // align in bottom of marker if on left/right
            if (this.opts.location === 'left' || this.opts.location === 'right') {
                height = height / 2;
            }
            // shift alignment based on edgeOffset option
            if (this.opts.edgeOffset) {
                if (this.opts.edgeOffset.y) {
                    height = height + this.opts.edgeOffset.y;
                }
                if (this.opts.edgeOffset.x) {
                    width = width + this.opts.edgeOffset.x;
                }
            }
            if (divPixel) {
                this.container.style.top = Math.floor(divPixel.y) - Math.floor(height) + "px";
                this.container.style.left = Math.floor(divPixel.x) - Math.floor(width) + "px";
            }
            this.setVisibility(this.isOpen);
        };
        /**
         * @return {?}
         */
        class_1.prototype.reposition = /**
         * @return {?}
         */
        function () {
            if (!this.addedToMap || !this.opts.panOnOpen || !this.container || !this.isOpen) {
                return;
            }
            /** @type {?} */
            var mib = this.getMapInnerBounds();
            /** @type {?} */
            var wb = this.container.getBoundingClientRect();
            /** @type {?} */
            var dx = 0;
            /** @type {?} */
            var dy = 0;
            if (mib.left >= wb.left) {
                dx = wb.left - mib.left;
            }
            else if (mib.right <= wb.right) {
                dx = wb.left - (mib.right - wb.width);
            }
            if (mib.top >= wb.top) {
                dy = wb.top - mib.top;
            }
            else if (mib.bottom <= wb.bottom) {
                dy = wb.top - (mib.bottom - wb.height);
            }
            if (dx !== 0 || dy !== 0) {
                this.getGoogleMap().panBy(dx, dy);
            }
        };
        /**
         * @return {?}
         */
        class_1.prototype.onAdd = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this.addedToMap) {
                /** @type {?} */
                var panes = this.getPanes();
                if (panes) {
                    panes.floatPane.appendChild(this.container);
                    /** @type {?} */
                    var mouseEvents = [
                        'click', 'dblclick', 'mouseup', 'mousedown'
                    ];
                    mouseEvents.forEach(function (event) {
                        _this.trackListener(google.maps.event.addDomListener(_this.container, event, function (e) {
                            e.cancelBubble = true;
                            if (e.stopPropagation) {
                                e.stopPropagation();
                            }
                        }), true);
                    });
                    // google cursor bug
                    this.trackListener(google.maps.event.addDomListener(this.container, 'mouseover', function (e) {
                        _this.container.style.cursor = 'default';
                    }), true);
                    this.addedToMap = true;
                }
            }
        };
        /**
         * @return {?}
         */
        class_1.prototype.destroy = /**
         * @return {?}
         */
        function () {
            if (this.getMap()) {
                this.setMap(null);
            }
        };
        /**
         * @return {?}
         */
        class_1.prototype.onRemove = /**
         * @return {?}
         */
        function () {
            if (this.container) {
                this.container.parentNode.removeChild(this.container);
            }
            this.clearListeners(true);
            this.setMap(null);
        };
        /**
         * @return {?}
         */
        class_1.prototype.getMapInnerBounds = /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var mb = this.getGoogleMap().getDiv().getBoundingClientRect();
            /** @type {?} */
            var mib = {
                top: mb.top + (this.opts.edgeOffset ? this.opts.edgeOffset.y : 0),
                right: mb.right + (this.opts.edgeOffset ? this.opts.edgeOffset.x : 0),
                bottom: mb.bottom,
                left: mb.left
            };
            mib.width = mib.right - mib.left;
            mib.height = mib.bottom - mib.top;
            return mib;
        };
        /**
         * @param {?} listener
         * @param {?=} persistent
         * @return {?}
         */
        class_1.prototype.trackListener = /**
         * @param {?} listener
         * @param {?=} persistent
         * @return {?}
         */
        function (listener, persistent) {
            if (persistent === void 0) { persistent = false; }
            this.listeners.push({
                listener: listener, persistent: persistent
            });
        };
        /**
         * @return {?}
         */
        class_1.prototype.getGoogleMap = /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var map = this.getMap();
            return map;
        };
        /**
         * @param {?=} show
         * @return {?}
         */
        class_1.prototype.setVisibility = /**
         * @param {?=} show
         * @return {?}
         */
        function (show) {
            if (show === void 0) { show = true; }
            if (this.container) {
                this.container.style.visibility = show ? 'visible' : 'hidden';
            }
        };
        /**
         * @param {?=} clearPersistent
         * @return {?}
         */
        class_1.prototype.clearListeners = /**
         * @param {?=} clearPersistent
         * @return {?}
         */
        function (clearPersistent) {
            if (clearPersistent === void 0) { clearPersistent = false; }
            if (google) {
                if (this.listeners) {
                    this.listeners.forEach(function (e) {
                        if (clearPersistent || !e.persistent) {
                            google.maps.event.removeListener(e.listener);
                            e.listener = null;
                        }
                    });
                    this.listeners = this.listeners.filter(function (e) {
                        return e.listener != null;
                    });
                }
            }
        };
        return class_1;
    }(google.maps.OverlayView));
    return new customInfoWindow(mapEl, options);
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FilterPanel = /** @class */ (function () {
    function FilterPanel(logger) {
        var _this = this;
        this.logger = logger;
        this.onQueryChange = new EventEmitter();
        this.onValidation = new EventEmitter();
        this.showMore = false;
        this.filters = [];
        this.lastQuery = '{}';
        this.subscriptions = [];
        this.isValid = function () {
            /** @type {?} */
            var invalidFilters = _this.filters.filter(function (f) { return !f.isEmpty() && !f.validate(); });
            /** @type {?} */
            var isValid = !(invalidFilters.length > 0);
            _this.onValidation.emit(isValid);
            return isValid;
        };
        this.getValidHiddenFiltersCount = function () {
            /** @type {?} */
            var validFilters = _this.filters.filter(function (f) {
                // an element is considered hidden if it doesn't have offsetHeight
                return !f.isEmpty() && f.validate() && f.getElement().nativeElement.offsetHeight === 0;
            });
            return validFilters.length;
        };
        this.isEmpty = function () {
            /** @type {?} */
            var nonEmptyFilters = _this.filters.filter(function (f) { return !f.isEmpty(); });
            return !(nonEmptyFilters.length > 0);
        };
    }
    /**
     * @return {?}
     */
    FilterPanel.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @param {?} filterInstances
     * @return {?}
     */
    FilterPanel.prototype.addMultiple = /**
     * @param {?} filterInstances
     * @return {?}
     */
    function (filterInstances) {
        var _this = this;
        filterInstances.forEach(function (filter) {
            _this.add(filter);
        });
    };
    /**
     * @param {?} filterInstance
     * @return {?}
     */
    FilterPanel.prototype.add = /**
     * @param {?} filterInstance
     * @return {?}
     */
    function (filterInstance) {
        this.filters.push(filterInstance);
        this.subscriptions.push(filterInstance.onQueryChange.subscribe(this.applyFilters.bind(this), this.logger.error));
    };
    /**
     * @return {?}
     */
    FilterPanel.prototype.applyFilters = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = this.getCurrentQuery();
        if (this.didQueryChange(query)) {
            this.lastQuery = JSON.stringify(query);
            this.onQueryChange.emit(query);
        }
    };
    /**
     * @return {?}
     */
    FilterPanel.prototype.getCurrentQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.isValid()) {
            this.filters.forEach(function (filter) {
                if (!filter.isEmpty()) {
                    Object.assign(query, filter.getQuery());
                }
            });
        }
        return query;
    };
    /**
     * @return {?}
     */
    FilterPanel.prototype.resetFilters = /**
     * @return {?}
     */
    function () {
        this.filters.forEach(function (filter) { return filter.reset(); });
        this.lastQuery = '{}';
        //MyDatepicker issue fix (hook focus after clearing).
        setTimeout(function () {
            if (document.activeElement instanceof HTMLInputElement) {
                (/** @type {?} */ (document.activeElement)).blur();
            }
        }, 120);
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    FilterPanel.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        this.filters.forEach(function (filter) { return filter.setInitialQuery(initialQuery); });
    };
    /**
     * @param {?} newQuery
     * @return {?}
     */
    FilterPanel.prototype.didQueryChange = /**
     * @param {?} newQuery
     * @return {?}
     */
    function (newQuery) {
        return JSON.stringify(newQuery) !== this.lastQuery;
    };
    FilterPanel.decorators = [
        { type: Component, args: [{
                    selector: 'am-filter-panel',
                    template: "<div class=\"apto-map--filter-panel\">\n    <div class=\"apto-map--filter-panel--fields\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    FilterPanel.ctorParameters = function () { return [
        { type: Logger }
    ]; };
    FilterPanel.propDecorators = {
        onQueryChange: [{ type: Output }],
        onValidation: [{ type: Output }]
    };
    return FilterPanel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MultiSelectFilter = /** @class */ (function (_super) {
    __extends(MultiSelectFilter, _super);
    function MultiSelectFilter(eRef) {
        var _this = _super.call(this) || this;
        _this.eRef = eRef;
        _this.items = [];
        _this.selectedOptions = [];
        _this.showOptions = false;
        _this.selectAll = false;
        return _this;
    }
    /**
     * @return {?}
     */
    MultiSelectFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.validate() && !this.isEmpty()) {
            query[this.name] = { value: this.selectedOptions, label: this.label };
        }
        return query;
    };
    /**
     * @return {?}
     */
    MultiSelectFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        return true;
    };
    /**
     * @return {?}
     */
    MultiSelectFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.selectedOptions = [];
    };
    /**
     * @return {?}
     */
    MultiSelectFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return !this.selectedOptions.length;
    };
    /**
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    MultiSelectFilter.prototype.updateSelected = /**
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    function (item, event) {
        /** @type {?} */
        var itemIdx = this.selectedOptions.findIndex(function (i) {
            return i.value === item.value;
        });
        if (itemIdx !== -1) {
            this.selectedOptions.splice(itemIdx, 1);
        }
        else {
            this.selectedOptions.push(item);
        }
        this.selectAll = this.selectedOptions.length === this.items.length;
        this.onQueryChange.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectFilter.prototype.toggleSelectAll = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.selectAll) {
            this.selectAll = false;
            this.selectedOptions = [];
        }
        else {
            this.selectAll = true;
            this.selectedOptions = this.items.slice(0);
        }
        this.onQueryChange.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MultiSelectFilter.prototype.onOutsideClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showOptions = false;
        }
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    MultiSelectFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        if (initialQuery && initialQuery[this.name]) {
            this.selectedOptions = initialQuery[this.name].value;
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    MultiSelectFilter.prototype.isSelected = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return !!this.selectedOptions.find(function (option) {
            return item.value === option.value;
        });
    };
    /**
     * @return {?}
     */
    MultiSelectFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.eRef;
    };
    MultiSelectFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-multi-select-filter',
                    template: "<div class=\"apto-map--filter apto-map--multi-select-filter apto-map--multi-select-filter--{{name}}\">\n    <label class=\"apto-map--form-label\">\n        {{ label }}\n        <span *ngIf=\"selectedOptions.length\" class=\"apto-map--form-badge\">{{ selectedOptions.length }}</span>\n    </label>\n    <div class=\"apto-map--multi-select-filter--field-wrapper\">\n        <div\n            (click)=\"showOptions = !showOptions\"\n            class=\"apto-map--form-control apto-map--multi-select-filter--show-options\">\n            <span *ngIf=\"selectedOptions.length\" class=\"apto-map--value apto-map--multi-select-filter--selected-items\">\n                <ng-container *ngFor=\"let item of selectedOptions; let last = last\">\n                    {{ item.label }}{{ last ? '' : ', ' }}\n                </ng-container>\n            </span>\n            <span *ngIf=\"!selectedOptions.length\" class=\"apto-map--placeholder\">\n                {{ dropdownLabel }}\n            </span>\n            <button type=\"button\" class=\"apto-map--btn apto-map--chevron--down\" title=\"open options\"></button>\n        </div>\n        <ul *ngIf=\"showOptions && items && items.length\" class=\"apto-map--dropdown apto-map--dropdown--borders apto-map--dropdown--hover apto-map--multi-select-filter--items\">\n            <li>\n                <label class=\"apto-map--form-control--checkbox apto-map--form-control--checkbox--muted\">\n                    Select {{ selectedOptions.length === items.length ? 'None' : 'All' }}\n                    <input type=\"checkbox\"\n                        class=\"apto-map--multi-select-filter--select-all\"\n                        [(value)]=\"selectAll\"\n                        [checked]=\"selectedOptions.length === items.length\"\n                        (click)=\"toggleSelectAll($event)\">\n                    <span class=\"apto-map--form-control--checkbox--check\"></span>\n                </label>\n            </li>\n            <li *ngFor=\"let item of items\" class=\"apto-map--multi-select-filter--item\">\n                <label class=\"apto-map--form-control--checkbox\">\n                    {{ item.label }}\n                    <input type=\"checkbox\"\n                        value=\"{{ item.value }}\"\n                        [checked]=\"isSelected(item)\"\n                        (change)=\"updateSelected(item, $event)\">\n                    <span class=\"apto-map--form-control--checkbox--check\"></span>\n                </label>\n            </li>\n        </ul>\n    </div>\n</div>",
                    host: {
                        '(document:click)': 'onOutsideClick($event)'
                    }
                }] }
    ];
    /** @nocollapse */
    MultiSelectFilter.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    MultiSelectFilter.propDecorators = {
        dropdownLabel: [{ type: Input }],
        items: [{ type: Input }]
    };
    return MultiSelectFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var RangeFilter = /** @class */ (function (_super) {
    __extends(RangeFilter, _super);
    function RangeFilter(elRef, logger) {
        var _this = _super.call(this) || this;
        _this.elRef = elRef;
        _this.logger = logger;
        _this.placeholderMin = 'No min';
        _this.placeholderMax = 'No max';
        _this.validateRe = /[^0-9.]/g;
        _this.debounceTime = 500;
        _this.subscriptions = [];
        return _this;
    }
    /**
     * @return {?}
     */
    RangeFilter.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.searchControlMin = new FormControl();
        this.searchControlMax = new FormControl();
        this.subscriptions.push(this.searchControlMin.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe(function (search) {
            /** @type {?} */
            var oldV = _this.searchControlMin.value;
            /** @type {?} */
            var formattedV = _this.formatInput(oldV);
            if (oldV !== formattedV) {
                _this.searchControlMin.setValue(formattedV, {
                    emitEvent: false
                });
            }
            _this.onQueryChange.emit();
        }, this.logger.error), this.searchControlMax.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe(function (search) {
            /** @type {?} */
            var oldV = _this.searchControlMax.value;
            /** @type {?} */
            var formattedV = _this.formatInput(oldV);
            if (oldV !== formattedV) {
                _this.searchControlMax.setValue(formattedV, {
                    emitEvent: false
                });
            }
            _this.onQueryChange.emit();
        }, this.logger.error));
    };
    /**
     * @return {?}
     */
    RangeFilter.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    RangeFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.validate()) {
            query[this.name] = {
                min: { value: this.searchControlMin.value ? this.searchControlMin.value : null, label: this.label + ":min" },
                max: { value: this.searchControlMax.value ? this.searchControlMax.value : null, label: this.label + ":max" }
            };
        }
        return query;
    };
    /**
     * @return {?}
     */
    RangeFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        return this.searchControlMin.value || this.searchControlMax.value;
    };
    /**
     * @return {?}
     */
    RangeFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.searchControlMin.setValue('', { emitEvent: false });
        this.searchControlMax.setValue('', { emitEvent: false });
    };
    /**
     * @return {?}
     */
    RangeFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return !this.searchControlMin.value && !this.searchControlMax.value;
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    RangeFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        if (initialQuery && initialQuery[this.name]) {
            /** @type {?} */
            var min = initialQuery[this.name].min ? initialQuery[this.name].min.value : '';
            /** @type {?} */
            var max = initialQuery[this.name].max ? initialQuery[this.name].max.value : '';
            this.searchControlMin.setValue(min, { emitEvent: false });
            this.searchControlMax.setValue(max, { emitEvent: false });
        }
    };
    /**
     * @return {?}
     */
    RangeFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.elRef;
    };
    /**
     * @param {?} v
     * @return {?}
     */
    RangeFilter.prototype.formatInput = /**
     * @param {?} v
     * @return {?}
     */
    function (v) {
        return v.replace(this.validateRe, '');
    };
    RangeFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-range-filter',
                    template: "<div class=\"apto-map--filter apto-map--range-filter apto-map--range-filter--{{name}}\">\n    <label class=\"apto-map--form-label\">{{ label }}</label>\n    <div class=\"apto-map--range-filter--wrapper\">\n        <input\n            class=\"apto-map--form-control\"\n            type=\"text\"\n            [formControl]=\"searchControlMin\"\n            [placeholder]=\"placeholderMin\">\n        <span>to</span>\n        <input\n            class=\"apto-map--form-control\"\n            type=\"text\"\n            [formControl]=\"searchControlMax\"\n            [placeholder]=\"placeholderMax\">\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    RangeFilter.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Logger }
    ]; };
    RangeFilter.propDecorators = {
        placeholderMin: [{ type: Input }],
        placeholderMax: [{ type: Input }],
        label: [{ type: Input }],
        validateRe: [{ type: Input }]
    };
    return RangeFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var PRECISION = 100000;
/** @type {?} */
var parseWKT = function (wkt) {
    var e_1, _a;
    /** @type {?} */
    var points = [];
    /** @type {?} */
    var parts = wkt.match(/\([^\(\)]+\)/g);
    if (parts !== null) {
        try {
            for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                var p = parts_1_1.value;
                /** @type {?} */
                var tmp = p.match(/-?\d+\.?\d*/g);
                if (tmp !== null) {
                    for (var j = 0; j < tmp.length; j += 2) {
                        points.push({
                            lat: Number(tmp[j + 1]),
                            lng: Number(tmp[j])
                        });
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    if (points.length > 2) {
        if (points[0].lat === points[points.length - 1].lat && points[0].lng === points[points.length - 1].lng) {
            points.pop();
        }
    }
    return points;
};
/** @type {?} */
var getWKTFromMVCArray = function (paths) {
    /** @type {?} */
    var points = [];
    paths.forEach(function (p) {
        /** @type {?} */
        var lat = Math.round(p.lat() * PRECISION) / PRECISION;
        /** @type {?} */
        var lng = Math.round(p.lng() * PRECISION) / PRECISION;
        points.push(lng + " " + lat);
    });
    if (points.length > 2) {
        if (points[0] !== points[points.length - 1]) {
            points.push(points[0]);
        }
        return "POLYGON((" + points.join(',') + "))";
    }
    return null;
};
/** @type {?} */
var getWKTFromLatLngLiteraltArray = function (paths) {
    /** @type {?} */
    var points = [];
    paths.forEach(function (p) {
        /** @type {?} */
        var lat = Math.round(p.lat * PRECISION) / PRECISION;
        /** @type {?} */
        var lng = Math.round(p.lng * PRECISION) / PRECISION;
        points.push(lng + " " + lat);
    });
    if (points.length > 2) {
        if (points[0] !== points[points.length - 1]) {
            points.push(points[0]);
        }
        return "POLYGON((" + points.join(',') + "))";
    }
    return null;
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var defaultOptions = {
    strokeColor: '#FF9800',
    fillColor: '#64B5F6',
    strokeWeight: 2,
    fillOpacity: 0.5,
    clickable: false,
    visible: false,
    editable: false,
    zIndex: 2000
};
var Polygon = /** @class */ (function () {
    function Polygon() {
        this.onChange = new EventEmitter();
    }
    /**
     * @param {?} map
     * @param {?=} options
     * @return {?}
     */
    Polygon.prototype.init = /**
     * @param {?} map
     * @param {?=} options
     * @return {?}
     */
    function (map, options) {
        if (options === void 0) { options = {}; }
        this.map = map;
        this.options = __assign({}, options, defaultOptions);
        this.poly = new google.maps.Polygon({
            strokeWeight: this.options.strokeWeight,
            strokeColor: this.options.strokeColor,
            fillOpacity: this.options.fillOpacity,
            fillColor: this.options.fillColor,
            clickable: this.options.clickable,
            editable: this.options.editable,
            visible: this.options.visible,
            zIndex: this.options.zIndex
        });
        this.poly.setMap(this.map);
        if (this.options.visible && this.options.editable) {
            this.getFocus();
        }
    };
    /**
     * @param {?} paths
     * @return {?}
     */
    Polygon.prototype.set = /**
     * @param {?} paths
     * @return {?}
     */
    function (paths) {
        if (this.poly) {
            this.poly.getPath().clear();
            this.poly.setPaths(paths);
        }
        this.onChange.emit(this.getValue());
        this.show();
    };
    /**
     * @return {?}
     */
    Polygon.prototype.getFocus = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.poly) {
            this.poly.setEditable(true);
            this.poly.setVisible(true);
        }
        if (this.map) {
            this.map.setOptions({
                clickableIcons: false
            });
        }
        if (this.map && this.poly && !this.mapClickEventHandler) {
            this.mapClickEventHandler = google.maps.event.addListener(this.map, 'click', function (e) {
                if (e && e.latLng) {
                    try {
                        _this.poly.getPath().push(e.latLng);
                        _this.onChange.emit(_this.getValue());
                    }
                    catch (err) {
                        // ignore errors
                    }
                }
            });
        }
        if (this.map && this.poly && !this.dblClickEventHandler) {
            this.dblClickEventHandler = this.poly.addListener('dblclick', function (e) {
                if (e.vertex) {
                    /** @type {?} */
                    var polygon = _this.poly.getPath();
                    if (polygon.getLength() > 2 && e && e.vertex) {
                        _this.poly.getPath().removeAt(e.vertex);
                        _this.onChange.emit(_this.getValue());
                    }
                }
            });
        }
    };
    /**
     * @return {?}
     */
    Polygon.prototype.removeFocus = /**
     * @return {?}
     */
    function () {
        this.removeMapEvents();
        if (this.poly) {
            this.poly.setEditable(false);
        }
        if (this.map) {
            this.map.setOptions({
                clickableIcons: true
            });
        }
    };
    /**
     * @return {?}
     */
    Polygon.prototype.hide = /**
     * @return {?}
     */
    function () {
        this.removeFocus();
        if (this.poly) {
            this.poly.setVisible(false);
        }
    };
    /**
     * @return {?}
     */
    Polygon.prototype.show = /**
     * @return {?}
     */
    function () {
        if (this.poly) {
            this.poly.setVisible(true);
        }
    };
    /**
     * @return {?}
     */
    Polygon.prototype.getValue = /**
     * @return {?}
     */
    function () {
        return this.poly ? getWKTFromMVCArray(this.poly.getPath()) : null;
    };
    /**
     * @return {?}
     */
    Polygon.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.hide();
        if (this.poly) {
            this.poly.getPath().clear();
        }
        this.onChange.emit(null);
    };
    /**
     * @return {?}
     */
    Polygon.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.removeMapEvents();
        if (this.poly) {
            this.poly.getPath().clear();
            this.poly.setMap(null);
            this.poly = null;
        }
    };
    /**
     * @return {?}
     */
    Polygon.prototype.removeMapEvents = /**
     * @return {?}
     */
    function () {
        if (this.mapClickEventHandler) {
            this.mapClickEventHandler.remove();
            this.mapClickEventHandler = null;
        }
        if (this.dblClickEventHandler) {
            this.dblClickEventHandler.remove();
            this.dblClickEventHandler = null;
        }
    };
    Polygon.decorators = [
        { type: Injectable }
    ];
    Polygon.propDecorators = {
        onChange: [{ type: Output }]
    };
    return Polygon;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DefaultAnalytics = /** @class */ (function () {
    function DefaultAnalytics() {
    }
    /**
     * @param {?} event
     * @param {?=} attributes
     * @return {?}
     */
    DefaultAnalytics.prototype.logEvent = /**
     * @param {?} event
     * @param {?=} attributes
     * @return {?}
     */
    function (event, attributes) {
        if (attributes) {
            console.log("Analytics Event: " + event, attributes);
        }
        else {
            console.log("Analytics Event: " + event);
        }
    };
    return DefaultAnalytics;
}());
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.analytics = new DefaultAnalytics();
    }
    /**
     * @param {?} event
     * @param {?=} attributes
     * @return {?}
     */
    Analytics.prototype.logEvent = /**
     * @param {?} event
     * @param {?=} attributes
     * @return {?}
     */
    function (event, attributes) {
        this.analytics.logEvent(event, attributes);
    };
    /**
     * @param {?} logger
     * @return {?}
     */
    Analytics.prototype.setHandler = /**
     * @param {?} logger
     * @return {?}
     */
    function (logger) {
        this.analytics = logger;
    };
    Analytics.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    Analytics.ctorParameters = function () { return []; };
    return Analytics;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PolygonFilter = /** @class */ (function (_super) {
    __extends(PolygonFilter, _super);
    function PolygonFilter(polygon, mapsService, elRef, logger, analytics) {
        var _this = _super.call(this) || this;
        _this.polygon = polygon;
        _this.mapsService = mapsService;
        _this.elRef = elRef;
        _this.logger = logger;
        _this.analytics = analytics;
        _this.onDrawStart = new EventEmitter();
        _this.onDrawEnd = new EventEmitter();
        _this.onOpen = new EventEmitter();
        _this.actionsVisible = false;
        _this.drawingMode = false;
        _this.wkt = null;
        _this.active = false;
        _this.subscriptions = [];
        return _this;
    }
    /**
     * @return {?}
     */
    PolygonFilter.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.polygon.onChange.subscribe(function (wkt) {
            _this.wkt = wkt;
        }, this.logger.error));
        this.subscriptions.push(this.mapsService.onMapLoad.subscribe(function (map) {
            _this.polygon.init(map);
        }, this.logger.error));
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (e) { return e.unsubscribe(); });
        this.active = false;
        this.reset();
        this.polygon.destroy();
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.edit = /**
     * @return {?}
     */
    function () {
        this.actionsVisible = true;
        this.drawingMode = true;
        this.polygon.getFocus();
        this.onDrawStart.emit();
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.save = /**
     * @return {?}
     */
    function () {
        this.drawingMode = false;
        this.wkt = this.polygon.getValue();
        if (this.validate()) {
            this.active = true;
            this.polygon.removeFocus();
            this.onDrawEnd.emit();
            this.onQueryChange.emit();
            this.analytics.logEvent('Mapping Created Polygon');
        }
        else {
            this.onDrawEnd.emit();
            this.reset();
        }
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.actionsVisible = !this.actionsVisible;
        if (this.actionsVisible) {
            if (!this.validate()) {
                this.drawingMode = true;
                this.polygon.getFocus();
                this.onDrawStart.emit();
            }
            this.active = true;
            this.onOpen.emit();
        }
        else {
            this.save();
        }
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.validate()) {
            query[this.name] = { value: this.wkt, label: this.label };
        }
        return query;
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        return this.wkt !== null;
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.active = false;
        this.actionsVisible = false;
        this.drawingMode = false;
        this.wkt = null;
        this.polygon.reset();
        this.onDrawEnd.emit();
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return this.wkt === null;
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    PolygonFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        if (initialQuery && initialQuery[this.name]) {
            this.active = true;
            this.actionsVisible = true;
            this.wkt = initialQuery[this.name].value;
            this.polygon.set(parseWKT(this.wkt));
        }
    };
    /**
     * @return {?}
     */
    PolygonFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.elRef;
    };
    PolygonFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-polygon-filter',
                    template: "<div class=\"apto-map--drawing-tool--wrapper apto-map--polygon-filter-component\">\n    <button\n        type=\"button\"\n        (click)=\"toggle()\"\n        [ngClass]=\"{'apto-map--map-toolbar--control--active': active}\"\n        class=\"apto-map--btn apto-map--map-toolbar--control apto-map--map-toolbar--margin apto-map--polygon-filter--toggle\">\n        <svg viewBox=\"0 0 24 24\">\n            <title>Draw Polygon</title>\n            <path d=\"M20 16.18V7.82A3 3 0 1 0 16.18 4H7.82A3 3 0 1 0 4 7.82v8.37A3 3 0 1 0 7.82 20h8.37A3 3 0 1 0 20 16.18zm-14 0V7.82A3 3 0 0 0 7.82 6h8.37A3 3 0 0 0 18 7.82v8.37A3 3 0 0 0 16.18 18H7.82A3 3 0 0 0 6 16.18z\"></path>\n        </svg>\n    </button>\n    <div\n        [ngClass]=\"{'apto-map--drawing-tool--actions-active': actionsVisible}\"\n        class=\"apto-map--drawing-tool--actions apto-map--polygon-filter--controls\">\n        <span\n            *ngIf=\"wkt === null\"\n            class=\"apto-map--drawing-tool--btn apto-map--drawing-tool--btn-no-select apto-map--polygon-filter--click-map\">Click On Map To Add</span>\n        <button\n            type=\"button\"\n            *ngIf=\"drawingMode && wkt !== null\"\n            class=\"apto-map--btn apto-map--drawing-tool--btn apto-map--drawing-tool--btn--active apto-map--btn--no-right-radius apto-map--polygon-filter--save\"\n            (click)=\"save()\">Save</button>\n        <button\n            type=\"button\"\n            *ngIf=\"!drawingMode && wkt !== null\"\n            class=\"apto-map--btn apto-map--drawing-tool--btn apto-map--btn--no-right-radius apto-map--polygon-filter--edit\"\n            (click)=\"edit()\">Edit</button>\n        <button\n            type=\"button\"\n            *ngIf=\"wkt !== null\"\n            class=\"apto-map--btn apto-map--drawing-tool--btn apto-map--btn--no-left-radius apto-map--polygon-filter--remove\"\n            (click)=\"reset()\">Remove</button>\n    </div>\n</div>",
                    providers: [Polygon]
                }] }
    ];
    /** @nocollapse */
    PolygonFilter.ctorParameters = function () { return [
        { type: Polygon },
        { type: GoogleMapsAPIService },
        { type: ElementRef },
        { type: Logger },
        { type: Analytics }
    ]; };
    PolygonFilter.propDecorators = {
        onDrawStart: [{ type: Output }],
        onDrawEnd: [{ type: Output }],
        onOpen: [{ type: Output }]
    };
    return PolygonFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var defaultOptions$1 = {
    strokeColor: '#FF9800',
    fillColor: '#64B5F6',
    strokeWeight: 2,
    fillOpacity: 0.5,
    clickable: false,
    visible: false,
    editable: true,
    radius: 0,
    center: {
        lat: 0,
        lng: 0
    },
    zIndex: 2000
};
/** @type {?} */
var DEFAULT_RADIUS = 1;
/** @type {?} */
var MILES_TO_METERS = 1609.344;
/** @type {?} */
var METERS_TO_MILES = 0.000621371;
var Circle = /** @class */ (function () {
    function Circle() {
        this.onChange = new EventEmitter();
        this.map = null;
    }
    /**
     * @param {?} map
     * @param {?=} options
     * @return {?}
     */
    Circle.prototype.init = /**
     * @param {?} map
     * @param {?=} options
     * @return {?}
     */
    function (map, options) {
        if (options === void 0) { options = {}; }
        this.map = map;
        this.options = __assign({}, options, defaultOptions$1);
        this.circle = new google.maps.Circle({
            strokeWeight: this.options.strokeWeight,
            strokeColor: this.options.strokeColor,
            fillOpacity: this.options.fillOpacity,
            fillColor: this.options.fillColor,
            clickable: this.options.clickable,
            editable: this.options.editable,
            visible: this.options.visible,
            zIndex: this.options.zIndex
        });
        this.circle.setMap(this.map);
        if (this.options.visible) {
            this.setMapEvents();
        }
    };
    /**
     * @param {?} center
     * @param {?=} radius
     * @return {?}
     */
    Circle.prototype.set = /**
     * @param {?} center
     * @param {?=} radius
     * @return {?}
     */
    function (center, radius) {
        if (radius === void 0) { radius = DEFAULT_RADIUS; }
        if (this.circle) {
            if (center !== null) {
                this.circle.setCenter(center);
            }
            this.circle.setRadius(radius * MILES_TO_METERS);
        }
        this.setEditMode();
    };
    /**
     * @return {?}
     */
    Circle.prototype.hide = /**
     * @return {?}
     */
    function () {
        if (this.circle) {
            this.circle.setVisible(false);
        }
    };
    /**
     * @return {?}
     */
    Circle.prototype.show = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.setEditMode();
        if (this.map) {
            this.mapClickEventHandler = google.maps.event.addListener(this.map, 'click', function (e) {
                if (e && e.latLng) {
                    _this.set(e.latLng, DEFAULT_RADIUS);
                    _this.mapClickEventHandler.remove();
                }
            });
        }
    };
    /**
     * @return {?}
     */
    Circle.prototype.getValue = /**
     * @return {?}
     */
    function () {
        if (this.circle) {
            /** @type {?} */
            var latLng = this.circle.getCenter();
            /** @type {?} */
            var radius = this.circle.getRadius();
            if (radius > 0 && latLng.lat() !== 0 && latLng.lng() !== 0) {
                return latLng.lat() + "," + latLng.lng() + "," + radius * METERS_TO_MILES;
            }
        }
        return null;
    };
    /**
     * @return {?}
     */
    Circle.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.hide();
        if (this.mapClickEventHandler) {
            this.mapClickEventHandler.remove();
        }
        this.set({ lat: 0, lng: 0 }, 0);
    };
    /**
     * @return {?}
     */
    Circle.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.removeMapEvents();
        if (this.circle) {
            this.circle.setMap(null);
            this.circle = null;
        }
    };
    /**
     * @return {?}
     */
    Circle.prototype.setMapEvents = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var debounceChange = null;
        if (this.circle && !this.radiusChangedHandler) {
            this.radiusChangedHandler = this.circle.addListener('radius_changed', function () {
                if (debounceChange) {
                    clearTimeout(debounceChange);
                }
                debounceChange = setTimeout(function () {
                    _this.onChange.emit(_this.getValue());
                }, 200);
            });
        }
        if (this.circle && !this.centerChangedHandler) {
            this.centerChangedHandler = this.circle.addListener('center_changed', function () {
                if (debounceChange) {
                    clearTimeout(debounceChange);
                }
                debounceChange = setTimeout(function () {
                    _this.onChange.emit(_this.getValue());
                }, 200);
            });
        }
    };
    /**
     * @return {?}
     */
    Circle.prototype.removeMapEvents = /**
     * @return {?}
     */
    function () {
        if (this.mapClickEventHandler) {
            this.mapClickEventHandler.remove();
        }
        if (this.radiusChangedHandler) {
            this.radiusChangedHandler.remove();
        }
        if (this.centerChangedHandler) {
            this.centerChangedHandler.remove();
        }
    };
    /**
     * @return {?}
     */
    Circle.prototype.setEditMode = /**
     * @return {?}
     */
    function () {
        if (this.circle) {
            this.circle.setVisible(true);
        }
        this.setMapEvents();
        if (this.mapClickEventHandler) {
            this.mapClickEventHandler.remove();
        }
    };
    Circle.propDecorators = {
        onChange: [{ type: Output }]
    };
    return Circle;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var DEFAULT_RADIUS$1 = 1;
var RadiusFilter = /** @class */ (function (_super) {
    __extends(RadiusFilter, _super);
    function RadiusFilter(ref, mapsService, circle, elRef, logger, analytics) {
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.mapsService = mapsService;
        _this.circle = circle;
        _this.elRef = elRef;
        _this.logger = logger;
        _this.analytics = analytics;
        _this.onOpen = new EventEmitter();
        _this.circleValue = null;
        _this.radius = DEFAULT_RADIUS$1;
        _this.optionsVisible = false;
        _this.actionsVisible = false;
        _this.active = false;
        _this.subscriptions = [];
        return _this;
    }
    /**
     * @return {?}
     */
    RadiusFilter.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.circle.onChange.subscribe(function (v) {
            if (v) {
                /** @type {?} */
                var parts = v.split(',');
                _this.radius = Number(parts[2] || DEFAULT_RADIUS$1);
            }
            _this.circleValue = v;
            // need to manually detect change
            if (!(/** @type {?} */ (_this.ref)).destroyed) {
                _this.ref.detectChanges();
            }
            _this.onQueryChange.emit();
            if (_this.validate()) {
                _this.analytics.logEvent('Mapping Created Radius');
            }
        }, this.logger.error));
        this.subscriptions.push(this.mapsService.onMapLoad.subscribe(function (map) {
            _this.circle.init(map);
        }, this.logger.error));
    };
    /**
     * @return {?}
     */
    RadiusFilter.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (e) { return e.unsubscribe(); });
        this.circle.destroy();
        this.active = false;
    };
    /**
     * @param {?} n
     * @return {?}
     */
    RadiusFilter.prototype.setRadius = /**
     * @param {?} n
     * @return {?}
     */
    function (n) {
        if (n <= 0) {
            n = DEFAULT_RADIUS$1;
        }
        this.optionsVisible = false;
        this.radius = n;
        this.circle.set(null, n);
        this.onQueryChange.emit();
    };
    /**
     * @param {?} e
     * @return {?}
     */
    RadiusFilter.prototype.setUserRadius = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var v = e.srcElement.value.replace(/[^0-9.,]/g, '');
        e.srcElement.value = v;
        this.setRadius(Number(v));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RadiusFilter.prototype.toggle = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.stopPropagation();
        this.actionsVisible = !this.actionsVisible;
        if (!this.actionsVisible) {
            if (this.validate()) {
                this.active = true;
            }
            else {
                this.reset();
            }
        }
        else {
            this.active = true;
            this.onOpen.emit();
            if (!this.validate()) {
                this.circle.show();
            }
        }
        // manually detect changes
        if (!(/** @type {?} */ (this.ref)).destroyed) {
            this.ref.detectChanges();
        }
    };
    /**
     * @return {?}
     */
    RadiusFilter.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var query = {};
        if (this.validate()) {
            query[this.name] = { value: this.circleValue, label: this.label };
        }
        return query;
    };
    /**
     * @return {?}
     */
    RadiusFilter.prototype.validate = /**
     * @return {?}
     */
    function () {
        return this.circleValue !== null;
    };
    /**
     * @return {?}
     */
    RadiusFilter.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.circleValue = null;
        this.actionsVisible = false;
        this.radius = null;
        this.active = false;
        this.circle.reset();
    };
    /**
     * @return {?}
     */
    RadiusFilter.prototype.isEmpty = /**
     * @return {?}
     */
    function () {
        return this.circleValue === null;
    };
    /**
     * @param {?} initialQuery
     * @return {?}
     */
    RadiusFilter.prototype.setInitialQuery = /**
     * @param {?} initialQuery
     * @return {?}
     */
    function (initialQuery) {
        if (initialQuery && initialQuery[this.name]) {
            this.active = true;
            this.circleValue = initialQuery[this.name].value;
            /** @type {?} */
            var parts = this.circleValue.split(',');
            this.radius = Number(parts[2] || DEFAULT_RADIUS$1);
            this.circle.set({ lat: parseFloat(parts[0]), lng: parseFloat(parts[1]) }, this.radius);
            this.actionsVisible = true;
        }
    };
    /**
     * @return {?}
     */
    RadiusFilter.prototype.getElement = /**
     * @return {?}
     */
    function () {
        return this.elRef;
    };
    RadiusFilter.decorators = [
        { type: Component, args: [{
                    selector: 'am-radius-filter',
                    template: "<div class=\"apto-map--drawing-tool--wrapper apto-map--radius-filter-component\">\n    <button\n        type=\"button\"\n        (click)=\"toggle($event)\"\n        [ngClass]=\"{'apto-map--map-toolbar--control--active': active}\"\n        class=\"apto-map--btn apto-map--map-toolbar--control apto-map--map-toolbar--margin apto-map--radius-filter--toggle\">\n        <svg viewBox=\"0 0 1792 1792\">\n            <title>Draw Radius</title>\n            <path d=\"M1152 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm128 0q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zm128 0q0 212-150 362t-362 150-362-150-150-362 150-362 362-150 362 150 150 362zm128 0q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zm128 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z\"></path>\n        </svg>\n    </button>\n    <div\n        [ngClass]=\"{'apto-map--drawing-tool--actions-active': actionsVisible}\"\n        class=\"apto-map--drawing-tool--actions apto-map--radius-filter--controls\">\n        <span\n            *ngIf=\"circleValue === null\"\n            class=\"apto-map--drawing-tool--btn apto-map--drawing-tool--btn-no-select apto-map--radius-filter--click-map\">Click On Map To Add</span>\n        <div\n            *ngIf=\"circleValue !== null\"\n            class=\"apto-map--radius-filter--input\">\n            <div class=\"apto-map--drawing-tool--btn apto-map--btn--no-right-radius\">\n                <input id=\"am-rf-miles\" type=\"text\" value=\"{{ radius | number:'1.0-2' }}\" (change)=\"setUserRadius($event)\">\n                <label for=\"am-rf-miles\">Miles</label>\n                <button\n                    (click)=\"optionsVisible = !optionsVisible\"\n                    class=\"apto-map--btn apto-map--drawing-tool--btn apto-map--chevron--down apto-map--radius-filter--options-toggle\"></button>\n            </div>\n            <ul\n                *ngIf=\"optionsVisible\"\n                class=\"apto-map--dropdown apto-map--drawing-tool--dropdown apto-map--radius-filter--options\">\n                <li (click)=\"setRadius(0.25)\">1/4 mi.</li>\n                <li (click)=\"setRadius(0.5)\">1/2 mi.</li>\n                <li (click)=\"setRadius(1)\">1 mi.</li>\n                <li (click)=\"setRadius(3)\">3 mi. - Submarket</li>\n                <li (click)=\"setRadius(5)\">5 mi.</li>\n                <li (click)=\"setRadius(10)\">10 mi. - City</li>\n                <li (click)=\"setRadius(20)\">20 mi. - City/Suburbs</li>\n                <li (click)=\"setRadius(50)\">50 mi. - Metro Area</li>\n            </ul>\n        </div>\n        <button\n            type=\"button\"\n            *ngIf=\"circleValue\"\n            class=\"apto-map--btn apto-map--drawing-tool--btn apto-map--btn--no-left-radius apto-map--radius-filter--remove\"\n            (click)=\"reset()\">Remove</button>\n    </div>\n</div>",
                    providers: [Circle]
                }] }
    ];
    /** @nocollapse */
    RadiusFilter.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: GoogleMapsAPIService },
        { type: Circle },
        { type: ElementRef },
        { type: Logger },
        { type: Analytics }
    ]; };
    RadiusFilter.propDecorators = {
        onOpen: [{ type: Output }]
    };
    return RadiusFilter;
}(BaseFilter));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IConfiguration = /** @class */ (function () {
    function IConfiguration() {
        this.addToListEnabled = true;
        this.addPropertyFromPlaceEnabled = true;
        this.exportEnabled = true;
        this.searchNearPlaceEnabled = true;
    }
    IConfiguration.decorators = [
        { type: Injectable }
    ];
    return IConfiguration;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ExportTypes = /** @class */ (function () {
    function ExportTypes() {
    }
    ExportTypes.PDF = 'pdf';
    ExportTypes.CSV = 'csv';
    return ExportTypes;
}());
var ExportLayouts = /** @class */ (function () {
    function ExportLayouts() {
    }
    ExportLayouts.PDF_NO_IMAGES = 'pdf-no-images';
    ExportLayouts.PDF_IMAGES = 'pdf-images';
    ExportLayouts.CSV = 'csv';
    return ExportLayouts;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var isPropertyMapped = function (property) {
    /** @type {?} */
    var lat = Number(property.latitude || null);
    /** @type {?} */
    var lng = Number(property.longitude || null);
    if (!lat || lat === 0 || !lng || lng === 0) {
        return false;
    }
    return true;
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var MAX_SELECTED_ITEMS = 500;
/** @type {?} */
var MAX_PDF_IMAGES = 100;
/** @type {?} */
var LIST_ITEM_HOVER_DELAY = 500;
var ListItems = /** @class */ (function () {
    function ListItems(config) {
        this.config = config;
        this.items = [];
        this.totalResults = 0;
        this.resultLimit = 500;
        this.onItemClick = new EventEmitter();
        this.onItemHover = new EventEmitter();
        this.onItemLeave = new EventEmitter();
        this.onUpdatePropertyAddress = new EventEmitter();
        this.onCallistMaxSelectionError = new EventEmitter();
        this.onChangePageExt = new EventEmitter();
        this.onUpdateWithMove = new EventEmitter();
        this.onAddPropertyClick = new EventEmitter();
        this.onAddSelectedToList = new EventEmitter();
        this.onExportSelected = new EventEmitter();
        this.updateWithMove = true;
        this.shownItems = [];
        this.selectedItems = [];
        this.showSelectAll = false;
        this.maxSelectedItems = MAX_SELECTED_ITEMS;
        this.maxPDFImages = MAX_PDF_IMAGES;
        this.exportOptionsVisible = false;
        this.mappedCount = 0;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ListItems.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.items) {
            this.mappedCount = this.getMappedCount();
        }
    };
    /**
     * @return {?}
     */
    ListItems.prototype.scrollTop = /**
     * @return {?}
     */
    function () {
        this.container.nativeElement.scrollTop = 0;
    };
    /**
     * @param {?} shownItems
     * @return {?}
     */
    ListItems.prototype.onChangePage = /**
     * @param {?} shownItems
     * @return {?}
     */
    function (shownItems) {
        this.scrollTop();
        this.shownItems = shownItems;
        this.onChangePageExt.emit(shownItems);
    };
    /**
     * @return {?}
     */
    ListItems.prototype.toggleSelected = /**
     * @return {?}
     */
    function () {
        if (this.selectedItems.length) {
            this.clearSelected();
        }
        else {
            this.addToListToggle.nativeElement.checked = true;
            this.addItemsToList(this.items.filter(function (p) { return isPropertyMapped(p); }), true);
            // only show more if there are some unmapped properties
            if (this.selectedItems.length < this.items.length) {
                this.showSelectAll = true;
            }
        }
    };
    /**
     * @return {?}
     */
    ListItems.prototype.clearSelected = /**
     * @return {?}
     */
    function () {
        this.selectedItems = [];
        this.showSelectAll = false;
        this.exportOptionsVisible = false;
        this.addToListToggle.nativeElement.checked = false;
    };
    /**
     * @return {?}
     */
    ListItems.prototype.addAllItemsToList = /**
     * @return {?}
     */
    function () {
        this.showSelectAll = false;
        this.addItemsToList(this.items, true);
        if (this.items.length > this.maxSelectedItems) {
            this.onCallistMaxSelectionError.emit("You can only select up to " + this.maxSelectedItems + " results.\n                The last " + (this.items.length - this.maxSelectedItems) + " were skipped.");
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListItems.prototype.debounceItemHover = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        if (this.itemHoverTimeout) {
            clearTimeout(this.itemHoverTimeout);
        }
        this.itemHoverTimeout = setTimeout(function () {
            _this.onItemHover.emit(item);
        }, LIST_ITEM_HOVER_DELAY);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListItems.prototype.debounceItemLeave = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (this.itemHoverTimeout) {
            clearTimeout(this.itemHoverTimeout);
        }
        this.onItemLeave.emit(item);
    };
    /**
     * @param {?=} items
     * @param {?=} forceAdd
     * @return {?}
     */
    ListItems.prototype.addItemsToList = /**
     * @param {?=} items
     * @param {?=} forceAdd
     * @return {?}
     */
    function (items, forceAdd) {
        var _this = this;
        if (items === void 0) { items = []; }
        if (forceAdd === void 0) { forceAdd = false; }
        items.forEach(function (item) {
            _this.addItemToList(item, forceAdd);
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListItems.prototype.handleWithMoveChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onUpdateWithMove.emit(this.updateWithMove);
    };
    /**
     * @param {?} item
     * @param {?=} forceAdd
     * @param {?=} event
     * @return {?}
     */
    ListItems.prototype.addItemToList = /**
     * @param {?} item
     * @param {?=} forceAdd
     * @param {?=} event
     * @return {?}
     */
    function (item, forceAdd, event) {
        if (forceAdd === void 0) { forceAdd = false; }
        if (event === void 0) { event = null; }
        /** @type {?} */
        var index = this.selectedItems.indexOf(item);
        if (index < 0) {
            // prevent selecting more than maxSelectedItems
            if (this.selectedItems.length < this.maxSelectedItems) {
                this.selectedItems.push(item);
            }
            else {
                // user clicked something to add and we have too many
                if (event && event.target) {
                    event.target.checked = false;
                    this.onCallistMaxSelectionError.emit("You can only select up to " + this.maxSelectedItems + " results");
                }
            }
        }
        else if (!forceAdd) {
            this.selectedItems.splice(index, 1);
            if (!this.selectedItems.length) {
                this.clearSelected();
            }
        }
    };
    /**
     * @param {?} item
     * @param {?=} field
     * @return {?}
     */
    ListItems.prototype.itemShown = /**
     * @param {?} item
     * @param {?=} field
     * @return {?}
     */
    function (item, field) {
        if (field === void 0) { field = '_id'; }
        return Boolean(this.shownItems.find(function (i) { return i[field] === item[field]; }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListItems.prototype.addShownItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.shownItems.push(item);
    };
    /**
     * @param {?} e
     * @param {?=} type
     * @param {?=} layout
     * @return {?}
     */
    ListItems.prototype.exportByType = /**
     * @param {?} e
     * @param {?=} type
     * @param {?=} layout
     * @return {?}
     */
    function (e, type, layout) {
        if (type === void 0) { type = ExportTypes.CSV; }
        if (layout === void 0) { layout = ExportLayouts.CSV; }
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        this.exportOptionsVisible = false;
        // don't allow images if items > this.maxPDFImages for performance reasons
        if (layout === ExportLayouts.PDF_IMAGES && this.selectedItems.length > this.maxPDFImages) {
            layout = ExportLayouts.PDF_NO_IMAGES;
        }
        this.onExportSelected.emit({
            selected: this.selectedItems,
            type: type,
            layout: layout
        });
    };
    /**
     * @return {?}
     */
    ListItems.prototype.getMappedCount = /**
     * @return {?}
     */
    function () {
        return this.items.filter(function (p) { return isPropertyMapped(p); }).length;
    };
    ListItems.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--list-items-content\">\n    <div class=\"apto-map--list-items-content--header\">\n        <div class=\"apto-map--list-items--top--cta-wrapper\">\n            <button *ngIf=\"config.addToListEnabled && selectedItems.length\"\n                    (click)=\"onAddSelectedToList.emit(selectedItems)\"\n                    type=\"button\"\n                    data-automation=\"apto-map-add-to-list\"\n                    class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link\">Add To List</button>\n\n            <div *ngIf=\"config.exportEnabled && selectedItems.length\"\n                 class=\"apto-map--export apto-map--dropdown-wrapper\">\n                <button (click)=\"exportOptionsVisible = !exportOptionsVisible\"\n                        type=\"button\"\n                        data-automation=\"apto-map--export-toggle\"\n                        class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link apto-map--chevron--down\">Export</button>\n                <ul *ngIf=\"exportOptionsVisible\"\n                    class=\"apto-map--dropdown apto-map--dropdown--hover\"\n                    data-automation=\"apto-map--export-dd\">\n                    <li>\n                        <a (click)=\"exportByType($event, 'csv')\"\n                           data-automation=\"apto-map--export--csv\">\n                            CSV Spreadsheet\n                            <span class=\"apto-map--muted\">({{ selectedItems.length }} {{ selectedItems.length > 1 ? 'items' : 'item' }})</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a (click)=\"exportByType($event, 'pdf', 'pdf-images')\"\n                           data-automation=\"apto-map--export--pdf\">\n                            PDF\n                            <span class=\"apto-map--muted\">({{ selectedItems.length }} {{ selectedItems.length > 1 ? 'items' : 'item' }})</span>\n                        </a>\n                    </li>\n                    <li *ngIf=\"selectedItems.length > maxPDFImages\"\n                        class=\"apto-map--export--notice\">\n                        PDFs with over {{ maxPDFImages }} items will\n                        <strong>not include</strong> images.\n                    </li>\n                </ul>\n            </div>\n            <button (click)=\"onAddPropertyClick.emit($event)\"\n                    type=\"button\"\n                    class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link\">Add Property</button>\n        </div>\n        <div class=\"apto-map--list-items--count-list-selector-wrapper\">\n            <div *ngIf=\"config.addToListEnabled\"\n                 class=\"apto-map--list-items--top--list-selector\">\n                <label class=\"apto-map--form-control--checkbox\">\n                    <input type=\"checkbox\"\n                           (change)=\"toggleSelected()\"\n                           #addToListToggle>\n                    <span class=\"apto-map--form-control--checkbox--check apto-map--form-control--checkbox--check--circle\"></span>\n                </label>\n                <span *ngIf=\"!selectedItems.length\"\n                      class=\"apto-map--pointer\"\n                      (click)=\"toggleSelected()\">Select {{ mappedCount }}</span>\n                <span *ngIf=\"selectedItems.length\">Selected {{ selectedItems.length }}</span>\n            </div>\n            <div class=\"apto-map--list-items--top--counts apto-map--muted\"\n                 data-automation=\"apto-map-result-count\">\n                <span *ngIf=\"!items.length || totalResults === 0\"\n                      class=\"apto-map--list-items--top--counts--warning\">\n                    <span>\n                        <span class=\"apto-map--icon-warning\"></span>\n                    </span>\n                    <span>No results found</span>\n                </span>\n                <span *ngIf=\"items.length && totalResults > resultLimit\"\n                      class=\"apto-map--list-items--top--counts--warning\">\n                    <span>\n                        <span class=\"apto-map--icon-warning\"></span>\n                    </span>\n                    <span>Only showing first {{ resultLimit|number }} of {{ totalResults|number }} results, try to narrow your search</span>\n                </span>\n                <span *ngIf=\"items.length && totalResults <= resultLimit\">{{ items.length|number }} result{{ items.length > 1 ? 's': '' }} found</span>\n            </div>\n        </div>\n        <div *ngIf=\"showSelectAll\"\n             class=\"apto-map--list-items--add-all-to-selected apto-map--pointer\">\n            <span *ngIf=\"items.length > maxSelectedItems\">\n                <a (click)=\"addAllItemsToList()\">Select first\n                    <strong>{{ maxSelectedItems|number }}</strong> of {{ items.length|number }} results including unmapped properties</a> (max {{ maxSelectedItems|number\n                }} allowed)</span>\n            <a *ngIf=\"items.length <= maxSelectedItems\"\n               (click)=\"addAllItemsToList()\">Select all {{ items.length|number }} including unmapped properties</a>\n            <am-tooltip>\n                <a amTooltipTrigger class=\"apto-map--tooltip--btn\">?</a>\n                <div amTooltipContent>\n                    <strong>Unmapped properties</strong> have partial or wrong addresses that are not able to be geocoded and displayed as markers on the map.\n                </div>\n            </am-tooltip>\n        </div>\n    </div>\n\n    <ul #container\n        class=\"apto-map--list-items-content--body apto-map--list-items\">\n        <li *ngFor=\"let item of shownItems\">\n            <div *ngIf=\"config.addToListEnabled\"\n                 class=\"apto-map--list-items--build-list-checkbox\"\n                 [ngClass]=\"{'apto-map--list-items--selected' : selectedItems.includes(item)}\"\n                 id=\"apto-map--list-items-item--property-{{ item._id }}\">\n                <label class=\"apto-map--form-control--checkbox\">\n                    <input type=\"checkbox\"\n                           [checked]=\"selectedItems.includes(item)\"\n                           (change)=\"addItemToList(item, false, $event)\">\n                    <span class=\"apto-map--form-control--checkbox--check apto-map--form-control--checkbox--check--circle\"></span>\n                </label>\n            </div>\n            <am-property-item [property]=\"item\"\n                           (click)=\"onItemClick.emit(item)\"\n                           (mouseenter)=\"debounceItemHover(item)\"\n                           (mouseleave)=\"debounceItemLeave(item)\"\n                           (onUpdatePropertyAddress)=\"onUpdatePropertyAddress.emit($event)\"\n                           class=\"apto-map--list-item\">\n            </am-property-item>\n        </li>\n    </ul>\n\n    <div class=\"apto-map--list-items-content--footer\">\n        <div class=\"apto-map--list-items--footer-elements\">\n            <div class=\"apto-map--muted apto-map--update-map-move\">\n                <label class=\"apto-map--form-control--checkbox\">\n                    Update on map move\n                    <input\n                        type=\"checkbox\"\n                        [(ngModel)]=\"updateWithMove\"\n                        (change)=\"handleWithMoveChange($event)\"\n                        data-automation=\"apto-map-update-mouse-move\">\n                    <span class=\"apto-map--form-control--checkbox--check\"></span>\n                </label>\n            </div>\n            <am-list-pager [items]=\"items\"\n                    [resultLimit]=\"resultLimit\"\n                    (onChangePage)=\"onChangePage($event)\"></am-list-pager>\n        </div>\n    </div>\n</div>",
                    selector: 'am-list-items'
                }] }
    ];
    /** @nocollapse */
    ListItems.ctorParameters = function () { return [
        { type: IConfiguration, decorators: [{ type: Inject, args: [IConfiguration,] }] }
    ]; };
    ListItems.propDecorators = {
        container: [{ type: ViewChild, args: ['container',] }],
        addToListToggle: [{ type: ViewChild, args: ['addToListToggle',] }],
        items: [{ type: Input }],
        totalResults: [{ type: Input }],
        resultLimit: [{ type: Input }],
        onItemClick: [{ type: Output }],
        onItemHover: [{ type: Output }],
        onItemLeave: [{ type: Output }],
        onUpdatePropertyAddress: [{ type: Output }],
        onCallistMaxSelectionError: [{ type: Output }],
        onChangePageExt: [{ type: Output }],
        onUpdateWithMove: [{ type: Output }],
        onAddPropertyClick: [{ type: Output }],
        onAddSelectedToList: [{ type: Output }],
        onExportSelected: [{ type: Output }]
    };
    return ListItems;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var listViewTabs = {
    properties: 'properties',
    saved: 'saved',
    recent: 'recent'
};
var ListView = /** @class */ (function () {
    function ListView(config, analytics) {
        this.config = config;
        this.analytics = analytics;
        this.items = [];
        this.showLoader = false;
        this.totalResults = 0;
        this.resultLimit = 500;
        this.onUpdateWithMove = new EventEmitter();
        this.onItemClick = new EventEmitter();
        this.onItemHover = new EventEmitter();
        this.onItemLeave = new EventEmitter();
        this.onChangePage = new EventEmitter();
        this.onAddPropertyClick = new EventEmitter();
        this.onAddSelectedToList = new EventEmitter();
        this.onCallistMaxSelectionError = new EventEmitter();
        this.onToggleListViewComplete = new EventEmitter();
        this.onUpdatePropertyAddress = new EventEmitter();
        this.onSaveQuery = new EventEmitter();
        this.onExportSelected = new EventEmitter();
        this.collapsed = 'active';
        this.listViewTabs = listViewTabs;
        this.activeTab = listViewTabs.properties;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    ListView.prototype.toggleListView = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.collapsed = this.collapsed === 'active' ? 'inactive' : 'active';
        this.analytics.logEvent('Mapping Toggle List View');
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ListView.prototype.toggleAnimationDone = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.onToggleListViewComplete.emit();
    };
    /**
     * @return {?}
     */
    ListView.prototype.clearSelectedItems = /**
     * @return {?}
     */
    function () {
        if (this.listItems) {
            this.listItems.clearSelected();
        }
    };
    /**
     * @param {?} item
     * @param {?=} field
     * @return {?}
     */
    ListView.prototype.itemShown = /**
     * @param {?} item
     * @param {?=} field
     * @return {?}
     */
    function (item, field) {
        if (field === void 0) { field = '_id'; }
        return this.listItems.itemShown(item, field);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListView.prototype.addShownItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return this.listItems.addShownItem(item);
    };
    ListView.decorators = [
        { type: Component, args: [{
                    template: "<div\n    [@toggle]=\"collapsed\"\n    (@toggle.done)=\"toggleAnimationDone($event)\"\n    class=\"apto-map--panel--wrapper\"\n    [ngClass]=\"{'apto-map--list-view--loading': showLoader !== false, 'apto-map--list-view--collapsed': collapsed === 'inactive'}\">\n    <div class=\"apto-map--panel\">\n        <div class=\"apto-map--list-view--header\">\n            <div class=\"apto-map--list-view--header--property-lists-wrapper\">\n                <button type=\"button\"\n                        class=\"apto-map--btn apto-map--btn-link\"\n                        [ngClass]=\"{'apto-map--btn-link--active' : activeTab === listViewTabs.properties}\"\n                        (click)=\"activeTab = listViewTabs.properties\">All Properties</button>\n                <button type=\"button\"\n                        class=\"apto-map--btn apto-map--btn-link\"\n                        [ngClass]=\"{'apto-map--btn-link--active' : activeTab === listViewTabs.recent}\"\n                        (click)=\"activeTab = listViewTabs.recent\">Recent</button>\n            </div>\n        </div>\n\n        <am-list-recent-query *ngIf=\"activeTab === listViewTabs.recent\"\n                           class=\"apto-map--list-view--body\"\n                           (onSave)=\"onSaveQuery.emit($event)\"\n                           (onSelectHistory)=\"showLoader = true; activeTab = listViewTabs.properties\"></am-list-recent-query>\n\n        <am-list-items *ngIf=\"activeTab === listViewTabs.properties\"\n                    class=\"apto-map--list-view--body\"\n                    [items]=\"items\"\n                    [totalResults]=\"totalResults\"\n                    [resultLimit]=\"resultLimit\"\n                    (onItemClick)=\"onItemClick.emit($event)\"\n                    (onItemHover)=\"onItemHover.emit($event)\"\n                    (onItemLeave)=\"onItemLeave.emit($event)\"\n                    (onUpdateWithMove)=\"onUpdateWithMove.emit($event)\"\n                    (onUpdatePropertyAddress)=\"onUpdatePropertyAddress.emit($event)\"\n                    (onAddSelectedToList)=\"onAddSelectedToList.emit($event)\"\n                    (onAddPropertyClick)=\"onAddPropertyClick.emit($event)\"\n                    (onCallistMaxSelectionError)=\"onCallistMaxSelectionError.emit($event)\"\n                    (onChangePageExt)=\"onChangePage.emit($event)\"\n                    (onExportSelected)=\"onExportSelected.emit($event)\"></am-list-items>\n    </div>\n    <button\n        (click)=\"toggleListView($event)\"\n        type=\"button\"\n        title=\"Toggle Panel\"\n        class=\"apto-map--btn apto-map--chevron--left apto-map--btn-toggle-list-view\"></button>\n</div>\n",
                    selector: 'am-list-view',
                    animations: [
                        trigger('toggle', [
                            state('active', style({})),
                            // uses width in the scss file
                            state('inactive', style({
                                width: 0,
                                paddingLeft: 0,
                                paddingRight: 0
                            })),
                            transition('active => inactive', animate('200ms ease-in')),
                            transition('inactive => active', animate('200ms ease-out'))
                        ])
                    ]
                }] }
    ];
    /** @nocollapse */
    ListView.ctorParameters = function () { return [
        { type: IConfiguration, decorators: [{ type: Inject, args: [IConfiguration,] }] },
        { type: Analytics }
    ]; };
    ListView.propDecorators = {
        listItems: [{ type: ViewChild, args: [ListItems,] }],
        items: [{ type: Input }],
        showLoader: [{ type: Input }],
        totalResults: [{ type: Input }],
        resultLimit: [{ type: Input }],
        onUpdateWithMove: [{ type: Output }],
        onItemClick: [{ type: Output }],
        onItemHover: [{ type: Output }],
        onItemLeave: [{ type: Output }],
        onChangePage: [{ type: Output }],
        onAddPropertyClick: [{ type: Output }],
        onAddSelectedToList: [{ type: Output }],
        onCallistMaxSelectionError: [{ type: Output }],
        onToggleListViewComplete: [{ type: Output }],
        onUpdatePropertyAddress: [{ type: Output }],
        onSaveQuery: [{ type: Output }],
        onExportSelected: [{ type: Output }]
    };
    return ListView;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    /**
     * @return {?}
     */
    WindowRef.prototype.getNativeWindow = /**
     * @return {?}
     */
    function () { return window; };
    return WindowRef;
}());
var DocumentRef = /** @class */ (function () {
    function DocumentRef() {
    }
    /**
     * @return {?}
     */
    DocumentRef.prototype.getNativeDocument = /**
     * @return {?}
     */
    function () { return document; };
    return DocumentRef;
}());
/** @type {?} */
var BROWSER_GLOBALS_PROVIDERS = [
    WindowRef,
    DocumentRef
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getUsersCoordinates() {
    return new Promise(function (resolve) {
        /** @type {?} */
        var win = new WindowRef();
        if (win.getNativeWindow().navigator.geolocation) {
            win.getNativeWindow()
                .navigator
                .geolocation
                .getCurrentPosition(function (position) {
                if (position && position.coords) {
                    resolve({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                }
                else {
                    resolve(null);
                }
            });
        }
        else {
            resolve(null);
        }
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BaseMap = /** @class */ (function () {
    function BaseMap() {
        // Map events
        this.onMapReady = new EventEmitter();
        // map settings
        this.longitude = -98.35;
        this.latitude = 39.5;
        this.zoom = 5;
        this.minZoom = 4;
        this.maxFitBoundsZoom = 17;
        this.tilt = 45;
        this.zoomControl = true;
        this.scrollwheel = true;
        this.rotateControl = false;
        this.streetViewControl = true;
        this.fullscreenControl = false;
        this.scaleControl = false;
        this.mapTypeControl = false;
        this.mapType = 'hybrid';
        this.clickableIcons = true;
    }
    /**
     * @param {?} logger
     * @return {?}
     */
    BaseMap.prototype.setLogger = /**
     * @param {?} logger
     * @return {?}
     */
    function (logger) {
        this.logger.setHandler(logger);
    };
    /**
     * @return {?}
     */
    BaseMap.prototype.getMapService = /**
     * @return {?}
     */
    function () {
        return this.mapsService;
    };
    /**
     * @param {?=} markers
     * @return {?}
     */
    BaseMap.prototype.zoomToFitMarkers = /**
     * @param {?=} markers
     * @return {?}
     */
    function (markers) {
        var _this = this;
        if (markers === void 0) { markers = []; }
        return new Promise(function (resolve, reject) {
            /** @type {?} */
            var bounds = new google.maps.LatLngBounds();
            markers.forEach(function (m) {
                if (m.latitude && m.latitude.toString().length > 2 &&
                    m.longitude && m.longitude.toString().length > 2) {
                    bounds.extend({
                        lat: Number(m.latitude),
                        lng: Number(m.longitude)
                    });
                }
            });
            if (!bounds.isEmpty()) {
                // prevents too much zoom in
                // prevents too much zoom in
                _this.getMapService().setMapOptions({
                    maxZoom: _this.maxFitBoundsZoom
                });
                _this.getMapService().fitBounds(bounds);
                // wait for zoom to stop before resolving
                setTimeout(function () {
                    _this.getMapService().setMapOptions({
                        maxZoom: _this.maxZoom
                    });
                    resolve(true);
                }, 1000);
            }
            else {
                resolve(true);
            }
        });
    };
    /**
     * @param {?=} z
     * @return {?}
     */
    BaseMap.prototype.centerMapOnUser = /**
     * @param {?=} z
     * @return {?}
     */
    function (z) {
        if (z === void 0) { z = null; }
        return __awaiter(this, void 0, void 0, function () {
            var userLoc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getUsersCoordinates()];
                    case 1:
                        userLoc = _a.sent();
                        if (userLoc) {
                            if (z) {
                                this.getMapService().setZoom(z);
                            }
                            this.getMapService().panTo(userLoc);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    BaseMap.prototype.mapReady = /**
     * @return {?}
     */
    function () {
        // override this method if needed to implement code when map is ready to go
    };
    /**
     * @param {?} mapElement
     * @return {?}
     */
    BaseMap.prototype.loadMap = /**
     * @param {?} mapElement
     * @return {?}
     */
    function (mapElement) {
        return __awaiter(this, void 0, void 0, function () {
            var map_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getMapService().createMap(mapElement.nativeElement, {
                                center: {
                                    lat: this.latitude,
                                    lng: this.longitude
                                },
                                tilt: this.tilt,
                                zoom: this.zoom,
                                minZoom: this.minZoom,
                                maxZoom: this.maxZoom,
                                zoomControl: this.zoomControl,
                                scrollwheel: this.scrollwheel,
                                rotateControl: this.rotateControl,
                                streetViewControl: this.streetViewControl,
                                fullscreenControl: this.fullscreenControl,
                                scaleControl: this.scaleControl,
                                mapTypeControl: this.mapTypeControl,
                                clickableIcons: this.clickableIcons
                            })];
                    case 1:
                        map_1 = _a.sent();
                        this.getMapService().setMapType(this.mapType);
                        return [4 /*yield*/, this.getMapService().tilesLoaded()];
                    case 2:
                        _a.sent();
                        // slow down ready event to allow everything to propegate
                        setTimeout(function () {
                            _this.onMapReady.emit(map_1);
                        }, 100);
                        this.mapReady();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.logger.info('Apto map unable to load');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseMap.propDecorators = {
        onMapReady: [{ type: Output }],
        longitude: [{ type: Input }],
        latitude: [{ type: Input }],
        zoom: [{ type: Input }],
        minZoom: [{ type: Input }],
        maxZoom: [{ type: Input }],
        maxFitBoundsZoom: [{ type: Input }],
        tilt: [{ type: Input }],
        zoomControl: [{ type: Input }],
        scrollwheel: [{ type: Input }],
        rotateControl: [{ type: Input }],
        streetViewControl: [{ type: Input }],
        fullscreenControl: [{ type: Input }],
        scaleControl: [{ type: Input }],
        mapTypeControl: [{ type: Input }],
        mapType: [{ type: Input }],
        clickableIcons: [{ type: Input }]
    };
    return BaseMap;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
var StatusFilterOption = {
    ALL: 0,
    LEASE: 1,
    SALE: 2,
};
StatusFilterOption[StatusFilterOption.ALL] = 'ALL';
StatusFilterOption[StatusFilterOption.LEASE] = 'LEASE';
StatusFilterOption[StatusFilterOption.SALE] = 'SALE';
/** @type {?} */
var ZOOM_CENTER_DEBOUNCE = 500;
var AptoMapComponent = /** @class */ (function (_super) {
    __extends(AptoMapComponent, _super);
    function AptoMapComponent(ref, mapsService, markerManager, resolver, injector, logger, analytics, queryHistory) {
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.mapsService = mapsService;
        _this.markerManager = markerManager;
        _this.resolver = resolver;
        _this.injector = injector;
        _this.logger = logger;
        _this.analytics = analytics;
        _this.queryHistory = queryHistory;
        // window events
        _this.onWindowResize = new EventEmitter();
        // Map events
        _this.onCenterChange = new EventEmitter();
        _this.onZoomChange = new EventEmitter();
        _this.onMapBoundsChange = new EventEmitter();
        // Search Events
        _this.onSearchStart = new EventEmitter();
        _this.onSearchEnd = new EventEmitter();
        _this.onSearchHere = new EventEmitter();
        // Marker Events
        _this.onMarkerClick = new EventEmitter();
        _this.onMarkerHover = new EventEmitter();
        _this.onMarkerMouseOut = new EventEmitter();
        // List events
        _this.onItemClick = new EventEmitter();
        _this.onItemHover = new EventEmitter();
        _this.onItemLeave = new EventEmitter();
        _this.onChangePage = new EventEmitter();
        _this.onAddPropertyClick = new EventEmitter();
        _this.onAddSelectedToList = new EventEmitter();
        _this.onCallistMaxSelectionError = new EventEmitter();
        _this.onToggleListViewComplete = new EventEmitter();
        _this.onUpdatePropertyAddress = new EventEmitter();
        _this.onExportSelected = new EventEmitter();
        // Filtering events
        _this.onQueryChange = new Subject();
        _this.items = [];
        _this.totalResults = 0;
        _this.resultLimit = 500;
        _this.clearFiltersEnabled = false;
        _this.disabled = false;
        _this.disableMapMoveEvents = false;
        _this.aptoMapInstance = _this;
        _this.showLoader = false;
        _this.propertyTypeOptions = [];
        _this.showMore = false;
        _this.moreOptionsCount = 0;
        _this.searchHereEnabled = false;
        _this.currentStatusFilter = StatusFilterOption.ALL;
        _this.StatusFilterOption = StatusFilterOption;
        _this.statusOptions = [
            { value: 'all', label: 'All properties' },
            { value: 'forLease', label: 'For lease' },
            { value: 'leased', label: 'Leased' },
            { value: 'forSale', label: 'For sale' },
            { value: 'sold', label: 'Sold' }
        ];
        _this.buildlingStatusOptions = [];
        _this.marketOptions = [];
        _this.subMarketOptions = [];
        _this.primaryUseOptions = [];
        _this.buildingClassOptions = [];
        _this.tenancyOptions = [];
        _this.stateOptions = [
            { label: 'Any State', value: '' },
            { label: 'Alabama', value: 'AL' },
            { label: 'Alaska', value: 'AK' },
            { label: 'Arizona', value: 'AZ' },
            { label: 'Arkansas', value: 'AR' },
            { label: 'California', value: 'CA' },
            { label: 'Colorado', value: 'CO' },
            { label: 'Connecticut', value: 'CT' },
            { label: 'Delaware', value: 'DE' },
            { label: 'District of Columbia', value: 'DC' },
            { label: 'Florida', value: 'FL' },
            { label: 'Georgia', value: 'GA' },
            { label: 'Hawaii', value: 'HI' },
            { label: 'Idaho', value: 'ID' },
            { label: 'Illinois', value: 'IL' },
            { label: 'Indiana', value: 'IN' },
            { label: 'Iowa', value: 'IA' },
            { label: 'Kansas', value: 'KS' },
            { label: 'Kentucky', value: 'KY' },
            { label: 'Louisiana', value: 'LA' },
            { label: 'Maine', value: 'ME' },
            { label: 'Maryland', value: 'MD' },
            { label: 'Massachusetts', value: 'MA' },
            { label: 'Michigan', value: 'MI' },
            { label: 'Minnesota', value: 'MN' },
            { label: 'Mississippi', value: 'MS' },
            { label: 'Missouri', value: 'MO' },
            { label: 'Montana', value: 'MT' },
            { label: 'Nebraska', value: 'NE' },
            { label: 'Nevada', value: 'NV' },
            { label: 'New Hampshire', value: 'NH' },
            { label: 'New Jersey', value: 'NJ' },
            { label: 'New Mexico', value: 'NM' },
            { label: 'New York', value: 'NY' },
            { label: 'North Carolina', value: 'NC' },
            { label: 'North Dakota', value: 'ND' },
            { label: 'Ohio', value: 'OH' },
            { label: 'Oklahoma', value: 'OK' },
            { label: 'Oregon', value: 'OR' },
            { label: 'Pennsylvania', value: 'PA' },
            { label: 'Rhode Island', value: 'RI' },
            { label: 'South Carolina', value: 'SC' },
            { label: 'South Dakota', value: 'SD' },
            { label: 'Tennessee', value: 'TN' },
            { label: 'Texas', value: 'TX' },
            { label: 'Utah', value: 'UT' },
            { label: 'Vermont', value: 'VT' },
            { label: 'Virginia', value: 'VA' },
            { label: 'Washington', value: 'WA' },
            { label: 'West Virginia', value: 'WV' },
            { label: 'Wisconsin', value: 'WI' },
            { label: 'Wyoming', value: 'WY' }
        ];
        _this.searchFilterPanelIsValid = true;
        _this.allFilterPanelIsValid = true;
        _this.leaseFilterPanelIsValid = true;
        _this.saleFilterPanelIsValid = true;
        _this.zoomOrCenterChanged = new EventEmitter();
        _this.subscriptions = [];
        _this.startZoomAndPan = {
            zoom: 5,
            pan: { lat: 39.5, lng: -98.35 }
        };
        return _this;
    }
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
        this.markerManager.deleteAllMarkers();
        if (this.infoWindow) {
            this.infoWindow.destroy();
        }
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.onQueryChange.subscribe(function (queryChangeEvent) {
            _this.getMapService().zoomAndPan(_this.startZoomAndPan.zoom, _this.startZoomAndPan.pan);
            if (queryChangeEvent.shouldUpdateHistory) {
                _this.queryHistory.create(queryChangeEvent.query);
            }
        }));
        // debounce zoom/center change events and just send one map bounds changed event
        this.subscriptions.push(this.zoomOrCenterChanged.pipe(debounceTime(ZOOM_CENTER_DEBOUNCE + 1)).subscribe(function () {
            if (!_this.disableMapMoveEvents) {
                _this.onMapBoundsChange.emit(true);
            }
        }));
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.initMap = /**
     * @return {?}
     */
    function () {
        this.loadMap(this.googleCanvas);
    };
    /**
     * @param {?} analyticsHandler
     * @return {?}
     */
    AptoMapComponent.prototype.setAnalytics = /**
     * @param {?} analyticsHandler
     * @return {?}
     */
    function (analyticsHandler) {
        this.analytics.setHandler(analyticsHandler);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.resetFilters = /**
     * @return {?}
     */
    function () {
        this.searchAndStatusFilterPanel.resetFilters();
        this.statusFilter.selectedOption = { value: 'all', label: 'All properties' };
        this.setCurrentStatusFilter(undefined);
        this.allFilterPanel.resetFilters();
        this.leaseFilterPanel.resetFilters();
        this.saleFilterPanel.resetFilters();
        this.onQueryChange.next({
            query: this.getFilterPanelQueries(),
            shouldUpdateHistory: false
        });
        this.analytics.logEvent('Mapping Clicked Clear Filters');
        this.getMapService().zoomAndPan(this.startZoomAndPan.zoom, this.startZoomAndPan.pan);
        this.moreOptionsCount = 0;
    };
    /**
     * @param {?=} options
     * @return {?}
     */
    AptoMapComponent.prototype.initFilters = /**
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.propertyTypeOptions = options.propertyTypeOptions;
        this.addSearchAndStatusFilterPanel(options);
        this.addAllFilterPanel(options);
        this.addLeaseFilterPanel(options);
        this.addSaleFilterPanel(options);
        this.addMapToolbarFilters(options);
        this.subscriptions.push(this.queryHistory.onSelectHistory.subscribe(function (queryHistoryItem) {
            _this.resetFilters();
            _this.searchAndStatusFilterPanel.setInitialQuery(queryHistoryItem.query);
            _this.mapToolbarFilterPanel.setInitialQuery(queryHistoryItem.query);
            _this.allFilterPanel.setInitialQuery(queryHistoryItem.query);
            _this.leaseFilterPanel.setInitialQuery(queryHistoryItem.query);
            _this.saleFilterPanel.setInitialQuery(queryHistoryItem.query);
            _this.onQueryChange.next({ query: _this.getFilterPanelQueries(), shouldUpdateHistory: false });
        }, this.logger.error));
    };
    /**
     * @param {?} options
     * @return {?}
     */
    AptoMapComponent.prototype.addSearchAndStatusFilterPanel = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        var _this = this;
        // subscribe to search start/end so we can toggle the loader icon inside the searchFilter component instance
        this.subscriptions.push(this.onSearchStart.subscribe(function () {
            _this.showLoader = true;
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.onSearchEnd.subscribe(function () {
            _this.showLoader = false;
        }, this.logger.error.bind(this)));
        this.statusFilter.selectedOption = { value: 'all', label: 'All properties' };
        this.subscriptions.push(this.searchAndStatusFilterPanel.onQueryChange.subscribe(function (query) {
            _this.setCurrentStatusFilter(query);
            _this.onQueryChange.next({ query: _this.getFilterPanelQueries(), shouldUpdateHistory: true });
        }, this.logger.error.bind(this)));
        this.searchAndStatusFilterPanel.addMultiple([
            this.searchFilter,
            this.statusFilter
        ]);
        this.setCurrentStatusFilter(options.initialQuery);
        // set query after all filters are added
        this.searchAndStatusFilterPanel.setInitialQuery(options.initialQuery);
    };
    /**
     * @param {?} options
     * @return {?}
     */
    AptoMapComponent.prototype.addAllFilterPanel = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        var _this = this;
        this.subscriptions.push(this.allFilterPanel.onQueryChange.subscribe(function (query) {
            _this.setHiddenFiltersCount();
            _this.onQueryChange.next({ query: _this.getFilterPanelQueries(), shouldUpdateHistory: true });
        }, this.logger.error.bind(this)));
        this.allFilterPanel.addMultiple([
            this.propertyTypeFilter,
            this.sqftFilter,
            // this.soldPriceFilter,
            // this.soldDateFilter,
            this.lotSizeFilter,
            this.yearBuiltFilter,
            this.zipCodeFilter,
            this.marketFilter,
            this.subMarketFilter,
            this.tenancyFilter,
            this.cityFilter,
            // this.countyFilter,
            this.stateFilter,
            this.unitFilter,
            this.buildingStatusFilter,
            this.primaryUseFilter
        ]);
        // set query after all filters are added
        this.allFilterPanel.setInitialQuery(options.initialQuery);
    };
    /**
     * @param {?} options
     * @return {?}
     */
    AptoMapComponent.prototype.addLeaseFilterPanel = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        var _this = this;
        this.subscriptions.push(this.leaseFilterPanel.onQueryChange.subscribe(function (query) {
            _this.setHiddenFiltersCount();
            _this.onQueryChange.next({ query: _this.getFilterPanelQueries(), shouldUpdateHistory: true });
        }, this.logger.error.bind(this)));
        this.leaseFilterPanel.addMultiple([
            this.leasePropertyTypeFilter,
            // this.leaseSoldPriceFilter,
            this.leaseSqftFilter,
            this.leasePrimaryUseFilter,
            // this.leaseSoldDateFilter,
            this.leaseYearBuiltFilter,
            this.leaseBuildingClassFilter,
            this.leaseMarketFilter,
            this.leaseSubMarketFilter,
            this.leaseZipCodeFilter,
            this.leaseCityFilter,
            // this.leaseCountyFilter,
            this.leaseStateFilter
        ]);
        // set query after all filters are added
        this.leaseFilterPanel.setInitialQuery(options.initialQuery);
    };
    /**
     * @param {?} options
     * @return {?}
     */
    AptoMapComponent.prototype.addSaleFilterPanel = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        var _this = this;
        this.subscriptions.push(this.saleFilterPanel.onQueryChange.subscribe(function (query) {
            _this.setHiddenFiltersCount();
            _this.onQueryChange.next({ query: _this.getFilterPanelQueries(), shouldUpdateHistory: true });
        }, this.logger.error.bind(this)));
        this.saleFilterPanel.addMultiple([
            this.salePropertyTypeFilter,
            this.saleSoldPriceFilter,
            this.saleSoldDateFilter,
            this.saleSqftFilter,
            this.saleUnitFilter,
            this.salePrimaryUseFilter,
            this.saleTenancyFilter,
            this.saleYearBuiltFilter,
            this.saleLotSizeFilter,
            this.saleBuildingClassFilter,
            this.saleMarketFilter,
            this.saleSubMarketFilter,
            this.saleZipCodeFilter,
            this.saleCityFilter,
            // this.saleCountyFilter,
            this.saleStateFilter,
            this.saleCapRateFilter
        ]);
        // set query after all filters are added
        this.saleFilterPanel.setInitialQuery(options.initialQuery);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.polygonDrawStart = /**
     * @return {?}
     */
    function () {
        this.disabled = true;
        this.markerManager.hideMarkers();
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.polygonDrawEnd = /**
     * @return {?}
     */
    function () {
        this.disabled = false;
        this.markerManager.showMarkers();
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.polygonOpen = /**
     * @return {?}
     */
    function () {
        if (this.radiusFilter.active) {
            this.radiusFilter.reset();
        }
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.radiusOpen = /**
     * @return {?}
     */
    function () {
        if (this.polygonFilter.active) {
            this.polygonFilter.reset();
        }
    };
    /**
     * @param {?} options
     * @return {?}
     */
    AptoMapComponent.prototype.addMapToolbarFilters = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        var _this = this;
        this.subscriptions.push(this.mapToolbarFilterPanel.onQueryChange.subscribe(function (query) {
            _this.onQueryChange.next({ query: _this.getFilterPanelQueries(), shouldUpdateHistory: true });
        }, this.logger.error.bind(this)));
        this.mapToolbarFilterPanel.addMultiple([
            this.polygonFilter,
            this.radiusFilter
        ]);
        // set query after all filters are added
        this.mapToolbarFilterPanel.setInitialQuery(options.initialQuery);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.getFilterPanelQueries = /**
     * @return {?}
     */
    function () {
        return Object.assign({}, this.searchAndStatusFilterPanel.getCurrentQuery(), this.mapToolbarFilterPanel.getCurrentQuery(), this.getCurrentFilterPanel().getCurrentQuery() // only get the currently used panel
        );
    };
    /**
     * @param {?} query
     * @return {?}
     */
    AptoMapComponent.prototype.urlSafeQuery = /**
     * @param {?} query
     * @return {?}
     */
    function (query) {
        /** @type {?} */
        var stringifiedQuery = JSON.stringify(query);
        /** @type {?} */
        var base64EncodedQuery = btoa(stringifiedQuery);
        return base64EncodedQuery;
    };
    /**
     * @param {?} query
     * @return {?}
     */
    AptoMapComponent.prototype.decodeUrlSafeQuery = /**
     * @param {?} query
     * @return {?}
     */
    function (query) {
        if (query) {
            /** @type {?} */
            var stringifiedQuery = atob(query);
            return JSON.parse(stringifiedQuery);
        }
        return {};
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.triggerResize = /**
     * @return {?}
     */
    function () {
        return this.mapsService.triggerMapEvent('resize');
    };
    /**
     * @param {?} items
     * @param {?=} type
     * @return {?}
     */
    AptoMapComponent.prototype.addMarkers = /**
     * @param {?} items
     * @param {?=} type
     * @return {?}
     */
    function (items, type) {
        if (type === void 0) { type = MarkerType.GENERIC; }
        // don't add markers if the map is disabled
        if (this.disabled) {
            return;
        }
        this.removeOldMarkers(items.map(function (p) { return type + p.id.toString(); }));
        /** @type {?} */
        var markers = [];
        items.forEach(function (item) {
            if (item.latitude && item.latitude.toString().length > 2 &&
                item.longitude && item.longitude.toString().length > 2) {
                /** @type {?} */
                var marker = new Marker(type, item.latitude, item.longitude, item.id, item.iconClass);
                marker.data = item.data;
                markers.push(marker);
            }
        });
        // bulk add to manager
        this.markerManager.addMarkers(markers);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.getMarkerManager = /**
     * @return {?}
     */
    function () {
        return this.markerManager;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AptoMapComponent.prototype.toggleShowMore = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        this.showMore = !this.showMore;
        if (this.showMore) {
            this.analytics.logEvent('Mapping Click Show More Filters');
        }
        // slight delay so panel hides before setting more count
        setTimeout(function () {
            _this.setHiddenFiltersCount();
        }, 100);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.setHiddenFiltersCount = /**
     * @return {?}
     */
    function () {
        // count is 0 if showMore is true because the panel is fully visible
        if (this.showMore) {
            this.moreOptionsCount = 0;
            return;
        }
        // get the count of the current filter panel that has valid hidden filters
        this.moreOptionsCount = this.getCurrentFilterPanel().getValidHiddenFiltersCount();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AptoMapComponent.prototype.onWindowResizeHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onWindowResize.emit(event);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AptoMapComponent.prototype.onPlaceReset = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.getMarkerManager().deleteMarkersByType(MarkerType.PLACE);
        this.infoWindow.close();
    };
    /**
     * @param {?} place
     * @return {?}
     */
    AptoMapComponent.prototype.onPlaceChanged = /**
     * @param {?} place
     * @return {?}
     */
    function (place) {
        return __awaiter(this, void 0, void 0, function () {
            var latlng, marker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        latlng = place.geometry.location;
                        return [4 /*yield*/, this.mapsService.zoomAndPan(15, {
                                lat: latlng.lat(),
                                lng: latlng.lng()
                            })];
                    case 1:
                        _a.sent();
                        this.getMarkerManager().deleteMarkersByType(MarkerType.PLACE);
                        this.infoWindow.close();
                        marker = new Marker(MarkerType.PLACE, latlng.lat(), latlng.lng(), place.place_id, MarkerClassName.PLACE);
                        this.analytics.logEvent('Mapping Searched Place');
                        marker.data = place;
                        this.getMarkerManager().addMarker(marker);
                        marker.onHover.emit(marker);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.mapReady = /**
     * @return {?}
     */
    function () {
        this.setupMarkerClusterer();
        this.handleMapCenterChange();
        this.handleMapZoomChange();
        this.handleMarkerEvents();
        this.setupInfoWindow();
        this.setupListView();
    };
    /**
     * @param {?} item
     * @param {?=} field
     * @return {?}
     */
    AptoMapComponent.prototype.itemShown = /**
     * @param {?} item
     * @param {?=} field
     * @return {?}
     */
    function (item, field) {
        if (field === void 0) { field = '_id'; }
        return this.listView.itemShown(item, field);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    AptoMapComponent.prototype.addShownItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return this.listView.addShownItem(item);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    AptoMapComponent.prototype.setHistoryUniqueKey = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.queryHistory.setUniqueKey(key);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.setupListView = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // subscribe to search start/end so we can toggle the loading state of the list view and
        this.subscriptions.push(this.onSearchStart.subscribe(function () {
            // show loader when search starts
            // show loader when search starts
            _this.listView.showLoader = true;
            // remove selected properties when a new search runs
            // remove selected properties when a new search runs
            _this.listView.clearSelectedItems();
            if (!(/** @type {?} */ (_this.ref)).destroyed) {
                _this.ref.detectChanges();
            }
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.onSearchEnd.subscribe(function () {
            // hide loader when search ends
            // hide loader when search ends
            _this.listView.showLoader = false;
            if (!(/** @type {?} */ (_this.ref)).destroyed) {
                _this.ref.detectChanges();
            }
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.onWindowResize.pipe(debounceTime(500)).subscribe(function (event) {
            _this.setHiddenFiltersCount();
        }, this.logger.error.bind(this)));
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.setupInfoWindow = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var customInfoWindow, _a, factory, self;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = createCustomInfoWindow;
                        return [4 /*yield*/, this.mapsService.getMap()];
                    case 1:
                        customInfoWindow = _a.apply(void 0, [_b.sent()]);
                        factory = this.resolver.resolveComponentFactory(InfoWindow);
                        self = this;
                        // pass the factory the custom info window's dom node so it can inject the component into it
                        this.infoWindow = factory.create(this.injector, [], customInfoWindow.container).instance;
                        // initialize
                        this.infoWindow.initialize(customInfoWindow);
                        // close infowindow when search starts
                        this.subscriptions.push(this.onSearchStart.subscribe(function () {
                            /** @type {?} */
                            var contentName = self.infoWindow.getCurrentContentName();
                            if (contentName !== 'PlaceInfoWindow') {
                                self.infoWindow.close();
                            }
                        }, this.logger.error.bind(this)));
                        // disable map move events as the infowindow opens
                        this.subscriptions.push(this.infoWindow.onBeforeOpen.subscribe(function (marker) {
                            _this.disableMapMoveEvents = true;
                        }, this.logger.error.bind(this)));
                        // enable map move events once the infowindow is opended
                        this.subscriptions.push(this.infoWindow.onAfterOpen.subscribe(function (marker) {
                            _this.disableMapMoveEvents = false;
                        }, this.logger.error.bind(this)));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} idsToKeep
     * @return {?}
     */
    AptoMapComponent.prototype.removeOldMarkers = /**
     * @param {?} idsToKeep
     * @return {?}
     */
    function (idsToKeep) {
        /** @type {?} */
        var removeMarkers = [];
        this.markerManager.markers.forEach(function (marker, markerId) {
            if (marker.type === MarkerType.PROPERTY && !idsToKeep.includes(markerId)) {
                removeMarkers.push(marker);
            }
        });
        // bulk remove from manager
        this.markerManager.deleteMarkers(removeMarkers);
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.setupMarkerClusterer = /**
     * @return {?}
     */
    function () {
        this.markerManager.initClusterer({
            minimumClusterSize: 6,
            maxZoom: 18,
            styles: [{
                    height: 44,
                    textColor: 'white',
                    url: '/assets/img/m1-2x.png',
                    width: 44
                }]
        });
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.handleMarkerEvents = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.markerManager.onMarkerClick.subscribe(function (marker) {
            _this.onMarkerClick.emit(marker);
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.markerManager.onMarkerHover.subscribe(function (marker) {
            _this.onMarkerHover.emit(marker);
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.markerManager.onMarkerMouseOut.subscribe(function (marker) {
            _this.onMarkerMouseOut.emit(marker);
        }));
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.handleMapCenterChange = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.mapsService.subscribeToMapEvent('center_changed').pipe(debounceTime(ZOOM_CENTER_DEBOUNCE)).subscribe(function () {
            /** @type {?} */
            var center = _this.mapsService.getCenter();
            _this.latitude = center.lat();
            _this.longitude = center.lng();
            if (!_this.disableMapMoveEvents) {
                _this.zoomOrCenterChanged.emit();
                _this.onCenterChange.emit(/** @type {?} */ ({ lat: _this.latitude, lng: _this.longitude }));
            }
        }, this.logger.error.bind(this)));
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.handleMapZoomChange = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.mapsService.subscribeToMapEvent('zoom_changed').pipe(debounceTime(ZOOM_CENTER_DEBOUNCE)).subscribe(function () {
            /** @type {?} */
            var z = _this.mapsService.getZoom();
            _this.zoom = z;
            if (!_this.disableMapMoveEvents) {
                _this.onZoomChange.emit(z);
                _this.zoomOrCenterChanged.emit();
            }
        }, this.logger.error.bind(this)));
    };
    /**
     * @return {?}
     */
    AptoMapComponent.prototype.getCurrentFilterPanel = /**
     * @return {?}
     */
    function () {
        switch (this.currentStatusFilter) {
            case StatusFilterOption.LEASE:
                return this.leaseFilterPanel;
            case StatusFilterOption.SALE:
                return this.saleFilterPanel;
            case StatusFilterOption.ALL:
            default:
                return this.allFilterPanel;
        }
    };
    /**
     * @param {?} query
     * @return {?}
     */
    AptoMapComponent.prototype.setCurrentStatusFilter = /**
     * @param {?} query
     * @return {?}
     */
    function (query) {
        if (!query || !query.propertyStatus) {
            this.currentStatusFilter = StatusFilterOption.ALL;
        }
        else if (query.propertyStatus.value === 'all') {
            this.currentStatusFilter = StatusFilterOption.ALL;
        }
        else if (query.propertyStatus.value === 'leased' || query.propertyStatus.value === 'forLease') {
            this.currentStatusFilter = StatusFilterOption.LEASE;
        }
        else if (query.propertyStatus.value === 'sold' || query.propertyStatus.value === 'forSale') {
            this.currentStatusFilter = StatusFilterOption.SALE;
        }
        this.setHiddenFiltersCount();
    };
    AptoMapComponent.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--global-container\">\n    <div class=\"apto-map--lower-container\">\n        <am-list-view\n            class=\"apto-map--list-view\"\n            [items]=\"items\"\n            [totalResults]=\"totalResults\"\n            [resultLimit]=\"resultLimit\"\n            (onItemClick)=\"onItemClick.emit($event)\"\n            (onItemHover)=\"onItemHover.emit($event)\"\n            (onItemLeave)=\"onItemLeave.emit($event)\"\n            (onChangePage)=\"onChangePage.emit($event)\"\n            (onUpdatePropertyAddress)=\"onUpdatePropertyAddress.emit($event)\"\n            (onAddPropertyClick)=\"onAddPropertyClick.emit($event)\"\n            (onAddSelectedToList)=\"onAddSelectedToList.emit($event)\"\n            (onCallistMaxSelectionError)=\"onCallistMaxSelectionError.emit($event)\"\n            (onToggleListViewComplete)=\"onToggleListViewComplete.emit($event)\"\n            (onExportSelected)=\"onExportSelected.emit($event)\">\n        </am-list-view>\n        <div class=\"apto-map--googlemap-container\">\n            <!-- keep the min height on the map canvas so we can see the map when running test as we don't load css -->\n            <div\n                #googleCanvas\n                class=\"apto-map--googlemap-canvas\"\n                style=\"min-height:100px;\"></div>\n            <am-map-type [aptoMap]=\"aptoMapInstance\"></am-map-type>\n            <div class=\"apto-map--map-toolbar--components\">\n                <am-places\n                    actionsVisible=\"true\"\n                    (onPlaceReset)=\"onPlaceReset($event)\"\n                    (onPlaceChanged)=\"onPlaceChanged($event)\"></am-places>\n                <am-toggle-3d [aptoMap]=\"aptoMapInstance\"></am-toggle-3d>\n                <am-filter-panel\n                    #mapToobarFilterPanel>\n                    <am-polygon-filter #polygonFilter\n                                    name=\"Polygon\"\n                                    label=\"Polygon\"\n                                    (onDrawStart)=\"polygonDrawStart()\"\n                                    (onDrawEnd)=\"polygonDrawEnd()\"\n                                    (onOpen)=\"polygonOpen()\"></am-polygon-filter>\n                    <am-radius-filter #radiusFilter\n                                   name=\"Radius\"\n                                   label=\"Radius\"\n                                   (onOpen)=\"radiusOpen()\"></am-radius-filter>\n                </am-filter-panel>\n            </div>\n            <button\n                *ngIf=\"searchHereEnabled\"\n                class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link apto-map--btn--search-here\"\n                (click)=\"onSearchHere.emit($event)\">Search This Area</button>\n        </div>\n    </div>\n    <div [ngClass]=\"{ 'apto-map--filter-panel--expanded': showMore !== false, 'apto-map--filter-panel--errors': !searchFilterPanelIsValid || !allFilterPanelIsValid || !leaseFilterPanelIsValid || !saleFilterPanelIsValid }\"\n         class=\"apto-map--filter-panel--top\">\n        <am-filter-panel\n                #searchAndStatusFilterPanel\n                class=\"apto-map--filter-panel--search\"\n                (onValidation)=\"searchFilterPanelIsValid = $event\">\n            <am-search-filter\n                #searchFilter\n                name=\"textbox\"\n                placeholder=\"Find nearby\"\n                label=\"Search\"\n                showSearch=\"true\"\n                [showLoader]=\"showLoader\">\n            </am-search-filter>\n            <am-select-filter\n                #statusFilter\n                name=\"propertyStatus\"\n                label=\"Status\"\n                placeholder=\"Filter status\"\n                [items]=\"statusOptions\">\n            </am-select-filter>\n        </am-filter-panel>\n        <div class=\"apto-map--filter-panels\">\n            <am-filter-panel\n                #allFilterPanel\n                [ngClass]=\"{'apto-map--hidden': currentStatusFilter !== StatusFilterOption.ALL}\"\n                class=\"apto-map--filter-panel--all\"\n                (onValidation)=\"allFilterPanelIsValid = $event\">\n                <div class=\"apto-map--filter-panel--primary\">\n                    <am-multi-select-filter\n                        #propertyTypeFilter\n                        name=\"propertyType\"\n                        label=\"Property Type\"\n                        dropdownLabel=\"Property types\"\n                        [items]=\"propertyTypeOptions\">\n                    </am-multi-select-filter>\n                    <am-range-filter\n                        #sqftFilter\n                        name=\"sqft\"\n                        label=\"Square Footage\">\n                    </am-range-filter>\n                    <!-- <am-range-filter\n                        #soldPriceFilter\n                        name=\"soldPrice\"\n                        label=\"Sale Price\">\n                    </am-range-filter>\n                    <am-date-range-filter\n                        #soldDateFilter\n                        name=\"soldDate\"\n                        label=\"Sold Date\">\n                    </am-date-range-filter> -->\n                </div>\n                <div class=\"apto-map--filter-panel--secondary\">\n                    <div class=\"apto-map--filter-panel--filter-group\">\n                        <h4>Property</h4>\n                        <div class=\"apto-map--filter-panel--filter-group--filters\">\n                            <am-range-filter\n                                #lotSizeFilter\n                                name=\"lotSize\"\n                                label=\"Lot Size\">\n                            </am-range-filter>\n                            <am-range-filter\n                                #yearBuiltFilter\n                                name=\"yearBuilt\"\n                                label=\"Year Built\">\n                            </am-range-filter>\n                            <am-multi-select-filter\n                                #tenancyFilter\n                                name=\"tenancy\"\n                                label=\"Tenancy\"\n                                dropdownLabel=\"Tenancy\"\n                                [items]=\"tenancyOptions\">\n                            </am-multi-select-filter>\n                            <am-range-filter\n                                #unitFilter\n                                name=\"units\"\n                                label=\"Number Of Units\">\n                            </am-range-filter>\n                            <am-multi-select-filter\n                                    #primaryUseFilter\n                                    name=\"primaryUse\"\n                                    label=\"Property Use\"\n                                    dropdownLabel=\"Property Use\"\n                                    [items]=\"primaryUseOptions\">\n                            </am-multi-select-filter>\n                            <am-multi-select-filter\n                                    #buildingStatusFilter\n                                    name=\"buildingStatus\"\n                                    label=\"Building Status\"\n                                    dropdownLabel=\"Building Status\"\n                                    [items]=\"buildlingStatusOptions\">\n                            </am-multi-select-filter>\n                        </div>\n                    </div>\n                    <div class=\"apto-map--filter-panel--filter-group\">\n                        <h4>Market Area</h4>\n                        <div class=\"apto-map--filter-panel--filter-group--filters\">\n                            <am-multi-select-filter\n                                #marketFilter\n                                name=\"market\"\n                                label=\"Market\"\n                                dropdownLabel=\"Markets\"\n                                [items]=\"marketOptions\">\n                            </am-multi-select-filter>\n                            <am-multi-select-filter\n                                #subMarketFilter\n                                name=\"subMarket\"\n                                label=\"Submarket\"\n                                dropdownLabel=\"Submarkets\"\n                                [items]=\"subMarketOptions\">\n                            </am-multi-select-filter>\n                            <am-search-filter\n                                #zipCodeFilter\n                                name=\"zipCode\"\n                                placeholder=\"Zip Codes\"\n                                label=\"Zip\"\n                                split=\",\">\n                            </am-search-filter>\n                            <am-search-filter\n                                #cityFilter\n                                name=\"city\"\n                                placeholder=\"Cities\"\n                                label=\"City\"\n                                split=\",\">\n                            </am-search-filter>\n                            <!-- <am-search-filter\n                                #countyFilter\n                                name=\"county\"\n                                placeholder=\"Counties\"\n                                label=\"County\"\n                                split=\",\">\n                            </am-search-filter> -->\n                            <am-multi-select-filter\n                                #stateFilter\n                                name=\"state\"\n                                label=\"State\"\n                                dropdownLabel=\"States\"\n                                [items]=\"stateOptions\">\n                            </am-multi-select-filter>\n                        </div>\n                    </div>\n                </div>\n            </am-filter-panel>\n\n            <am-filter-panel\n                #leaseFilterPanel\n                [ngClass]=\"{'apto-map--hidden': currentStatusFilter !== StatusFilterOption.LEASE}\"\n                class=\"apto-map--filter-panel--lease\"\n                (onValidation)=\"leaseFilterPanelIsValid = $event\">\n                <div class=\"apto-map--filter-panel--primary\">\n                    <am-multi-select-filter\n                        #leasePropertyTypeFilter\n                        name=\"propertyType\"\n                        label=\"Property Type\"\n                        dropdownLabel=\"Property types\"\n                        [items]=\"propertyTypeOptions\">\n                    </am-multi-select-filter>\n                    <am-range-filter\n                        #leaseSqftFilter\n                        name=\"sqft\"\n                        label=\"Space Size\">\n                    </am-range-filter>\n                    <!-- <am-range-filter\n                        #leaseSoldPriceFilter\n                        name=\"soldPrice\"\n                        label=\"Lease Rate\">\n                    </am-range-filter>\n                    <am-date-range-filter\n                        #leaseSoldDateFilter\n                        name=\"soldDate\"\n                        label=\"Lease Date\">\n                    </am-date-range-filter> -->\n                </div>\n                <div class=\"apto-map--filter-panel--secondary\">\n                    <div class=\"apto-map--filter-panel--filter-group\">\n                        <h4>Property</h4>\n                        <div class=\"apto-map--filter-panel--filter-group--filters\">\n                            <am-multi-select-filter\n                                #leaseBuildingClassFilter\n                                name=\"buildingClass\"\n                                label=\"Building Class\"\n                                dropdownLabel=\"Building Classes\"\n                                [items]=\"buildingClassOptions\">\n                            </am-multi-select-filter>\n                            <am-range-filter\n                                #leaseYearBuiltFilter\n                                name=\"yearBuilt\"\n                                label=\"Year Built\">\n                            </am-range-filter>\n                            <am-multi-select-filter\n                                #leasePrimaryUseFilter\n                                name=\"primaryUse\"\n                                label=\"Space Use\"\n                                dropdownLabel=\"Space Use\"\n                                [items]=\"primaryUseOptions\">\n                            </am-multi-select-filter>\n                        </div>\n                    </div>\n                    <div class=\"apto-map--filter-panel--filter-group\">\n                        <h4>Market Area</h4>\n                        <div class=\"apto-map--filter-panel--filter-group--filters\">\n                            <am-multi-select-filter\n                                #leaseMarketFilter\n                                name=\"market\"\n                                label=\"Market\"\n                                dropdownLabel=\"Markets\"\n                                [items]=\"marketOptions\">\n                            </am-multi-select-filter>\n                            <am-multi-select-filter\n                                #leaseSubMarketFilter\n                                name=\"subMarket\"\n                                label=\"Submarket\"\n                                dropdownLabel=\"Submarkets\"\n                                [items]=\"subMarketOptions\">\n                            </am-multi-select-filter>\n                            <am-search-filter\n                                #leaseZipCodeFilter\n                                name=\"zipCode\"\n                                placeholder=\"Zip Codes\"\n                                label=\"Zip\"\n                                split=\",\">\n                            </am-search-filter>\n                            <am-search-filter\n                                #leaseCityFilter\n                                name=\"city\"\n                                placeholder=\"Cities\"\n                                label=\"City\"\n                                split=\",\">\n                            </am-search-filter>\n                            <!-- <am-search-filter\n                                #leaseCountyFilter\n                                name=\"county\"\n                                placeholder=\"Counties\"\n                                label=\"County\"\n                                split=\",\">\n                            </am-search-filter> -->\n                            <am-multi-select-filter\n                                #leaseStateFilter\n                                name=\"state\"\n                                label=\"State\"\n                                dropdownLabel=\"States\"\n                                [items]=\"stateOptions\">\n                            </am-multi-select-filter>\n                        </div>\n                    </div>\n                </div>\n            </am-filter-panel>\n\n            <am-filter-panel\n                #saleFilterPanel\n                [ngClass]=\"{'apto-map--hidden': currentStatusFilter !== StatusFilterOption.SALE}\"\n                class=\"apto-map--filter-panel--sale\"\n                (onValidation)=\"saleFilterPanelIsValid = $event\">\n                <div class=\"apto-map--filter-panel--primary\">\n                    <am-multi-select-filter\n                        #salePropertyTypeFilter\n                        name=\"propertyType\"\n                        label=\"Property Type\"\n                        dropdownLabel=\"Property Types\"\n                        [items]=\"propertyTypeOptions\">\n                    </am-multi-select-filter>\n                    <am-range-filter\n                        #saleSqftFilter\n                        name=\"sqft\"\n                        label=\"Total Building Size\">\n                    </am-range-filter>\n                    <am-range-filter\n                        #saleSoldPriceFilter\n                        name=\"soldPrice\"\n                        label=\"Sale Price\">\n                    </am-range-filter>\n                    <am-date-range-filter\n                        #saleSoldDateFilter\n                        name=\"soldDate\"\n                        label=\"Sale Date\">\n                    </am-date-range-filter>\n                </div>\n                <div class=\"apto-map--filter-panel--secondary\">\n                    <div class=\"apto-map--filter-panel--filter-group\">\n                        <h4>Property</h4>\n                        <div class=\"apto-map--filter-panel--filter-group--filters\">\n                            <am-range-filter\n                                #saleLotSizeFilter\n                                name=\"lotSize\"\n                                label=\"Lot Size\">\n                            </am-range-filter>\n                            <am-range-filter\n                                #saleUnitFilter\n                                name=\"units\"\n                                label=\"Number Of Units\">\n                            </am-range-filter>\n                            <am-multi-select-filter\n                                #saleBuildingClassFilter\n                                name=\"buildingClass\"\n                                label=\"Building Class\"\n                                dropdownLabel=\"Building Classes\"\n                                [items]=\"buildingClassOptions\">\n                            </am-multi-select-filter>\n                            <am-range-filter\n                                #saleYearBuiltFilter\n                                name=\"yearBuilt\"\n                                label=\"Year Built\">\n                            </am-range-filter>\n                            <am-range-filter\n                                #saleCapRateFilter\n                                name=\"capRate\"\n                                label=\"Cap Rate\">\n                            </am-range-filter>\n                            <am-multi-select-filter\n                                #salePrimaryUseFilter\n                                name=\"primaryUse\"\n                                label=\"Space Use\"\n                                dropdownLabel=\"Space Use\"\n                                [items]=\"primaryUseOptions\">\n                            </am-multi-select-filter>\n                            <am-multi-select-filter\n                                #saleTenancyFilter\n                                name=\"tenancy\"\n                                label=\"Tenancy\"\n                                dropdownLabel=\"Tenancy\"\n                                [items]=\"tenancyOptions\">\n                            </am-multi-select-filter>\n                        </div>\n                    </div>\n                    <div class=\"apto-map--filter-panel--filter-group\">\n                        <h4>Market Area</h4>\n                        <div class=\"apto-map--filter-panel--filter-group--filters\">\n                            <am-multi-select-filter\n                                #saleMarketFilter\n                                name=\"market\"\n                                label=\"Market\"\n                                dropdownLabel=\"Markets\"\n                                [items]=\"marketOptions\">\n                            </am-multi-select-filter>\n                            <am-multi-select-filter\n                                #saleSubMarketFilter\n                                name=\"subMarket\"\n                                label=\"Submarket\"\n                                dropdownLabel=\"Submarkets\"\n                                [items]=\"subMarketOptions\">\n                            </am-multi-select-filter>\n                            <am-search-filter\n                                #saleZipCodeFilter\n                                name=\"zipCode\"\n                                placeholder=\"Zip Codes\"\n                                label=\"Zip\"\n                                split=\",\">\n                            </am-search-filter>\n                            <am-search-filter\n                                #saleCityFilter\n                                name=\"city\"\n                                placeholder=\"Cities\"\n                                label=\"City\"\n                                split=\",\">\n                            </am-search-filter>\n                            <!-- <am-search-filter\n                                #saleCountyFilter\n                                name=\"county\"\n                                placeholder=\"Counties\"\n                                label=\"County\"\n                                split=\",\">\n                            </am-search-filter> -->\n                            <am-multi-select-filter\n                                #saleStateFilter\n                                name=\"state\"\n                                label=\"State\"\n                                dropdownLabel=\"States\"\n                                [items]=\"stateOptions\">\n                            </am-multi-select-filter>\n                        </div>\n                    </div>\n                </div>\n            </am-filter-panel>\n        </div>\n        <div class=\"apto-map--filter-button--controls\">\n            <button\n                class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link apto-map--filter-panel--reset-button\"\n                (click)=\"resetFilters()\"\n                *ngIf=\"clearFiltersEnabled\">\n                Clear\n            </button>\n            <button\n                (click)=\"toggleShowMore($event)\"\n                class=\"apto-map--btn apto-map--btn-upper apto-map--chevron--down apto-map--filter-panel--more-button\">\n                {{ showMore ? 'Less' : 'More' }}\n                <span\n                    *ngIf=\"!showMore && moreOptionsCount > 0\"\n                    class=\"apto-map--form-badge\"\n                    data-automation=\"apto-map--moreOptionsCount\">{{ moreOptionsCount }}</span>\n            </button>\n        </div>\n    </div>\n</div>\n\n\n",
                    selector: 'am-apto-map',
                    providers: [
                        GoogleMapsAPIService,
                        MarkerManager
                    ],
                    host: {
                        '(window:resize)': 'onWindowResizeHandler($event)'
                    }
                }] }
    ];
    /** @nocollapse */
    AptoMapComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: GoogleMapsAPIService },
        { type: MarkerManager },
        { type: ComponentFactoryResolver },
        { type: Injector },
        { type: Logger },
        { type: Analytics },
        { type: QueryHistory }
    ]; };
    AptoMapComponent.propDecorators = {
        googleCanvas: [{ type: ViewChild, args: ['googleCanvas',] }],
        searchAndStatusFilterPanel: [{ type: ViewChild, args: ['searchAndStatusFilterPanel',] }],
        searchFilter: [{ type: ViewChild, args: ['searchFilter',] }],
        statusFilter: [{ type: ViewChild, args: ['statusFilter',] }],
        mapToolbarFilterPanel: [{ type: ViewChild, args: ['mapToobarFilterPanel',] }],
        polygonFilter: [{ type: ViewChild, args: ['polygonFilter',] }],
        radiusFilter: [{ type: ViewChild, args: ['radiusFilter',] }],
        allFilterPanel: [{ type: ViewChild, args: ['allFilterPanel',] }],
        propertyTypeFilter: [{ type: ViewChild, args: ['propertyTypeFilter',] }],
        sqftFilter: [{ type: ViewChild, args: ['sqftFilter',] }],
        zipCodeFilter: [{ type: ViewChild, args: ['zipCodeFilter',] }],
        soldPriceFilter: [{ type: ViewChild, args: ['soldPriceFilter',] }],
        soldDateFilter: [{ type: ViewChild, args: ['soldDateFilter',] }],
        lotSizeFilter: [{ type: ViewChild, args: ['lotSizeFilter',] }],
        yearBuiltFilter: [{ type: ViewChild, args: ['yearBuiltFilter',] }],
        marketFilter: [{ type: ViewChild, args: ['marketFilter',] }],
        subMarketFilter: [{ type: ViewChild, args: ['subMarketFilter',] }],
        tenancyFilter: [{ type: ViewChild, args: ['tenancyFilter',] }],
        cityFilter: [{ type: ViewChild, args: ['cityFilter',] }],
        stateFilter: [{ type: ViewChild, args: ['stateFilter',] }],
        unitFilter: [{ type: ViewChild, args: ['unitFilter',] }],
        primaryUseFilter: [{ type: ViewChild, args: ['primaryUseFilter',] }],
        buildingStatusFilter: [{ type: ViewChild, args: ['buildingStatusFilter',] }],
        leaseFilterPanel: [{ type: ViewChild, args: ['leaseFilterPanel',] }],
        leasePropertyTypeFilter: [{ type: ViewChild, args: ['leasePropertyTypeFilter',] }],
        leaseSqftFilter: [{ type: ViewChild, args: ['leaseSqftFilter',] }],
        leaseYearBuiltFilter: [{ type: ViewChild, args: ['leaseYearBuiltFilter',] }],
        leaseZipCodeFilter: [{ type: ViewChild, args: ['leaseZipCodeFilter',] }],
        leaseCityFilter: [{ type: ViewChild, args: ['leaseCityFilter',] }],
        leaseStateFilter: [{ type: ViewChild, args: ['leaseStateFilter',] }],
        leaseMarketFilter: [{ type: ViewChild, args: ['leaseMarketFilter',] }],
        leaseSubMarketFilter: [{ type: ViewChild, args: ['leaseSubMarketFilter',] }],
        leaseBuildingClassFilter: [{ type: ViewChild, args: ['leaseBuildingClassFilter',] }],
        leasePrimaryUseFilter: [{ type: ViewChild, args: ['leasePrimaryUseFilter',] }],
        leaseSoldPriceFilter: [{ type: ViewChild, args: ['leaseSoldPriceFilter',] }],
        leaseSoldDateFilter: [{ type: ViewChild, args: ['leaseSoldDateFilter',] }],
        saleFilterPanel: [{ type: ViewChild, args: ['saleFilterPanel',] }],
        salePropertyTypeFilter: [{ type: ViewChild, args: ['salePropertyTypeFilter',] }],
        saleSoldPriceFilter: [{ type: ViewChild, args: ['saleSoldPriceFilter',] }],
        saleSoldDateFilter: [{ type: ViewChild, args: ['saleSoldDateFilter',] }],
        saleSqftFilter: [{ type: ViewChild, args: ['saleSqftFilter',] }],
        saleUnitFilter: [{ type: ViewChild, args: ['saleUnitFilter',] }],
        salePrimaryUseFilter: [{ type: ViewChild, args: ['salePrimaryUseFilter',] }],
        saleTenancyFilter: [{ type: ViewChild, args: ['saleTenancyFilter',] }],
        saleYearBuiltFilter: [{ type: ViewChild, args: ['saleYearBuiltFilter',] }],
        saleLotSizeFilter: [{ type: ViewChild, args: ['saleLotSizeFilter',] }],
        saleBuildingClassFilter: [{ type: ViewChild, args: ['saleBuildingClassFilter',] }],
        saleMarketFilter: [{ type: ViewChild, args: ['saleMarketFilter',] }],
        saleSubMarketFilter: [{ type: ViewChild, args: ['saleSubMarketFilter',] }],
        saleZipCodeFilter: [{ type: ViewChild, args: ['saleZipCodeFilter',] }],
        saleCityFilter: [{ type: ViewChild, args: ['saleCityFilter',] }],
        saleStateFilter: [{ type: ViewChild, args: ['saleStateFilter',] }],
        saleCapRateFilter: [{ type: ViewChild, args: ['saleCapRateFilter',] }],
        listView: [{ type: ViewChild, args: [ListView,] }],
        onWindowResize: [{ type: Output }],
        onCenterChange: [{ type: Output }],
        onZoomChange: [{ type: Output }],
        onMapBoundsChange: [{ type: Output }],
        onSearchStart: [{ type: Output }],
        onSearchEnd: [{ type: Output }],
        onSearchHere: [{ type: Output }],
        onMarkerClick: [{ type: Output }],
        onMarkerHover: [{ type: Output }],
        onMarkerMouseOut: [{ type: Output }],
        onItemClick: [{ type: Output }],
        onItemHover: [{ type: Output }],
        onItemLeave: [{ type: Output }],
        onChangePage: [{ type: Output }],
        onAddPropertyClick: [{ type: Output }],
        onAddSelectedToList: [{ type: Output }],
        onCallistMaxSelectionError: [{ type: Output }],
        onToggleListViewComplete: [{ type: Output }],
        onUpdatePropertyAddress: [{ type: Output }],
        onExportSelected: [{ type: Output }],
        onQueryChange: [{ type: Output }],
        items: [{ type: Input }],
        totalResults: [{ type: Input }],
        resultLimit: [{ type: Input }],
        clearFiltersEnabled: [{ type: Input }]
    };
    return AptoMapComponent;
}(BaseMap));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Spinner = /** @class */ (function () {
    function Spinner() {
    }
    Spinner.decorators = [
        { type: Component, args: [{
                    selector: 'am-spinner',
                    template: "<svg viewBox=\"0 0 64 64\">\n    <circle transform=\"translate(32,32)\" r=\"26\"></circle>\n</svg>\n"
                }] }
    ];
    return Spinner;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SharedMappingModule = /** @class */ (function () {
    function SharedMappingModule() {
    }
    SharedMappingModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        Spinner
                    ],
                    entryComponents: [
                        Spinner
                    ],
                    exports: [
                        Spinner
                    ]
                },] }
    ];
    return SharedMappingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$2 = moment_;
var DateField = /** @class */ (function () {
    function DateField() {
        this.onClearCalendar = new EventEmitter();
        this.onOpenCalendar = new EventEmitter();
        this.onSelectDate = new EventEmitter();
        this.required = false;
        this.currentDate = null;
        this.datepickerOptions = {
            dateFormat: 'mm/dd/yyyy',
            firstDayOfWeek: 'su',
            sunHighlight: false
        };
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    DateField.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    DateField.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.form.controls.hasOwnProperty(this.field)) {
            throw new Error("Field \"" + this.field + "\" does not exist on form.");
        }
        Object.assign(this.datepickerOptions, this.options);
        /** @type {?} */
        var defaultDate = moment$2(this.defaultDate);
        if (this.defaultDate && defaultDate.isValid()) {
            this.default = {
                year: defaultDate.year(),
                month: defaultDate.month() + 1,
                day: defaultDate.date()
            };
        }
        this.subscriptions.push(this.onOpenCalendar.subscribe(function () {
            _this.myDatePicker.openBtnClicked();
        }), this.onClearCalendar.subscribe(function (shouldEmitEvent) {
            if (shouldEmitEvent === void 0) { shouldEmitEvent = true; }
            _this.form.controls[_this.field].patchValue(null, { emitEvent: shouldEmitEvent });
            // really annoying but if we are resseting because we want to use query history
            // this will fire an event to update before we have cleared all the filters
            if (shouldEmitEvent) {
                _this.myDatePicker.clearDate();
            }
        }), this.onSelectDate.subscribe(function (date) {
            /** @type {?} */
            var newDate = _this.myDatePicker.jsDateToMyDate(date);
            _this.default = newDate;
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DateField.prototype.onInputChanged = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.value = event.value.trim();
        /** @type {?} */
        var date = moment$2(event.value);
        /** @type {?} */
        var regex = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/;
        if (event.value) {
            if (regex.test(event.value) && date.isValid()) {
                this.form.controls[this.field].patchValue({ date: date });
            }
            else {
                this.form.controls[this.field].patchValue({ date: event.value });
                this.form.controls[this.field].setErrors({ syntax: true });
            }
        }
        else {
            this.form.controls[this.field].patchValue(null);
        }
        this.form.controls[this.field].markAsDirty();
    };
    DateField.decorators = [
        { type: Component, args: [{
                    selector: 'am-date-field',
                    template: "<div class=\"apto-map--date-field\">\n    <label *ngIf=\"label\" stacked class=\"apto-map--date-label\" [attr.required]=\"required ? true : null\">{{ label }}</label>\n    <my-date-picker #myDatePicker\n                    [attr.name]=\"field\"\n                    [placeholder]=\"placeholder\"\n                    [selDate]=\"default\"\n                    [options]=\"datepickerOptions\"\n                    (inputFieldChanged)=\"onInputChanged($event)\"></my-date-picker>\n</div>\n"
                }] }
    ];
    DateField.propDecorators = {
        defaultDate: [{ type: Input }],
        form: [{ type: Input }],
        field: [{ type: Input }],
        label: [{ type: Input }],
        onClearCalendar: [{ type: Input }],
        onOpenCalendar: [{ type: Input }],
        onSelectDate: [{ type: Input }],
        options: [{ type: Input }],
        placeholder: [{ type: Input }],
        required: [{ type: Input }],
        myDatePicker: [{ type: ViewChild, args: ['myDatePicker',] }]
    };
    return DateField;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DateFieldModule = /** @class */ (function () {
    function DateFieldModule() {
    }
    DateFieldModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, ReactiveFormsModule, MyDatePickerModule],
                    declarations: [
                        DateField
                    ],
                    entryComponents: [
                        DateField
                    ],
                    exports: [
                        DateField
                    ]
                },] }
    ];
    return DateFieldModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FilterModule = /** @class */ (function () {
    function FilterModule() {
    }
    FilterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        DateFieldModule,
                        SharedMappingModule
                    ],
                    declarations: [
                        FilterPanel,
                        SearchFilter,
                        MultiSelectFilter,
                        PolygonFilter,
                        RadiusFilter,
                        RangeFilter,
                        DateRangeFilter,
                        SelectFilter
                    ],
                    entryComponents: [
                        SearchFilter,
                        MultiSelectFilter,
                        PolygonFilter,
                        RadiusFilter,
                        RangeFilter,
                        DateRangeFilter,
                        SelectFilter
                    ],
                    exports: [
                        FilterPanel,
                        SearchFilter,
                        MultiSelectFilter,
                        PolygonFilter,
                        RadiusFilter,
                        RangeFilter,
                        DateRangeFilter,
                        SelectFilter
                    ]
                },] }
    ];
    return FilterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var RecentQueryItem = /** @class */ (function () {
    function RecentQueryItem() {
        this.onSave = new EventEmitter();
    }
    /**
     * @param {?} query
     * @return {?}
     */
    RecentQueryItem.prototype.getSortedQuery = /**
     * @param {?} query
     * @return {?}
     */
    function (query) {
        /** @type {?} */
        var keys = Object.keys(query).sort();
        /** @type {?} */
        var sortedQuery = keys.map(function (k) { return query[k]; });
        return sortedQuery;
    };
    /**
     * @param {?} queryValue
     * @return {?}
     */
    RecentQueryItem.prototype.prettyQueryValue = /**
     * @param {?} queryValue
     * @return {?}
     */
    function (queryValue) {
        if (queryValue.value) {
            if (typeof queryValue.value === 'object' && queryValue.value.length) {
                /** @type {?} */
                var values = queryValue.value.map(function (v) { return v.label || v.value || v; }).join(':');
                return queryValue.label + ":" + values;
            }
            else {
                return queryValue.label + ":" + queryValue.value;
            }
        }
        else if (queryValue.min || queryValue.max) {
            /** @type {?} */
            var values = [];
            if (queryValue.min && queryValue.min.value) {
                values.push(queryValue.min.label + ":" + queryValue.min.value);
            }
            if (queryValue.max && queryValue.max.value) {
                values.push(queryValue.max.label + ":" + queryValue.max.value);
            }
            return values.join('\n');
        }
        else if (queryValue.startDate || queryValue.stopDate) {
            /** @type {?} */
            var values = [];
            if (queryValue.startDate && queryValue.startDate.value) {
                values.push(queryValue.startDate.label + ":" + queryValue.startDate.value);
            }
            if (queryValue.stopDate && queryValue.stopDate.value) {
                values.push(queryValue.stopDate.label + ":" + queryValue.stopDate.value);
            }
            return values.join('\n');
        }
    };
    /**
     * @param {?} ev
     * @return {?}
     */
    RecentQueryItem.prototype.onViewAll = /**
     * @param {?} ev
     * @return {?}
     */
    function (ev) {
        var e_1, _a;
        /** @type {?} */
        var hiddenElements = ev.target.parentElement.querySelectorAll('.apto-map--recent-query-item--hidden');
        try {
            // unhide list of query items
            for (var hiddenElements_1 = __values(hiddenElements), hiddenElements_1_1 = hiddenElements_1.next(); !hiddenElements_1_1.done; hiddenElements_1_1 = hiddenElements_1.next()) {
                var element = hiddenElements_1_1.value;
                element.classList.remove('apto-map--recent-query-item--hidden');
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (hiddenElements_1_1 && !hiddenElements_1_1.done && (_a = hiddenElements_1.return)) _a.call(hiddenElements_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // hide view all button
        ev.target.classList.add('apto-map--recent-query-item--hidden');
    };
    RecentQueryItem.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-mapping--list-view--history-item apto-mapping--list-view--history-item--border-bottom\">\n    <div>\n        <div class=\"apto-mapping--history-item--date\">\n            <strong>\n                {{ item.date.format('MMMM DD, YYYY &#183; hh:mma') }}\n            </strong>\n        </div>\n        <div class=\"apto-mapping--history-item--query\">\n            <div *ngFor=\"let query of getSortedQuery(item.query); let i = index;\"\n                  class=\"apto-mapping--history-item--query-value\"\n                  [ngClass]=\"{'apto-map--recent-query-item--hidden': i >= 2}\"\n                  [title]=\"prettyQueryValue(query)\">\n                  {{ prettyQueryValue(query) }}\n            </div>\n            <span class=\"apto-mapping--list-view--history-item--show-all apto-map--btn-link\"\n                  *ngIf=\"getSortedQuery(item.query).length > 2\"\n                  (click)=\"onViewAll($event); $event.stopPropagation()\">VIEW ALL {{ getSortedQuery(item.query).length }}</span>\n        </div>\n    </div>\n    <!-- <div class=\"apto-map--list-view--history--item--save apto-map--btn-link\"\n         (click)=\"onSave.emit(item); $event.stopPropagation()\">SAVE</div> -->\n    <div class=\"apto-map--list-view--history--item--border apto-map--chevron--right\"></div>\n</div>",
                    selector: 'am-recent-query-item'
                }] }
    ];
    /** @nocollapse */
    RecentQueryItem.ctorParameters = function () { return []; };
    RecentQueryItem.propDecorators = {
        item: [{ type: Input }],
        onSave: [{ type: Output }]
    };
    return RecentQueryItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PropertyItem = /** @class */ (function () {
    function PropertyItem() {
        this.onUpdatePropertyAddress = new EventEmitter();
    }
    /**
     * @param {?} price
     * @param {?} sqft
     * @return {?}
     */
    PropertyItem.prototype.getPricePerSqft = /**
     * @param {?} price
     * @param {?} sqft
     * @return {?}
     */
    function (price, sqft) {
        return (parseFloat(price) / parseFloat(sqft)).toFixed(2).toString();
    };
    /**
     * @return {?}
     */
    PropertyItem.prototype.getMarkerClass = /**
     * @return {?}
     */
    function () {
        if (this.property.forSale) {
            return this.property.internal ? MarkerClassName.ON_MARKET_INTERNAL : MarkerClassName.ON_MARKET;
        }
        if (this.property.recentlySold) {
            return this.property.internal ? MarkerClassName.OFF_MARKET_INTERNAL : MarkerClassName.OFF_MARKET;
        }
        return null;
    };
    /**
     * @param {?} n
     * @return {?}
     */
    PropertyItem.prototype.convertToNumber = /**
     * @param {?} n
     * @return {?}
     */
    function (n) {
        return parseFloat(n);
    };
    /**
     * @return {?}
     */
    PropertyItem.prototype.isMapped = /**
     * @return {?}
     */
    function () {
        return isPropertyMapped(this.property);
    };
    PropertyItem.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--property-item--marker\">\n    <span\n        *ngIf=\"isMapped()\"\n        class=\"apto-map--inline-block apto-map--marker\"\n        [ngClass]=\"getMarkerClass()\"></span>\n    <span\n        *ngIf=\"!isMapped()\"\n        class=\"apto-map--inline-block\"\n        data-automation=\"not-mapped\">\n        <i class=\"apto-map--icon-warning\"></i>\n        <small class=\"apto-map--block\">Not Mapped</small>\n    </span>\n</div>\n<div class=\"apto-map--property-item--details apto-map--property-item--border\">\n    <h5>\n        {{ property.name }}\n    </h5>\n    <address class=\"apto-map--muted\">\n        {{ property.street }} {{ property.city }}, {{ property.state }} {{ property.postalCode }}\n        <am-address-suggestion\n            *ngIf=\"!isMapped()\"\n            [suggestions]=\"property.addressSuggestions\"\n            [property]=\"property\"\n            (onUpdateAddress)=\"onUpdatePropertyAddress.emit($event)\"\n            ></am-address-suggestion>\n    </address>\n    <p class=\"apto-map--muted apto-map-property-item-price-details\">\n        <ng-container *ngIf=\"property.salePrice\">\n            <strong class=\"apto-map-property-item-price-details-item\">\n                {{ property.salePrice | currency:'USD':'symbol':'1.0-2' }}\n            </strong>\n        </ng-container>\n        <ng-container *ngIf=\"property.squareFootage\">\n            <strong class=\"apto-map-property-item-price-details-item\">\n                {{ property.squareFootage | number }} sqft\n            </strong>\n        </ng-container>\n        <ng-container *ngIf=\"property.squareFootage && property.salePrice\">\n            <strong class=\"apto-map-property-item-price-details-item\">\n                {{ convertToNumber(property.salePrice) / convertToNumber(property.squareFootage) | currency:'USD':'symbol':'1.0-2' }}/sqft\n            </strong>\n        </ng-container>\n    </p>\n</div>\n<div\n    *ngIf=\"property.defaultImageAttachmentId || property.daysOnMarket\"\n    class=\"apto-map--property-item--border apto-map--property-item--image\">\n    <am-spinner\n        *ngIf=\"property.defaultImageAttachmentId && !property.blobImageData\"\n        class=\"apto-map--spinner\"></am-spinner>\n    <img\n        *ngIf=\"property.blobImageData\"\n        [src]=\"property.blobImageData\"\n        alt=\"property photo\"\n        class=\"apto-map--responsive-image apto-map--image-loading apto-map--image-loaded\"\n        [ngClass]=\"{'apto-map--property-item--dom--image': property.daysOnMarket}\">\n    <span\n        *ngIf=\"property.daysOnMarket\"\n        class=\"apto-map--property-item--dom\">Listed {{ property.daysOnMarket }} day(s)</span>\n</div>\n<div class=\"apto-map--property-item--border apto-map--chevron--right\"></div>",
                    selector: 'am-property-item'
                }] }
    ];
    /** @nocollapse */
    PropertyItem.ctorParameters = function () { return []; };
    PropertyItem.propDecorators = {
        property: [{ type: Input }],
        onUpdatePropertyAddress: [{ type: Output }]
    };
    return PropertyItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ListRecentQuery = /** @class */ (function () {
    function ListRecentQuery(queryHistory, logger) {
        this.queryHistory = queryHistory;
        this.logger = logger;
        this.onSaveItem = new EventEmitter();
        this.onSelectHistory = new EventEmitter();
        this.items = [];
        this.shownItems = [];
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ListRecentQuery.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    ListRecentQuery.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.update();
        this.subscriptions.push(this.queryHistory.onChange.subscribe(function (item) { return _this.update(item); }, this.logger.error));
    };
    /**
     * @param {?=} item
     * @return {?}
     */
    ListRecentQuery.prototype.update = /**
     * @param {?=} item
     * @return {?}
     */
    function (item) {
        this.items = this.queryHistory.getHistory();
        if (item) {
            this.shownItems.unshift(item);
        }
    };
    /**
     * @param {?} historyItem
     * @return {?}
     */
    ListRecentQuery.prototype.onSelectHistoryItem = /**
     * @param {?} historyItem
     * @return {?}
     */
    function (historyItem) {
        this.queryHistory.onSelectHistory.next(historyItem);
        this.onSelectHistory.emit();
    };
    ListRecentQuery.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--list-items-content apto-mapping--list-recent-query\">\n    <div class=\"apto-map--list-items-content--header\">Showing {{items.length}} recent queries</div>\n    <ul *ngIf=\"items.length\"\n        class=\"apto-map--list-items-content--body apto-mapping--list-recent-query--items\">\n        <li *ngFor=\"let item of shownItems\"\n            (click)=\"onSelectHistoryItem(item);\">\n            <div class=\"apto-mapping--recent-query-icon\"></div>\n            <am-recent-query-item [item]=\"item\"\n                               (onSave)=\"onSaveItem.emit($event)\">\n            </am-recent-query-item>\n        </li>\n    </ul>\n    <div class=\"apto-map--list-items-content--footer\">\n        <am-list-pager\n            [items]=\"items\"\n            (onChangePage)=\"shownItems = $event\"></am-list-pager>\n    </div>\n</div>",
                    selector: 'am-list-recent-query'
                }] }
    ];
    /** @nocollapse */
    ListRecentQuery.ctorParameters = function () { return [
        { type: QueryHistory },
        { type: Logger }
    ]; };
    ListRecentQuery.propDecorators = {
        onSaveItem: [{ type: Output }],
        onSelectHistory: [{ type: Output }]
    };
    return ListRecentQuery;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ListPager = /** @class */ (function () {
    function ListPager() {
        this.items = [];
        this.resultLimit = 500;
        this.itemsPerPage = 20;
        this.onChangePage = new EventEmitter(true);
        this.shownItems = [];
        this.currentPage = 0;
    }
    /**
     * @return {?}
     */
    ListPager.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.changePage(0);
    };
    /**
     * @param {?} $changes
     * @return {?}
     */
    ListPager.prototype.ngOnChanges = /**
     * @param {?} $changes
     * @return {?}
     */
    function ($changes) {
        var _this = this;
        /** @type {?} */
        var hasChangesInShown = !this.shownItems.every(function (item) {
            return _this.items.find(function (i) {
                return i === item;
            });
        });
        // The shown items have invalid values so go to page 0
        if (hasChangesInShown) {
            this.changePage(0);
            // if there is a change in the full item list go to the current page but dont
            // necessarily blow away what they are looking at if its still valid.
        }
        else if ($changes["items"] &&
            $changes["items"].previousValue &&
            $changes["items"].previousValue.length !== $changes["items"].currentValue.length) {
            this.changePage(this.currentPage);
        }
    };
    /**
     * @param {?} page
     * @return {?}
     */
    ListPager.prototype.changePage = /**
     * @param {?} page
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        /** @type {?} */
        var start = this.currentPage * this.itemsPerPage;
        /** @type {?} */
        var end = start + this.itemsPerPage;
        this.shownItems = this.items.slice(start, end);
        this.onChangePage.emit(this.shownItems);
    };
    /**
     * @return {?}
     */
    ListPager.prototype.getPaging = /**
     * @return {?}
     */
    function () {
        return this.currentPage * this.itemsPerPage + 1 + " - " + (this.currentPage *
            this.itemsPerPage +
            this.shownItems.length);
    };
    ListPager.decorators = [
        { type: Component, args: [{
                    template: "<div *ngIf=\"items.length\"\n     class=\"apto-map--list-view--paging-controls\"\n     data-automation=\"apto-map-pager-controls\">\n    <button type=\"button\"\n            class=\"apto-map--btn  apto-map--btn-link\"\n            *ngIf=\"currentPage !== 0\"\n            (click)=\"changePage(currentPage - 1)\"\n            title=\"Previous page\"\n            data-automation=\"apto-map-pager-prev\"> &lt; </button>\n    <span data-automation=\"apto-map-pager-text\">\n        Showing results {{ getPaging() }}\n    </span>\n    <button type=\"button\"\n            class=\"apto-map--btn apto-map--btn-link\"\n            *ngIf=\"items.length > (currentPage * itemsPerPage + shownItems.length)\"\n            (click)=\"changePage(currentPage + 1)\"\n            title=\"Next page\"\n            data-automation=\"apto-map-pager-next\"> &gt; </button>\n</div>",
                    selector: 'am-list-pager'
                }] }
    ];
    /** @nocollapse */
    ListPager.ctorParameters = function () { return []; };
    ListPager.propDecorators = {
        items: [{ type: Input }],
        resultLimit: [{ type: Input }],
        itemsPerPage: [{ type: Input }],
        onChangePage: [{ type: Output }]
    };
    return ListPager;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var next_id = 1;
var Tooltip = /** @class */ (function () {
    function Tooltip(documentRef) {
        this.documentRef = documentRef;
        this.hoverDelay = 200;
        this.onItemHover = new EventEmitter();
        this.onItemLeave = new EventEmitter();
        this.onItemClick = new EventEmitter();
        this.visible = true;
        this.built = false;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    Tooltip.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var timeout;
        this.subscriptions.push(this.onItemHover.subscribe(function () {
            _this.visible = true;
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                _this.hoverHandler();
            }, _this.hoverDelay);
        }));
        this.subscriptions.push(this.onItemClick.subscribe(function () {
            if (timeout) {
                clearTimeout(timeout);
            }
            _this.clickHandler();
        }));
        this.subscriptions.push(this.onItemLeave.subscribe(function () {
            if (timeout) {
                clearTimeout(timeout);
            }
            _this.leaveHandler();
        }));
    };
    /**
     * @return {?}
     */
    Tooltip.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    Tooltip.prototype.buildElement = /**
     * @return {?}
     */
    function () {
        if (this.built) {
            return;
        }
        next_id += 1;
        this.tipId = "ng2-apto-map-tooltip-" + next_id;
        this.trigger.nativeElement.setAttribute('id', this.tipId);
        this.tip.nativeElement.setAttribute('aria-describedby', this.tipId);
        this.documentRef.getNativeDocument().body.appendChild(this.tip.nativeElement);
        this.built = true;
    };
    /**
     * @return {?}
     */
    Tooltip.prototype.clickHandler = /**
     * @return {?}
     */
    function () {
        this.hoverHandler();
    };
    /**
     * @return {?}
     */
    Tooltip.prototype.hoverHandler = /**
     * @return {?}
     */
    function () {
        if (!this.built) {
            this.buildElement();
        }
        if (!this.visible) {
            return;
        }
        this.tip.nativeElement.removeAttribute('hidden');
        /** @type {?} */
        var handleBounds = this.trigger.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var tipBounds = this.tip.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var x = (handleBounds.x + (handleBounds.width / 2)) - (tipBounds.width / 2);
        /** @type {?} */
        var y = handleBounds.y + handleBounds.height;
        /** @type {?} */
        var position = "translate3d(" + x + "px," + y + "px,0)";
        this.tip.nativeElement.style.transform = position;
    };
    /**
     * @return {?}
     */
    Tooltip.prototype.leaveHandler = /**
     * @return {?}
     */
    function () {
        this.visible = false;
        if (this.built) {
            this.tip.nativeElement.setAttribute('hidden', 'hidden');
        }
    };
    Tooltip.decorators = [
        { type: Component, args: [{
                    selector: 'am-tooltip',
                    template: "<div #tooltipTrigger\n     class=\"apto-map--tooltip--trigger\"\n     (mouseenter)=\"onItemHover.emit()\"\n     (mouseleave)=\"onItemLeave.emit()\"\n     (click)=\"onItemClick.emit()\">\n    <ng-content select=\"[amTooltipTrigger],am-tooltip-trigger\"></ng-content>\n</div>\n<div #tooltipContent\n     hidden=\"hidden\"\n     class=\"apto-map--tooltip\"\n     role=\"tooltip\">\n    <div class=\"apto-map--tooltip--inner\">\n        <ng-content select=\"[amTooltipContent],am-tooltip-content\"></ng-content>\n    </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    Tooltip.ctorParameters = function () { return [
        { type: DocumentRef }
    ]; };
    Tooltip.propDecorators = {
        hoverDelay: [{ type: Input }],
        onItemHover: [{ type: Output }],
        onItemLeave: [{ type: Output }],
        onItemClick: [{ type: Output }],
        tip: [{ type: ViewChild, args: ['tooltipContent',] }],
        trigger: [{ type: ViewChild, args: ['tooltipTrigger',] }]
    };
    return Tooltip;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TooltipTrigger = /** @class */ (function () {
    function TooltipTrigger() {
    }
    TooltipTrigger.decorators = [
        { type: Directive, args: [{
                    selector: '[amTooltipTrigger],am-tooltip-trigger'
                },] }
    ];
    return TooltipTrigger;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TooltipContent = /** @class */ (function () {
    function TooltipContent() {
    }
    TooltipContent.decorators = [
        { type: Directive, args: [{
                    selector: '[amTooltipContent],am-tooltip-content'
                },] }
    ];
    return TooltipContent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TooltipModule = /** @class */ (function () {
    function TooltipModule() {
    }
    TooltipModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        TooltipTrigger,
                        TooltipContent,
                        Tooltip
                    ],
                    exports: [
                        TooltipTrigger,
                        TooltipContent,
                        Tooltip
                    ],
                    providers: __spread(BROWSER_GLOBALS_PROVIDERS)
                },] }
    ];
    return TooltipModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ListModule = /** @class */ (function () {
    function ListModule() {
    }
    ListModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        TooltipModule,
                        SharedMappingModule
                    ],
                    declarations: [
                        ListView,
                        ListPager,
                        ListItems,
                        ListRecentQuery,
                        RecentQueryItem,
                        AddressSuggestion,
                        PropertyItem
                    ],
                    exports: [ListView]
                },] }
    ];
    return ListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MapType = /** @class */ (function () {
    function MapType(logger, analytics) {
        this.logger = logger;
        this.analytics = analytics;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    MapType.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    MapType.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.aptoMap.onMapReady.subscribe(function (map) {
            _this.init();
        }, this.logger.error));
    };
    /**
     * @param {?} e
     * @return {?}
     */
    MapType.prototype.onToggle = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (this.mapType === 'roadmap') {
            this.mapType = 'hybrid';
        }
        else {
            this.mapType = 'roadmap';
        }
        this.mapsService.setMapType(this.mapType);
        this.analytics.logEvent("Mapping Change Map Type To " + this.mapType);
    };
    /**
     * @return {?}
     */
    MapType.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.mapsService = this.aptoMap.getMapService();
        this.mapType = this.mapsService.getMapType();
        this.subscriptions.push(this.mapsService.subscribeToMapEvent('maptypeid_changed').subscribe(function () {
            _this.mapType = _this.mapsService.getMapType();
        }, this.logger.error));
    };
    MapType.decorators = [
        { type: Component, args: [{
                    selector: 'am-map-type',
                    template: "<div class=\"apto-map--map-type-component\">\n    <div class=\"apto-map--map-type{{mapType === 'roadmap' ? ' apto-map--map-type-hybrid': ''}}\">\n        <button class=\"apto-map--btn\" type=\"button\" (click)=\"onToggle($event)\" aria-label=\"Toggle map type\">\n            <span>{{mapType === 'roadmap' ? 'Satellite' : 'Map'}}</span>\n        </button>\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    MapType.ctorParameters = function () { return [
        { type: Logger },
        { type: Analytics }
    ]; };
    MapType.propDecorators = {
        aptoMap: [{ type: Input }]
    };
    return MapType;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AddMarkerOptions = /** @class */ (function () {
    function AddMarkerOptions() {
    }
    return AddMarkerOptions;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PlaceInfoWindow = /** @class */ (function () {
    function PlaceInfoWindow(config) {
        this.config = config;
        this.onCloseClick = new EventEmitter();
        this.onSearchNearPlace = new EventEmitter();
        this.onAddPlace = new EventEmitter();
    }
    /**
     * @param {?} marker
     * @return {?}
     */
    PlaceInfoWindow.prototype.init = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        this.marker = marker;
    };
    /**
     * @return {?}
     */
    PlaceInfoWindow.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} loc
     * @return {?}
     */
    PlaceInfoWindow.prototype.searchNearPlace = /**
     * @param {?} loc
     * @return {?}
     */
    function (loc) {
        this.onSearchNearPlace.emit(loc);
    };
    /**
     * @param {?} place
     * @return {?}
     */
    PlaceInfoWindow.prototype.addPlace = /**
     * @param {?} place
     * @return {?}
     */
    function (place) {
        this.onAddPlace.emit(place);
    };
    PlaceInfoWindow.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--place-info-window\">\n    <div class=\"apto-map--place-info-window--header\">\n        <button type=\"button\" class=\"apto-map--btn-close\" (click)=\"onCloseClick.emit()\"></button>\n        <h5>\n            {{ marker.data.name }}\n            <span class=\"apto-map--badge apto-map--badge--green\">POI</span>\n        </h5>\n    </div>\n    <div class=\"apto-map--place-info-window--content\">\n        <address class=\"apto-map--muted\">\n            {{ marker.data.formatted_address }}\n        </address>\n    </div>\n    <div *ngIf=\"config.addPropertyFromPlaceEnabled || config.searchNearPlaceEnabled\" class=\"apto-map--place-info-window--cta\">\n        <button\n            *ngIf=\"config.addPropertyFromPlaceEnabled\"\n            type=\"button\"\n            data-automation=\"apto-map-add-place\"\n            class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link\"\n            (click)=\"addPlace(marker.data)\">Add Property</button>\n        <button\n            *ngIf=\"config.searchNearPlaceEnabled\"\n            type=\"button\"\n            data-automation=\"apto-map-search-near-place\"\n            class=\"apto-map--btn apto-map--btn-upper apto-map--btn-link\"\n            (click)=\"searchNearPlace(marker.data.geometry.location)\">Search Near</button>\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    PlaceInfoWindow.ctorParameters = function () { return [
        { type: IConfiguration, decorators: [{ type: Inject, args: [IConfiguration,] }] }
    ]; };
    return PlaceInfoWindow;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Places = /** @class */ (function () {
    function Places(mapsService, ngZone, logger, ref) {
        this.mapsService = mapsService;
        this.ngZone = ngZone;
        this.logger = logger;
        this.ref = ref;
        this.active = false;
        this.actionsVisible = false;
        this.onPlaceChanged = new EventEmitter();
        this.onPlaceOpen = new EventEmitter();
        this.onPlaceClose = new EventEmitter();
        this.onPlaceReset = new EventEmitter();
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    Places.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.mapsService.onMapLoad.subscribe(function (map) {
            _this.initAutocompleter();
        }, this.logger.error));
    };
    /**
     * @return {?}
     */
    Places.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (e) { return e.unsubscribe(); });
        if (this.autocompleteEvent) {
            this.autocompleteEvent.remove();
        }
    };
    /**
     * @return {?}
     */
    Places.prototype.initAutocompleter = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.autocompleter = new google.maps.places.Autocomplete(this.autocompleteField.nativeElement);
        this.autocompleteEvent = this.autocompleter.addListener('place_changed', function () {
            _this.ngZone.run(function () {
                /** @type {?} */
                var place = _this.autocompleter.getPlace();
                _this.currentPlace = place;
                _this.active = true;
                _this.onPlaceChanged.emit(place);
            });
        });
    };
    /**
     * @return {?}
     */
    Places.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.active = false;
        this.currentPlace = null;
        this.autocompleteField.nativeElement.value = '';
        this.actionsVisible = false;
        if (!(/** @type {?} */ (this.ref)).destroyed) {
            this.ref.detectChanges();
        }
        this.onPlaceReset.emit();
    };
    /**
     * @return {?}
     */
    Places.prototype.onToggle = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.actionsVisible = !this.actionsVisible;
        this.active = this.currentPlace ? true : false;
        if (!this.actionsVisible) {
            this.onPlaceClose.emit();
        }
        else {
            this.onPlaceOpen.emit();
            setTimeout(function () {
                _this.autocompleteField.nativeElement.focus();
            }, 100);
        }
    };
    Places.decorators = [
        { type: Component, args: [{
                    selector: 'am-places',
                    template: "<div class=\"apto-map--drawing-tool--wrapper apto-map--places-component\">\n    <button title=\"Point of Interest Search\"\n            type=\"button\"\n            aria-label=\"Toggle Places\"\n            [ngClass]=\"{'apto-map--map-toolbar--control--active': active}\"\n            class=\"apto-map--btn apto-map--map-toolbar--control apto-map--map-toolbar--margin apto-map--places-toggle\"\n            (click)=\"onToggle()\">\n        <svg viewBox=\"0 0 24 24\">\n            <path d=\"M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z\"></path>\n        </svg>\n    </button>\n    <div\n        [ngClass]=\"{'apto-map--drawing-tool--actions-active': actionsVisible}\"\n        class=\"apto-map--drawing-tool--actions apto-map--places--controls\">\n            <input #placeAutocompleteField placeholder=\"Enter a location\" type=\"text\" class=\"apto-map--form-control apto-map--btn--no-right-radius\">\n            <button\n                type=\"button\"\n                *ngIf=\"currentPlace\"\n                class=\"apto-map--btn apto-map--drawing-tool--btn apto-map--btn--no-left-radius\"\n                data-automation=\"apto-map-places-remove\"\n                (click)=\"reset()\">Remove</button>\n    </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    Places.ctorParameters = function () { return [
        { type: GoogleMapsAPIService },
        { type: NgZone },
        { type: Logger },
        { type: ChangeDetectorRef }
    ]; };
    Places.propDecorators = {
        actionsVisible: [{ type: Input }],
        currentPlace: [{ type: Input }],
        onPlaceChanged: [{ type: Output }],
        onPlaceOpen: [{ type: Output }],
        onPlaceClose: [{ type: Output }],
        onPlaceReset: [{ type: Output }],
        autocompleteField: [{ type: ViewChild, args: ['placeAutocompleteField',] }]
    };
    return Places;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var PropertyInfoWindow = /** @class */ (function () {
    function PropertyInfoWindow() {
        this.onCloseClick = new EventEmitter();
    }
    /**
     * @param {?} marker
     * @return {?}
     */
    PropertyInfoWindow.prototype.init = /**
     * @param {?} marker
     * @return {?}
     */
    function (marker) {
        this.marker = marker;
    };
    /**
     * @return {?}
     */
    PropertyInfoWindow.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { };
    PropertyInfoWindow.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-map--property-info-window\">\n    <div class=\"apto-map--property-info-window--header\">\n        <h5>{{ marker.data.name }}</h5>\n    </div>\n    <div class=\"apto-map--property-info-window--content\">\n        <div>\n            <address class=\"apto-map--muted\">\n                {{ marker.data.street }} {{ marker.data.city }}, {{ marker.data.state }} {{ marker.data.postalCode }}\n            </address>\n            <p class=\"apto-map--muted apto-map-property-info-window-price-details\">\n                <ng-container *ngIf=\"marker.data.salePrice\">\n                    <strong class=\"apto-map-property-info-window-price-details-item\">\n                        {{ marker.data.salePrice | currency:'USD':'symbol':'1.0-2' }}\n                    </strong>\n                </ng-container>\n                <ng-container *ngIf=\"marker.data.squareFootage\">\n                    <span class=\"apto-map-property-info-window-price-details-item\">\n                        {{ marker.data.squareFootage | number }} sqft\n                    </span>\n                </ng-container>\n                <ng-container *ngIf=\"marker.data.squareFootage && marker.data.salePrice\">\n                    <span class=\"apto-map-property-info-window-price-details-item\">\n                        {{ +marker.data.salePrice / +marker.data.squareFootage | currency:'USD':'symbol':'1.0-2' }}/sqft\n                    </span>\n                </ng-container>\n            </p>\n        </div>\n        <div\n            *ngIf=\"marker.data.defaultImageAttachmentId || marker.data.daysOnMarket\"\n            class=\"apto-map--property-info-window--image\">\n            <am-spinner\n                *ngIf=\"marker.data.defaultImageAttachmentId && !marker.data.blobImageData\"\n                class=\"apto-map--spinner\"></am-spinner>\n            <img\n                *ngIf=\"marker.data.blobImageData\"\n                [src]=\"marker.data.blobImageData\"\n                alt=\"property photo\"\n                class=\"apto-map--responsive-image\"\n                [ngClass]=\"{'apto-map--property-info-window--dom--image': marker.data.daysOnMarket}\">\n            <span\n                *ngIf=\"marker.data.daysOnMarket\"\n                class=\"apto-map--property-info-window--dom\">Listed {{ marker.data.daysOnMarket }} day(s)</span>\n        </div>\n    </div>\n</div>\n"
                }] }
    ];
    return PropertyInfoWindow;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Geocoder = /** @class */ (function () {
    function Geocoder(logger) {
        this.logger = logger;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    Geocoder.prototype.geocode = /**
     * @param {?} request
     * @return {?}
     */
    function (request) {
        var _this = this;
        if (!this.geocoder) {
            this.geocoder = new google.maps.Geocoder();
        }
        return new Promise(function (resolve, reject) {
            _this.geocoder.geocode(request, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve({
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    });
                }
                reject({
                    message: "error geocoding address: " + request.address,
                    status: status
                });
            });
        });
    };
    /**
     * @param {?} items
     * @param {?=} type
     * @return {?}
     */
    Geocoder.prototype.bulkGeocode = /**
     * @param {?} items
     * @param {?=} type
     * @return {?}
     */
    function (items, type) {
        if (type === void 0) { type = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(items.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var result, err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.geocode({
                                                address: item.address
                                            })];
                                    case 1:
                                        result = _a.sent();
                                        item.latitude = result.lat;
                                        item.longitude = result.lng;
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        if (err_1.status &&
                                            err_1.status !== google.maps.GeocoderStatus.ZERO_RESULTS &&
                                            err_1.state !== google.maps.GeocoderStatus.UNKNOWN_ERROR) {
                                            this.logger.error("Mapping BulkGeocode Error: " + err_1.status + ", Message: " + (err_1.message || null));
                                        }
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, items];
                }
            });
        });
    };
    return Geocoder;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoSimpleMapComponent = /** @class */ (function (_super) {
    __extends(AptoSimpleMapComponent, _super);
    function AptoSimpleMapComponent(mapsService, markerManager, logger) {
        var _this = _super.call(this) || this;
        _this.mapsService = mapsService;
        _this.markerManager = markerManager;
        _this.logger = logger;
        // Map events
        _this.onMarkersAdded = new EventEmitter();
        // Marker Events
        _this.onMarkerClick = new EventEmitter();
        _this.onMarkerHover = new EventEmitter();
        _this.onMarkerMouseOut = new EventEmitter();
        _this.aptoMapInstance = _this;
        _this.subscriptions = [];
        return _this;
    }
    /**
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.initMap = /**
     * @return {?}
     */
    function () {
        this.geocoder = new Geocoder(this.logger);
        this.loadMap(this.googleCanvas);
    };
    /**
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
        this.markerManager.deleteAllMarkers();
    };
    /**
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.getMarkerManager = /**
     * @return {?}
     */
    function () {
        return this.markerManager;
    };
    /**
     * @param {?} items
     * @param {?=} type
     * @param {?=} removeOld
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.addMarkers = /**
     * @param {?} items
     * @param {?=} type
     * @param {?=} removeOld
     * @return {?}
     */
    function (items, type, removeOld) {
        if (type === void 0) { type = ''; }
        if (removeOld === void 0) { removeOld = true; }
        return __awaiter(this, void 0, void 0, function () {
            var markers, unGeocodedItems, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (removeOld) {
                            this.removeOldMarkersByType(items.map(function (p) { return type + p.id.toString(); }), type);
                        }
                        markers = [];
                        unGeocodedItems = [];
                        // figure out if there are any points that need geocoding
                        items.forEach(function (item) {
                            if (!item.latitude || item.latitude.toString().length < 3 ||
                                !item.longitude || item.longitude.toString().length < 3) {
                                unGeocodedItems.push(item);
                            }
                        });
                        if (!unGeocodedItems.length) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.geocoder.bulkGeocode(unGeocodedItems, type)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.logger.info(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        items.forEach(function (item) {
                            if (item.latitude && item.latitude.toString().length > 2 &&
                                item.longitude && item.longitude.toString().length > 2) {
                                /** @type {?} */
                                var marker = new Marker(type, item.latitude, item.longitude, item.id, item.iconClass);
                                marker.data = item.data;
                                markers.push(marker);
                            }
                        });
                        // bulk add to manager
                        this.markerManager.addMarkers(markers);
                        return [4 /*yield*/, this.zoomToFitMarkers(Array.from(this.markerManager.markers.values()))];
                    case 5:
                        _a.sent();
                        this.onMarkersAdded.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.mapReady = /**
     * @return {?}
     */
    function () {
        this.setupMarkerClusterer();
        this.handleMarkerEvents();
    };
    /**
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.setupMarkerClusterer = /**
     * @return {?}
     */
    function () {
        this.markerManager.initClusterer({
            minimumClusterSize: 6,
            maxZoom: 18,
            styles: [{
                    height: 44,
                    textColor: 'white',
                    url: '/assets/img/m1-2x.png',
                    width: 44
                }]
        });
    };
    /**
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.handleMarkerEvents = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.markerManager.onMarkerClick.subscribe(function (marker) {
            _this.onMarkerClick.emit(marker);
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.markerManager.onMarkerHover.subscribe(function (marker) {
            _this.onMarkerHover.emit(marker);
        }, this.logger.error.bind(this)));
        this.subscriptions.push(this.markerManager.onMarkerMouseOut.subscribe(function (marker) {
            _this.onMarkerMouseOut.emit(marker);
        }));
    };
    /**
     * @param {?} idsToKeep
     * @param {?=} type
     * @return {?}
     */
    AptoSimpleMapComponent.prototype.removeOldMarkersByType = /**
     * @param {?} idsToKeep
     * @param {?=} type
     * @return {?}
     */
    function (idsToKeep, type) {
        if (type === void 0) { type = ''; }
        /** @type {?} */
        var removeMarkers = [];
        this.markerManager.markers.forEach(function (marker, markerId) {
            if (!idsToKeep.includes(markerId) && (type === '' || (type !== '' && marker.type === type))) {
                removeMarkers.push(marker);
            }
        });
        // bulk remove from manager
        this.markerManager.deleteMarkers(removeMarkers);
    };
    AptoSimpleMapComponent.decorators = [
        { type: Component, args: [{
                    template: "<div class=\"apto-simple-map-wrapper\">\n    <div #simpleMapGoogleCanvas\n        class=\"apto-simple-map--googlemap-canvas\"\n        style=\"min-height:100px;\"></div>\n    <am-map-type [aptoMap]=\"aptoMapInstance\"></am-map-type>\n    <div class=\"apto-map--map-toolbar--components\">\n        <am-toggle-3d [aptoMap]=\"aptoMapInstance\"></am-toggle-3d>\n    </div>\n</div>",
                    selector: 'am-apto-simple-map',
                    providers: [
                        GoogleMapsAPIService,
                        MarkerManager
                    ]
                }] }
    ];
    /** @nocollapse */
    AptoSimpleMapComponent.ctorParameters = function () { return [
        { type: GoogleMapsAPIService },
        { type: MarkerManager },
        { type: Logger }
    ]; };
    AptoSimpleMapComponent.propDecorators = {
        googleCanvas: [{ type: ViewChild, args: ['simpleMapGoogleCanvas',] }],
        onMarkersAdded: [{ type: Output }],
        onMarkerClick: [{ type: Output }],
        onMarkerHover: [{ type: Output }],
        onMarkerMouseOut: [{ type: Output }]
    };
    return AptoSimpleMapComponent;
}(BaseMap));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
var StaticImageFormats = {
    'JPEG': 0,
    'GIF': 1,
    'PNG': 2,
};
StaticImageFormats[StaticImageFormats['JPEG']] = 'JPEG';
StaticImageFormats[StaticImageFormats['GIF']] = 'GIF';
StaticImageFormats[StaticImageFormats['PNG']] = 'PNG';
/** @enum {number} */
var StaticImageMapTypes = {
    'roadmap': 0,
    'satellite': 1,
    'hybrid': 2,
    'terrain': 3,
};
StaticImageMapTypes[StaticImageMapTypes['roadmap']] = 'roadmap';
StaticImageMapTypes[StaticImageMapTypes['satellite']] = 'satellite';
StaticImageMapTypes[StaticImageMapTypes['hybrid']] = 'hybrid';
StaticImageMapTypes[StaticImageMapTypes['terrain']] = 'terrain';
var AptoStaticMapComponent = /** @class */ (function () {
    function AptoStaticMapComponent(config, http, ref) {
        this.config = config;
        this.http = http;
        this.ref = ref;
        this.size = '2500x2500';
        this.format = StaticImageFormats.JPEG;
        this.type = StaticImageMapTypes.hybrid;
        this.zoom = 17;
        this.scale = 2;
        this.onMapLoaded = new EventEmitter();
        this.staticMapLoaded = false;
    }
    /**
     * @return {?}
     */
    AptoStaticMapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getMap();
    };
    /**
     * @param {?} e
     * @return {?}
     */
    AptoStaticMapComponent.prototype.ngOnChanges = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e["markers"]) {
            this.staticMapLoaded = false;
            this.getMap();
        }
    };
    /**
     * @return {?}
     */
    AptoStaticMapComponent.prototype.getMap = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var params = [];
        // set default center/zoom if the map is missing center and markers
        if (!this.center && !this.markers) {
            this.center = '-98.35,39.5';
            this.zoom = 6;
        }
        if (this.center) {
            params.push("center=" + this.center);
        }
        if (this.markers && Array.isArray(this.markers)) {
            this.markers.forEach(function (m) {
                params.push("markers=" + m);
            });
        }
        else if (this.markers) {
            params.push("markers=" + this.markers);
        }
        params.push("size=" + this.size);
        params.push("type=" + this.type.toString());
        params.push("zoom=" + this.zoom);
        params.push("scale=" + this.scale);
        /** @type {?} */
        var url = this.config.google.staticMapUrl + "?" + encodeURI(params.join('&'));
        this.getUrlFromMappingAPI(url).subscribe(function (data) {
            _this.mapURL = data;
            if (!(/** @type {?} */ (_this.ref)).destroyed) {
                _this.ref.detectChanges();
            }
        }, function (error) {
            _this.onImageError(error);
        });
    };
    /**
     * @param {?} url
     * @return {?}
     */
    AptoStaticMapComponent.prototype.getUrlFromMappingAPI = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (!url.includes('://')) {
            throw new Error('Mapping API Static Map URL missing');
        }
        return this.http.get(url, {
            responseType: 'text',
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AptoStaticMapComponent.prototype.onImageLoad = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.staticMapLoaded = true;
        this.onMapLoaded.emit();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AptoStaticMapComponent.prototype.onImageError = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.mapURL =
            'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
        this.onImageLoad(null);
        this.onMapLoaded.error(event);
    };
    AptoStaticMapComponent.decorators = [
        { type: Component, args: [{
                    template: "<div\n    class=\"apto-map--static-map\"\n    [ngClass]=\"{'apto-map--static-map-loaded': staticMapLoaded}\">\n    <img\n        *ngIf=\"mapURL\"\n        [src]=\"mapURL\"\n        alt=\"map\"\n        data-automation=\"static-map-img\"\n        (load)=\"onImageLoad($event)\"\n        (error)=\"onImageError($event)\">\n    <am-spinner\n        *ngIf=\"!staticMapLoaded\"\n        class=\"apto-map--spinner\">\n    </am-spinner>\n</div>",
                    selector: 'am-apto-static-map'
                }] }
    ];
    /** @nocollapse */
    AptoStaticMapComponent.ctorParameters = function () { return [
        { type: IConfiguration, decorators: [{ type: Inject, args: [IConfiguration,] }] },
        { type: HttpClient },
        { type: ChangeDetectorRef }
    ]; };
    AptoStaticMapComponent.propDecorators = {
        size: [{ type: Input }],
        format: [{ type: Input }],
        type: [{ type: Input }],
        zoom: [{ type: Input }],
        center: [{ type: Input }],
        scale: [{ type: Input }],
        markers: [{ type: Input }],
        onMapLoaded: [{ type: Output }]
    };
    return AptoStaticMapComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Toggle3d = /** @class */ (function () {
    function Toggle3d(logger, analytics) {
        this.logger = logger;
        this.analytics = analytics;
        this.tilt = 0;
        this.degrees = 0;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    Toggle3d.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * @return {?}
     */
    Toggle3d.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscriptions.push(this.aptoMap.onMapReady.subscribe(function () {
            _this.init();
        }, this.logger.error));
    };
    /**
     * @param {?} e
     * @return {?}
     */
    Toggle3d.prototype.onToggle = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.stopPropagation();
        if (this.tilt > 0) {
            this.tilt = 0;
        }
        else {
            this.tilt = 45;
        }
        this.mapsService.setTilt(this.tilt);
        this.analytics.logEvent("Mapping Tilt Map To " + this.tilt);
    };
    /**
     * @param {?} e
     * @param {?} deg
     * @return {?}
     */
    Toggle3d.prototype.onHeadingChange = /**
     * @param {?} e
     * @param {?} deg
     * @return {?}
     */
    function (e, deg) {
        e.stopPropagation();
        this.degrees = deg;
        this.mapsService.setHeading(this.degrees);
        this.analytics.logEvent('Mapping Change Heading');
    };
    /**
     * @return {?}
     */
    Toggle3d.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.mapsService = this.aptoMap.getMapService();
        this.tilt = this.mapsService.getTilt();
        this.zoom = this.mapsService.getZoom();
        this.mapType = this.mapsService.getMapType();
        this.subscriptions.push(this.mapsService.subscribeToMapEvent('maptypeid_changed').subscribe(function () {
            _this.mapType = _this.mapsService.getMapType();
        }, this.logger.error));
        this.subscriptions.push(this.mapsService.subscribeToMapEvent('zoom_changed').subscribe(function () {
            _this.zoom = _this.mapsService.getZoom();
        }, this.logger.error));
        this.subscriptions.push(this.mapsService.subscribeToMapEvent('tilt_changed').subscribe(function () {
            _this.tilt = _this.mapsService.getTilt();
        }, this.logger.error));
    };
    Toggle3d.decorators = [
        { type: Component, args: [{
                    selector: 'am-toggle-3d',
                    template: "<div *ngIf=\"zoom > 17 && mapType === 'hybrid'\" class=\"apto-map--toggle-3d-component\">\n    <div *ngIf=\"tilt > 0\" class=\"apto-map--heading-control apto-map--map-toolbar--margin\">\n        <div class=\"apto-map--heading-control--content\">\n            <div class=\"apto-map--heading-control--compass apto-map--heading-control--compass--{{degrees}}\">\n                <div class=\"apto-map--heading-control--compass--pointer\"></div>\n            </div>\n            <button class=\"apto-map--btn apto-map--heading-control--north\" (click)=\"onHeadingChange($event, 0)\" aria-label=\"Set heading to North\"></button>\n            <button class=\"apto-map--btn apto-map--heading-control--south\" (click)=\"onHeadingChange($event, 180)\" aria-label=\"Set heading to South\"></button>\n            <button class=\"apto-map--btn apto-map--heading-control--east\" (click)=\"onHeadingChange($event, 90)\" aria-label=\"Set heading to East\"></button>\n            <button class=\"apto-map--btn apto-map--heading-control--west\" (click)=\"onHeadingChange($event, 270)\" aria-label=\"Set heading to West\"></button>\n        </div>\n    </div>\n    <button type=\"button\"\n            aria-label=\"Toggle map tilt\"\n            class=\"apto-map--btn apto-map--map-toolbar--control apto-map--map-toolbar--margin apto-map--map-2d-3d-control\"\n            (click)=\"onToggle($event)\">{{tilt > 0 ? '2D' : '3D'}}</button>\n</div>"
                }] }
    ];
    /** @nocollapse */
    Toggle3d.ctorParameters = function () { return [
        { type: Logger },
        { type: Analytics }
    ]; };
    Toggle3d.propDecorators = {
        aptoMap: [{ type: Input }]
    };
    return Toggle3d;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var GoogleMapsLoader = /** @class */ (function (_super) {
    __extends(GoogleMapsLoader, _super);
    function GoogleMapsLoader(config, windowRef, documentRef) {
        var _this = _super.call(this) || this;
        _this.windowRef = windowRef;
        _this.documentRef = documentRef;
        _this.config = config || {};
        return _this;
    }
    /**
     * @return {?}
     */
    GoogleMapsLoader.prototype.load = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.scriptLoadingPromise) {
            return this.scriptLoadingPromise;
        }
        // return promise if google maps is already loaded
        if (typeof google === 'object' && typeof google.maps === 'object') {
            return new Promise(function (resolve, reject) {
                resolve();
            });
        }
        /** @type {?} */
        var callbackName = 'AptoGmapsLoadedCallback';
        /** @type {?} */
        var script = this.documentRef.getNativeDocument().createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = this.getMapSrc(callbackName);
        this.scriptLoadingPromise = new Promise(function (resolve, reject) {
            (/** @type {?} */ (_this.windowRef.getNativeWindow()))[callbackName] = function () {
                resolve();
            };
            script.onerror = function (error) {
                reject(error);
            };
        });
        this.documentRef.getNativeDocument().body.appendChild(script);
        return this.scriptLoadingPromise;
    };
    /**
     * @param {?} callback
     * @return {?}
     */
    GoogleMapsLoader.prototype.getMapSrc = /**
     * @param {?} callback
     * @return {?}
     */
    function (callback) {
        /** @type {?} */
        var jsUrlBase = "https://maps.google.com/maps/api/js";
        /** @type {?} */
        var jsUrlCallback = "callback=" + callback;
        /** @type {?} */
        var jsLibraries = "libraries=places,geometry";
        /** @type {?} */
        var version = "v=3.33";
        /** @type {?} */
        var url = jsUrlBase + "?" + jsUrlCallback + "&" + jsLibraries + "&" + version;
        if (this.config.google && this.config.google.clientId) {
            url = url + "&client=" + this.config.google.clientId;
        }
        else if (this.config.google && this.config.google.apiKey) {
            url = url + "&key=" + this.config.google.apiKey;
        }
        return url;
    };
    GoogleMapsLoader.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    GoogleMapsLoader.ctorParameters = function () { return [
        { type: IConfiguration, decorators: [{ type: Inject, args: [IConfiguration,] }] },
        { type: WindowRef },
        { type: DocumentRef }
    ]; };
    return GoogleMapsLoader;
}(MapAPILoader));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AptoMappingModule = /** @class */ (function () {
    function AptoMappingModule() {
    }
    /**
     * @param {?} appConfig
     * @return {?}
     */
    AptoMappingModule.forRoot = /**
     * @param {?} appConfig
     * @return {?}
     */
    function (appConfig) {
        return {
            ngModule: AptoMappingModule,
            providers: __spread(BROWSER_GLOBALS_PROVIDERS, [
                { provide: MapAPILoader, useClass: GoogleMapsLoader },
                { provide: IConfiguration, useClass: appConfig },
                Logger
            ])
        };
    };
    AptoMappingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        SharedMappingModule,
                        FilterModule,
                        TooltipModule,
                        ListModule,
                        HttpClientModule
                    ],
                    declarations: [
                        AptoMapComponent,
                        AptoSimpleMapComponent,
                        AptoStaticMapComponent,
                        PropertyInfoWindow,
                        PlaceInfoWindow,
                        InfoWindow,
                        Toggle3d,
                        MapType,
                        Places
                    ],
                    entryComponents: [
                        PropertyInfoWindow,
                        PlaceInfoWindow,
                        InfoWindow
                    ],
                    exports: [
                        AptoMapComponent,
                        AptoSimpleMapComponent,
                        AptoStaticMapComponent
                    ],
                    providers: [
                        Analytics,
                        QueryHistory
                    ]
                },] }
    ];
    return AptoMappingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { AptoMappingModule, SharedMappingModule, AddressSuggestion, AptoMapComponent, FilterPanel, FilterModule, BaseFilter, DateRangeFilter, MultiSelectFilter, Polygon, PolygonFilter, Circle, RadiusFilter, RangeFilter, SelectItem, SelectFilter, SearchFilter, InfoWindowPosition, createCustomInfoWindow, InfoWindow, ExportTypes, ExportLayouts, ListModule, RecentQueryItem, PropertyItem, listViewTabs, ListView, ListRecentQuery, ListPager, ListItems, MapType, AddMarkerOptions, MARKER_POSITION, createCustomMarker, MarkerType, MarkerClassName, Marker, MarkerManager, PlaceInfoWindow, Places, PropertyInfoWindow, AptoSimpleMapComponent, Spinner, StaticImageFormats, StaticImageMapTypes, AptoStaticMapComponent, Toggle3d, Tooltip, TooltipModule, TooltipTrigger, TooltipContent, MapAPILoader, Logger, IConfiguration, Analytics, GoogleMapsLoader, Geocoder, GoogleMapsAPIService, QueryHistory, BaseMap, isPropertyMapped, getUsersCoordinates, parseWKT, getWKTFromMVCArray, getWKTFromLatLngLiteraltArray, WindowRef, DocumentRef, BROWSER_GLOBALS_PROVIDERS, DateField as ɵb, DateFieldModule as ɵa };

//# sourceMappingURL=ng2-apto-map.js.map